// 1	Company
// 2	Area
// 3	City
// 4	Pincode
// 5	Unit Type
// 6	Menu Category
// 7	Gender
// 8	Age-Range
// 9	Item Type
// 10	Product Categories
// 11	Neck Type
// 12	Brand
// 13	Market
// 14	Yarn Group
// 15	Yarn
// 16	Fabric Group
// 17	Fabric
// 18	Dia
// 19	Sleeve Type
// 20	Type of Fit
// 21	Part
// 22	Unit Of Measurement
// 23	Program Type
// 24	Type of Order
// 25	Type of Packing
// 26	Designation
// 27	User Category
// 28	Department
// 29	Country
// 30	Employee Type
// 31	Party Category
// 32	Role in the Team
// 33	Roles
// 34	Section
// 35	Product Type
// 36	HSN Category
// 37	Bank Name
// 38	Accessories Type
// 39	Currency Code
// 40	Currency Conversion Type
// 41	Program Category
/*
    GET_BY_ID => It takes the Id of the previous module and pass that id in current module Example company master id will be passed into unit master get api to fetch unit master grid data

    GETID / GET_SINGLE_USER_ID (are same) => It fetch data of that particular user to which you want to update it.
*/

// propertyList from company master
const CompanyPropertyListById = {
    PropertyList: '/api/TblCompanyMaster/GetPropertyList'
};
//State master List
const StateMasterList = {
    StateList: '/api/TblStateMaster/GetStateMaster'
};

//Bank master List
const BankMasterList = {
    BankList: '/api/TblBankMaster/GetAllTblBankMaster'
};

const settings = {
    GETAllSettings: '/api/TbllpSetting/GetAlllpSetting',
    GETBYIDSettings: '/api/TbllpSetting/GetlpSetting',
    POSTSettings: '/api/TbllpSetting/CreatelpSetting',
    PATCHSettings: '/api/TbllpSetting/UpdatelpSetting',
    DELETESettings: '/api/TbllpSetting/DeletelpSetting',
}

const auditTrial = {
    GETAuditLogByUser: '/api/TblAuditLog/GetTblAuditLogByUserSearch'
}

const AccountMaster = {
    GetAllTblAccountMaster: '/api/TblAccountMaster/GetAllTblAccountMaster',
    CreateAccountMaster: '/api/TblAccountMaster/CreateAccountMaster',
    GetTblAccountMaster: '/api/TblAccountMaster/GetTblAccountMaster',
    UpdateAccountMaster: '/api/TblAccountMaster/UpdateAccountMaster',
    DeleteAccountMaster: "/api/TblAccountMaster/DeleteAccountMaster"
}

const propertyMaster = {
    propertyMasterGET: '/api/TblPropertyMaster/GetTblPropertyMaster',
    propertyMasterPOST: '/api/TblPropertyMaster/CreatePropertyMaster',
    propertyMasterGETID: '/api/TblPropertyMaster/GetPropertyMaster',
    propertyMasterPATCH: '/api/TblPropertyMaster/UpdatePropertyMaster',
    propertyMasterDELETE: '/api/TblPropertyMaster/DeletePropertyMaster',
    propertyMasterGET_SET_ACTIVE: '/api/TblProperties/ToggleTblPropertiesIsActive'
};

const feedbackAnyWhere = {
    feedbackAnyWherePOST: '/api/TblFeedbackDetail/CreateTblFeedbackDetailFromAnywhere'
};

const productionReport = {
    GetReports_Production: '/api/TblReports/GetReports_Production',
    GetReports_Program: '/api/TblReports/GetReports_StyleMovementStatus',
}

const property = {
    propertyGET: '/api/TblProperties/GetProperties',
    propertyMasterListGET: '/api/TblProperties/GetPropertyMasterList',
    propertyPOST: '/api/TblProperties/CreateTblProperties',
    formatPOST: '/api/TblFormatMaster/CreateFormatMaster',
    appLogoutPOST: '/api/Authenticate/Logout/Logout',
    appForceLogoutPOST: '/api/Authenticate/ForceLogout/ForceLogout',
    stylePOST: '/api/TblStyleMasterBasic/CreateTblStyleMasterBasic?FldStyleName=',
    propertyGETID: '/api/TblProperties/GetProperties',
    propertyPATCH: '/api/TblProperties/UpdateProperties',
    propertyDELETE: '/api/TblProperties/DeleteProperties'
};

const areaMaster = {
    areaMasterGET: '/api/TblAreaMaster/GetAreaMaster',
    areaMasterPOST: '/api/TblAreaMaster/CreateTblAreaMaster',
    areaMasterGETID: '/api/TblAreaMaster/GetAreaMaster',
    areaMasterPATCH: '/api/TblAreaMaster/UpdateAreaMaster',
    areaMasterDELETE: '/api/TblAreaMaster/DeleteAreaMaster'
};

const companyMaster = {
    companyMasterGET: '/api/TblCompanyMaster/GetCompanyMasters',
    companyMasterPOST: '/api/TblCompanyMaster/CreateTblCompanyMaster',
    companyMasterGETID: '/api/TblCompanyMaster/GetCompanyMaster',
    companyMasterPATCH: '/api/TblCompanyMaster/UpdateCompanyMaster',
    companyMasterDELETE: '/api/TblCompanyMaster/DeleteCompanyMaster',
    companyMasterImageUpload: '/api/TblImagesInfo/CreateTblImagesInfoDirectUpload',
    companyMasterGetLogo: '/api/TblCompanyMaster/getCompanyLogo'
};

const unitMaster = {
    unitMasterGET: '/api/TblUnitMaster/GetAllTblUnitMaster',
    unitMasterGET_BY_ID: '/api/TblUnitMaster/GetTblUnitListofCompany',
    unitMasterPOST: '/api/TblUnitMaster/CreateTblUnitMaster',
    unitMasterGETID: '/api/TblUnitMaster/GetUnitMaster',
    unitMasterPATCH: '/api/TblUnitMaster/UpdateUnitMaster',
    unitMasterDELETE: '/api/TblUnitMaster/DeleteUnitMaster'
};

const partyMaster = {
    partyMasterGET: '/api/TblPartyMaster/GetAllTblPartyMaster',
    partyMasterPANFileGET: '/api/TblPartyMaster/GetGSTorPANImage',
    partyMasterPOST: '/api/TblPartyMaster/CreateTblPartyMaster',
    partyMasterGETID: '/api/TblPartyMaster/GetTblPartyMaster',
    partyMasterXLSX: '/api/TblPartyDetail/CreateTblPartyDetailBulk',
    partyMasterPATCH: '/api/TblPartyMaster/UpdateTblPartyMaster',
    partyMasterDELETE: '/api/TblPartyMaster/DeleteTblPartyMaster',
    partyMasterGET_SET_ACTIVE: '/api/TblPartyMaster/ToggleTblPartyIsActive',
    ActiveSendVerifyOTP: '/api/TblMail/SendApprovalOTP_ActiveParty',
    partyMasterGETALL: '/api/TblPartyMaster/GetTblPartyMasterAll'
};
// GetTblPartyDetailofParty?FldFKParty=12
const partyDetails = {
    partyDetailsGET: '/api/TblPartyDetail/GetAllTblPartyDetail',
    partyDetailsGET_BY_ID: '/api/TblPartyDetail/GetTblPartyDetailofParty',
    partyDetailsPOST: '/api/TblPartyDetail/CreateTblPartyDetail',
    partyDetailsGETID: '/api/TblPartyDetail/GetTblPartyDetail',
    partyDetailsPATCH: '/api/TblPartyDetail/UpdateTblPartyDetail',
    partyDetailsDELETE: '/api/TblPartyDetail/DeleteTblPartyDetail'
};

const vendorMaster = {
    vendorMasterGET: '/api/TblVendorManagement/GetallTblVendorManagement',
    vendorMasterGETBYUSER: '/api/TblVendorManagement/GetTblVendorByUserId',
    vendorMasterGETBYID: '/api/TblVendorManagement/GetTblVendor',
    vendorMasterPATCH: '/api/TblVendorManagement/UpdateTblVendorManagement',
    RejectVendor: '/api/TblPartyDetail/RejectVendor',
    AcceptVendor: '/api/TblPartyDetail/AcceptVendorByApprovalStatus',
    GetVendorImage: '/api/TblVendorManagement/GetVendorImage',
    VendorImageUpload: '/api/TblVendorManagement/VendorImageUpload',
    updateImg: '/api/TblVendorManagement/UpdateVendorImageUpload',
    VendorGSTorPANInPartyDetails: "/api/TblVendorManagement/VendorGSTorPANInPartyDetails",
    ApproveWithoutOverwrite: '/api/TblVendorManagement/ApproveWithoutOverwrite',
    ApproveWithOverwrite: '/api/TblVendorManagement/ApproveWithOverwrite',
    ApproveVendor: '/api/TblVendorManagement/ApproveVendor',
    vendorMasterPendingGET: '/api/TblVendorManagement/GetAllPendingVendors',
    GetTblUserHeader: '/api/TblUserHeader/GetTblUserHeader'
}

const styleInProgress = {
    getStyleInProgress: '/api/TblReports/GetReports_StyleInProgress'
}


const colorMaster = {
    colorMasterGET: '/api/TblColourMaster/GetColourMaster',
    colorMasterPOST: '/api/TblColourMaster/CreateTblColourMaster',
    colorMasterGETID: '/api/TblColourMaster/GetColourMaster',
    colorMasterPATCH: '/api/TblColourMaster/UpdateColourMaster',
    colorMasterDelete: '/api/TblColourMaster/DeleteColourMaster'
};

const colorDetails = {
    colorDetailsGET: '/api/TblColourDetail/GetColourDetail',
    colorDetailsGET1: '/api/TblColourDetail/GetAllColourDetail',
    // colorListStyleShade: '/api/TblColourDetail/GetColourListStyle',
    colorListStyleShade: '/api/TblColourDetail/GetColourListStyleRqrmnt',
    colorDetailsGET_BY_ID: '/api/TblColourDetail/GetColourList',
    colorDetailsPOST: '/api/TblColourDetail/CreateTblColourDetail',
    colorDetailsGETID: '/api/TblColourDetail/GetColourDetail',
    colorDetailsPATCH: '/api/TblColourDetail/UpdateTblColourDetail',
    colorDetailsDELETE: '/api/TblColourDetail/DeleteColourDetail'
};

const userAccessInfo = {
    userAccessInfoGET: '/api/TblUserAccessInfo/GetTblUserAccessInfo'
};
const userAccessInfoDetails = {
    userAccessInfoDetailsGET: '/api/TblUserAccessDetail/GetUserAccessDetail'
};

const teamMaster = {
    teamMasterGET: '/api/TblTeamMaster/GetAllTblTeamMaster',
    checkCompanyGET: '/api/TblCompanyMaster/GetCompanyMasters',
    fetchTeamLeadGET: '/api/TblEmployee/GetAllTblEmployee',
    teamMasterPOST: '/api/TblTeamMaster/CreateTblTeamMaster',
    teamMasterGETID: '/api/TblTeamMaster/GetTblTeamMaster',
    teamMasterPATCH: '/api/TblTeamMaster/UpdateTblTeamMaster',
    teamMasterDELETE: '/api/TblTeamMaster/DeleteTblTeamMaster'
};



const pimMaster = {
    pimMasterGET: '/api/TblPIM/GetTblPIMs',
    pimMasterPoDcGET: '/api/TblPIM/GetForAdvancePaymentsPIM',
    //pimPendingMasterGET: '/api/TblPIM/GetTblPIMPendingInvoices',
    pimPendingMasterGET: '/api/TblPIM/GetTblPIMPendingDCsDashboard',
    pimMasterSupplierGET: '/api/TblPIM/GetSupplierPIM',
    pimMasterProgramGET: '/api/TblPIM/GetProgramPIM',
    pimProgramGET: '/api/TblPIM/GetTblPIMs',
    pimMasterPOST: '/api/TblPIM/CreateTblPIM',

    // /api/TblPIM/CreateTblPIM
    generateMultiplePimMasterPOST: '/api/TblPIM/GenerateMultipleTblPIMs',
    pimMasterGETID: '/api/TblPIM/GetTblPIM',
    pimMasterPATCH: '/api/TblPIM/UpdateTblPIM',
    pimMasterDELETE: '/api/TblPIM/DeleteTblPIM',
    getMaterGridData: 'api/TblPIM/GetInwardData_ProgramWise'
};
const teamDetails = {
    teamDetailsGET_BY_ID: '/api/TblTeamDetail/GetTeamDetailsList',
    teamDetailsPOST: '/api/TblTeamDetail/CreateTblTeamDetail',
    teamDetailsGETID: '/api/TblTeamDetail/GetTblTeamDetail',
    teamDetailsPATCH: '/api/TblTeamDetail/UpdateTblTeamDetail',
    teamDetailsDELETE: '/api/TblTeamDetail/DeleteTblTeamDetail'
};

const pimDetails = {
    pimDetailsGET_BY_ID: '/api/TblPIMDetail/GetTblPIMDetailsByPIMID',
    pimDetailsGET: '/api/TblPIMDetail/GetTblPIMDetails',
    pimDetailsInwardNoGET: '/api/TblPIM/GetTblPIMPendingDCsInwardNo',
    pimDetailsPOST: '/api/TblPIMDetail/CreateTblPIMDetail',
    pimDetailsGETID: '/api/TblPIMDetail/GetTblPIMDetail',
    pimDetailsPATCH: '/api/TblPIMDetail/UpdateTblPIMDetail',
    pimDetailsDELETE: '/api/TblPIMDetail/DeleteTblPIMDetail'
};

const brandMaster = {
    brandMasterGET: '/api/TblBrandMaster/GetTblBrandMasters',
    buyerNameGET: '/api/TblBrandMaster/GetLoadBuyerUsingFilter',
    brandMasterPOST: '/api/TblBrandMaster/CreateTblBrandMaster',
    brandMasterGETID: '/api/TblBrandMaster/GetTblBrandMaster',
    brandMasterPATCH: '/api/TblBrandMaster/UpdateTblBrandMaster',
    brandMasterDELETE: '/api/TblBrandMaster/DeleteTblBrandMaster'
};

const hsnMaster = {
    hsnMasterGET: '/api/TblHSNMaster/GetAllTblHSNMaster',
    hsnMasterPOST: '/api/TblHSNMaster/CreateHSNMaster',
    hsnMasterGETID: '/api/TblHSNMaster/GetTblHSNMaster',
    hsnMasterPATCH: '/api/TblHSNMaster/UpdateHSNMaster',
    hsnMasterDELETE: '/api/TblHSNMaster/DeleteHSNMaster'
};

const bankMaster = {
    bankMasterGET: '/api/TblBankMaster/GetAllTblBankMaster',
    bankMasterPOST: '/api/TblBankMaster/CreateBankMaster',
    bankMasterGETID: '/api/TblBankMaster/GetTblBankMaster',
    bankMasterPATCH: '/api/TblBankMaster/UpdateBankMaster',
    bankMasterDELETE: '/api/TblBankMaster/DeleteBankMaster'
};

const roles = {
    rolesGET: '/api/TblRoles/GetRoles',
    rolesPOST: '/api/TblRoles/CreateTblRoles',
    rolesGETID: '/api/TblRoles/GetRoles',
    rolesPATCH: '/api/TblRoles/UpdateRoles',
    rolesDELETE: '/api/TblRoles/DeleteRoles'
};

const employee = {
    employeeGET: '/api/TblEmployee/GetAllTblEmployee',
    employeePOST: '/api/TblEmployee/CreateEmployee',
    employeeGET_SINGLE_USER_ID: '/api/TblEmployee/GetTblEmployee',
    employeePATCH: '/api/TblEmployee/UpdateEmployee',
    employeeDELETE: '/api/TblEmployee/DeleteEmployee'
};

const priceMapping = {
    priceMappingGET: '/api/TblAccessoriesPriceMapping/GetAllTblAccessoriesPriceMapping',
    priceMappingPOST: '/api/TblAccessoriesPriceMapping/CreateAccessoriesPriceMapping',
    priceMappingGET_SINGLE_USER_ID: '/api/TblAccessoriesPriceMapping/GetTblAccessoriesPriceMapping',
    priceMappingPATCH: '/api/TblAccessoriesPriceMapping/UpdateAccessoriesPriceMapping',
    priceMappingDELETE: '/api/TblAccessoriesPriceMapping/DeleteAccessoriesPriceMapping'
};

const filter = {
    filterGET: '/api/TblFilter/GetTblFilters',
    filterPOST: '/api/TblFilter/CreateTblFilter',
    filterGET_SINGLE_USER_ID: '/api/TblFilter/GetTblFilter',
    filterPATCH: '/api/TblFilter/UpdateTblFilter',
    filterDELETE: '/api/TblFilter/DeleteTblFilter'
};

const stock = {
    stockGET: '/api/TblStock/GetTblStocks'
};

const accessoriesMaster = {
    accessoriesMasterGET: '/api/TblAccessoriesMaster/GetAllTblAccessoriesMaster',
    accessoriesMasterPOST: '/api/TblAccessoriesMaster/CreateAccessoriesMaster',
    accessoriesMasterGET_SINGLE_USER_ID: '/api/TblAccessoriesMaster/GetTblAccessoriesMaster',
    accessoriesMasterPATCH: '/api/TblAccessoriesMaster/UpdateAccessoriesMaster',
    accessoriesMasterDELETE: '/api/TblAccessoriesMaster/DeleteAccessoriesMaster',
    accessoriesMasterForSizes: '/api/TblStylePrepAccessoriesMaster/GetSizeInfoByStyleMaster'
};

// const barcodeMaster = {
//     barcodeMasterGET: '/api/TblBarcodeTemplate/GetAllTblBarcodeDashBoards',
//     // barcodeMasterGET: '/api/TblBarcodeTemplate/GetAllTblBarcodeTemplates',
//     barcodeMasterSalesOrderGET: '/api/TblBarcodeTemplate/GetTblStyleForBarcode',
//     // barcodeMasterSalesOrderGET: '/api/TblSaleOrderDetail/GetAllTblSaleOrderDetail',
//     // barcodeMasterSalesOrderGET: '/api/TblSaleOrder/GetAllTblSaleOrderByUnit',
//     barcodeMasterStyleMasterGET: '/api/TblSaleOrderDetail/GetSaleOrderDetailsList',
//     barcodeCopyFromStyleGET: '/api/TblBarcodeTemplate/GetTblStyleForBarcode_CopyFrom',
//     barcodeMasterPOST: '/api/TblBarcodeTemplate/GetTblColorSizeByStyleID',
//     barcodeMasterSalesOrderPOST: '/api/TblBarcodeTemplate/GetTblBarcodeOnSaleOrder',
//     barcodeMasterGridPOST: '/api/TblBarcodeTemplate/CreateTblBarcodeTemplates',
//     // barcodeMasterGridPOST: '/api/TblBarcodeTemplate/CreateTblBarcodeTemplate',
//     barcodeMasterGET_SINGLE_USER_ID: '/api/TblBarcodeTemplate/GetTblBCTemplateByTemplateID',
//     barcodeMasterPATCH: '/api/TblBarcodeTemplate/updateTblBarcodeTemplateByTemplateID',
//     barcodeMasterDELETE: '/api/TblBarcodeTemplate/deleteTblBarcodeTemplateByTemplateID'
// };


const barcodeMaster = {
    barcodeMasterGET: '/api/TblBarcodeTemplate/GetAllTblBarcodeDashBoards',

    programCatMasterGET: '/api/TblProgramCatalogue/GetAllTblProgramCatalogues',

    // barcodeMasterGET: '/api/TblBarcodeTemplate/GetAllTblBarcodeTemplates',
    barcodeMasterSalesOrderGET: '/api/TblBarcodeTemplate/GetTblStyleForBarcode',
    programCatGET: '/api/TblProgramCatalogue/GetTblStyleForProgramCatalogue',

    // barcodeMasterSalesOrderGET: '/api/TblSaleOrderDetail/GetAllTblSaleOrderDetail',
    // barcodeMasterSalesOrderGET: '/api/TblSaleOrder/GetAllTblSaleOrderByUnit',
    barcodeMasterStyleMasterGET: '/api/TblSaleOrderDetail/GetSaleOrderDetailsList',
    barcodeCopyFromStyleGET: '/api/TblBarcodeTemplate/GetTblStyleForBarcode_CopyFrom',
    barcodeMasterPOST: '/api/TblBarcodeTemplate/GetTblColorSizeByStyleID',
    barcodeMasterSalesOrderPOST: '/api/TblBarcodeTemplate/GetTblBarcodeOnSaleOrder',

    barcodeMasterGridPOST: '/api/TblBarcodeTemplate/CreateTblBarcodeTemplates',


    barcodeMasterProgramCatPOST: '/api/TblProgramCatalogue/CreateTblProgramCatalogue',


    // barcodeMasterGridPOST: '/api/TblBarcodeTemplate/CreateTblBarcodeTemplate',
    barcodeMasterGET_SINGLE_USER_ID: '/api/TblBarcodeTemplate/GetTblBCTemplateByTemplateID',

    programCatMasterGET_SINGLE_USER_ID: '/api/TblProgramCatalogue/GetTblBCTemplateByTemplateID',
    programCatGET_PRINT: '/api/TblProgramCatalogue/GetPrintTblProgramCatalogue',

    barcodeMasterPATCH: '/api/TblBarcodeTemplate/updateTblBarcodeTemplateByTemplateID',
    barcodeMasterDELETE: '/api/TblBarcodeTemplate/deleteTblBarcodeTemplateByTemplateID',
    programCatMasterDELETE: '/api/TblProgramCatalogue/DeleteTblProgramCatalogueByTemplateID'

};

const accessoriesUsage = {
    accessoriesUsageGET: '/api/TblAccessoriesUsage/GetAllTblAccessoriesUsage',
    accessoriesUsagePOST: '/api/TblAccessoriesUsage/CreateAccessoriesUsage',
    accessoriesUsagePATCH: '/api/TblAccessoriesUsage/UpdateAccessoriesUsage',
    accessoriesUsageDELETE: '/api/TblAccessoriesUsage/DeleteAccessoriesUsage'
};

const sizeInfo = {
    sizeInfoGET: '/api/TblSizeInfo/GetAllTblSizeInfo',
    sizeInfoPOST: '/api/TblSizeInfo/CreateSizeInfo',
    sizeInfoGET_SINGLE_USER_ID: '/api/TblSizeInfo/GetTblSizeInfo',
    sizeInfoPATCH: '/api/TblSizeInfo/UpdateSizeInfo',
    sizeInfoMesPost: '/api/TblSizeInfo/CreateSizeMeasurement',
    sizeInfoMesGet: '/api/TblSizeInfo/GetSizeMeasurementByInfo',
    sizeInfoMesSingleGet: '/api/TblSizeInfo/GetSizeMeasurementById',
    sizeInfoMesDelete: '/api/TblSizeInfo/DeleteSizeMeasurement',
    sizeInfoMesUpdate: '/api/TblSizeInfo/UpdateSizeMeasurement',
    sizeInfoDELETE: '/api/TblSizeInfo/DeleteSizeInfo',
    sizeinfoInvoiceGET: '/api/TblSizeInfo/GetTblStylePrepSizeInfoPrint'
};

const sizeRatio = {
    sizeRatioGET_BY_ID: '/api/TblSizeRatio/GetSizeRatioList',
    sizeRatioPOST: '/api/TblSizeRatio/CreateSizeRatio',
    sizeRatioGET_SINGLE_USER_ID: '/api/TblSizeRatio/GetTblSizeRatio',
    sizeRatioPATCH: '/api/TblSizeRatio/UpdateSizeRatio',
    sizeRatioDELETE: '/api/TblSizeRatio/DeleteSizeRatio'
};

const product = {
    productGET: '/api/TblProductList/GetTblProductLists',
    productPOST: '/api/TblProductList/CreateTblProductList',
    productGET_SINGLE_USER_ID: '/api/TblProductList/GetTblProductList',
    productPATCH: '/api/TblProductList/UpdateTblProductList',
    productDELETE: '/api/TblProductList/DeleteTblProductList'
};

const productDetails = {
    productDetailsGET: '/api/TblProductListDetail/GetTblProductListDetails',
    productDetailsGET_BY_ID: '/api/TblProductListDetail/GetProductListDetailofProductList',
    productDetailsPOST: '/api/TblProductListDetail/CreateTblProductListDetail',
    productDetailsGET_SINGLE_USER_ID: '/api/TblProductListDetail/GetTblProductListDetail',
    productDetailsPATCH: '/api/TblProductListDetail/UpdateTblProductListDetail',
    productDetailsDELETE: '/api/TblProductListDetail/DeleteTblProductListDetail'
};

const sizeMeasurementMaster = {
    sizeMeasurementMasterGET: '/api/TblSizeMeasurementHeader/GetAllTblSizeMeasurementHeader',
    sizeMeasurementMasterPOST: '/api/TblSizeMeasurementHeader/CreateSizeMeasurementHeader',
    sizeMeasurementMasterPATCH: '/api/TblSizeMeasurementHeader/UpdateSizeMeasurementHeader',
    sizeMeasurementMasterDELETE: '/api/TblSizeMeasurementHeader/DeleteSizeMeasurementHeader',
    sizeInfoIdGET: '/api/TblSizeInfo/GetSizeInfo',
    sizeMeasurementBuyerList: '/api/TblBuyerMaster/GetBuyerList'
};

const sizeMeasurementDetails = {
    sizeMeasurementDetailGET_SINGLE_USER_ID: '/api/TblSizeMeasurementDetail/GetSizeMeasurementDetailList',
    sizeMeasurementDetailGET: '/api/TblSizeMeasurementDetail/GetAllTblSizeMeasurementDetail',
    sizeMeasurementDetailsPOST: '/api/TblSizeMeasurementDetail/CreateSizeMeasurementDetail',
    sizeMeasurementDetailsPOST_BULK: '/api/TblSizeMeasurementDetail/InsertSizeMeasurementDetailsBulk',
    sizeMeasurementDetailsGET_BY_ID: '/api/TblSizeMeasurementDetail/GetTblSizeMeasurementDetail',
    sizeMeasurementDetailsPATCH: '/api/TblSizeMeasurementDetail/UpdateSizeMeasurementDetail',
    sizeMeasurementDetailsPATCH_BULK: '/api/TblSizeMeasurementDetail/UpdateSizeMeasurementDetailsBulk',
    sizeMeasurementDetailsDELETE: '/api/TblSizeMeasurementDetail/DeleteSizeMeasurementDetail'
};

const userHeader = {
    userHeaderGET: '/api/TblUserHeader/GetAllUserHeader',
    userHeaderPOST: '/api/TblUserHeader/CreateTblUserHeader',
    userHeaderPATCH: '/api/TblUserHeader/UpdateTblUserHeader',
    userHeaderDELETE: '/api/TblUserHeader/DeleteTblUserHeader',
    userHeaderSignatureImageGET: '/api/TblUserHeader/GetSignImage',
    userHeaderCompanyGET: '/api/TblUserHeader/CheckCompanyName',
    getFilterMeu: '/api/TblMenuMaster/GetAllTblMenuMaster',
    getFilteredLists: '/api/TblUserDetail/GetTblUserDetailByMenuName'
};

const userDetails = {
    userDetailsGET_BY_ID: '/api/TblUserDetail/GetTblUserDetailList',
    userDetailsPOST: '/api/TblUserDetail/CreateTblUserDetail',
    userDetailsGET_SINGLE_USER_ID: '/api/TblUserDetail/GetTblUserDetail',
    userDetailsPATCH: '/api/TblUserDetail/UpdateTblUserDetail',
    userDetailsDELETE: '/api/TblUserDetail/DeleteTblUserDetail'
};

const feedbackMaster = {
    feedbackMasterGET: '/api/TblFeedbackMaster/GetTblFeedbackMasters',
    feedbackMasterPOST: '/api/TblFeedbackMaster/CreateTblFeedbackMaster',
    feedbackMasterGET_SINGLE_USER_ID: '/api/TblFeedbackMaster/GetTblFeedbackMaster',
    feedbackMasterPATCH: '/api/TblFeedbackMaster/UpdateTblFeedbackMaster',
    feedbackMasterDELETE: '/api/TblFeedbackMaster/DeleteTblFeedbackMaster'
};

const styleMasterBasic = {
    styleMasterBasicGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasicWithoutSKU',
    styleMasterBasicWithSKUGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasicWithSKU',
    // styleMasterBasicGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasic',
    styleMasterBasicPOST: '/api/TblStyleMasterBasic/CreateTblStyleMasterBasic',
    styleMasterBasicGET_SINGLE_USER_ID: '/api/TblStyleMasterBasic/GetTblStyleMasterBasic',
    styleMasterBasicPATCH: '/api/TblStyleMasterBasic/UpdateTblStyleMasterBasic',
    styleMasterBasicDELETE: '/api/TblStyleMasterBasic/DeleteTblStyleMasterBasic',
    styleMasterMultipleUpload: '/api/TblStyleMaster/UploadMultipleStyleTemplate'

};

const skuMasterHeader = {
    skuMasterHeaderGET: '/api/TblSKUDetail/GetAllTblSKUMaster',
    skuMasterSizeHeaderGET: '/api/TblSizeInfo/CheckSizeInfoIsUpdated',
    skuMasterHeaderDetailGET: '/api/TblSKUDetail/GetAllTblSKUDetail',
    skuMasterHeaderGET_BY_ID: '/api/TblSKUDetail/GetSKUDetailWithStyle',
    skuMasterHeaderPOST: '/api/TblSKUDetail/CreateTblSKUDetailManual',
    skuMasterHeaderUploadXLSXPOST: '/api/TblSKUDetail/CreateTblSKUDetail',
    skuMasterHeaderGET_SINGLE_USER_ID: '/api/TblSKUDetail/GetTblSKUDetailId',
    skuMasterHeaderPATCH: '/api/TblSKUMaster/UpdateTblSKUMaster',
    skuMasterSizeHeaderPATCH: '/api/TblSizeInfo/UpdateRearrangeSizeInfo',
    skuMasterHeaderDELETE: '/api/TblSKUDetail/DeleteTblSKUDetail',
    skuMasterHeaderSizeByID: '/api/TblProperties/GetTblPropertyByFKProperty/47',
    skuMasterHeaderImagePOST: '/api/TblImagesInfo/CreateTblImagesInfoDirectUpload'
};

const skuMasterDetails = {
    skuMasterDetailsGET: '/api/TblSKUDetail/GetAllTblSKUDetail',
    skuMasterDetailsGET_BY_ID: '/api/TblSKUDetail/GetTblSKUDetail',
    skuMasterDetailsPOST: '/api/TblSKUDetail/CreateTblSKUDetail',
    skuMasterDetailsGET_SINGLE_USER_ID: '/api/TblSKUDetail/GetTblSKUDetail',
    skuMasterDetailsPATCH: '/api/TblSKUDetail/UpdateTblSKUDetail',
    skuMasterDetailsDELETE: '/api/TblSKUDetail/DeleteTblSKUDetail'
};

const feedbackDetails = {
    feedbackDetailsGET_BY_ID: '/api/TblFeedbackDetail/GetAllTblFeedbackDetails',
    feedbackDetailsPOST: '/api/TblFeedbackDetail/CreateTblFeedbackDetail',
    feedbackDetailsGET_SINGLE_USER_ID: '/api/TblFeedbackDetail/GetTblFeedbackDetail',
    feedbackDetailsPATCH: '/api/TblFeedbackDetail/UpdateTblFeedbackDetail',
    feedbackDetailsDELETE: '/api/TblFeedbackDetail/DeleteTblFeedbackDetail'
};
const process = {
    processGET: '/api/TblProcess/GetAllProcess',
    processAssignGET: '/api/TblProcessAssignStyle/GetAllProcessAssignStyle',
    processAssignByStyleIdGET: '/api/TblProcessAssignStyle/CheckTblProcessAssignStyledetailByid',
    // programMappingByProcessIdGET: '/api/TblStylePrepAccessoriesMaster/GetProcessByID',
    programMappingByProcessIdGET: '/api/TblStylePrepFabric/GetProgramMappingbyProcess',
    processPOST: '/api/TblProcess/CreateProcess',
    processAssignPOST: '/api/TblProcessAssignStyle/CreateProcessAssignStyle',
    processGETID: '/api/TblProcess/GetProcess',
    programMappingKGGETID: '/api/TblStylePrepPCSWeight/GetProgramMappingKgPcsByStyle',
    processAssignGETID: '/api/TblProcessAssignStyle/GetProcessAssignStyle',
    processPATCH: '/api/TblProcess/UpdateProcess',
    processAssignPATCH: '/api/TblProcessAssignStyle/UpdateProcessAssignStyle',
    processDELETE: '/api/TblProcess/DeleteProcess',
    processAssignDELETE: '/api/TblProcessAssignStyle/DeleteProcessAssignStyle',
    processFlowCopy: '/api/TblProcessFlow/CreateCopyProcessFlow'
};

const processAddOn = {
    processAddOnGET_BY_ID: '/api/TblProcessFlowAddOn/GetTblProcessFlowAddOnbyProcessFlow',
    processAddOnGET: '',
    processAddOnPOST: '/api/TblAddOnProcessFlow/CreateAddOnProcessFlow',
    processAddOnGETID: '/api/TblAddOnProcessFlow/GetTblAddOnProcessFlow',
    processAddOnPATCH: '/api/TblAddOnProcessFlow/UpdateAddOnProcessFlow',
    processAddOnDELETE: '/api/TblAddOnProcessFlow/DeleteAddOnProcessFlow',
    processAddOnSalesOderGET: '/api/TblYarnInwardDetail/GetPendingSaleOrderByProgram?FldAction=DISTINCTPENDINGSALE'
};
const dashboardDK = {
    dashboardDKProgramGET: '/api/TblProgramMapping/GetTblProgramMappings',
    dashboardDKSummaryGET: '/api/TblDashboard/GetDashboardSummary',
    dashboardDKSupplierWiseGET: '/api/TblDashboard/GetDashboardSupplierWise',
    dashboardDKOutstandingWiseGET: '/api/TblDashboard/GetDashboardOutstanding',
    dashboardDKAllSummaryGET: '/api/TblDashboard/GetDashboardOverallSummary',
    dashboardDKItemWiseGET: '/api/TblDashboard/GetDashboardItemWise'
};
const reportDK = {
    reportDKProgramWiseGET: '/api/TblReports/GetReports_ProgramWise',
    reportDKCuttingWiseGET: '/api/TblReports/GetReports_CuttingBulk',
    reportDKSingleProgramWiseGET: '/api/TblReports/GetInwardReports_POWise'
};

const billEntriesDK = {
    addBillEntriesGET: '/api/TblBillEntryDetail/GetAddBillEntries',
    addBillEntriesPOST: '/api/TblBillEntries/CreateTblBillEntries',
    addBillEntriesDetailPost: '/api/TblBillEntryDetail/CreateTblBillEntryDetail',
    addBillEntriesreportGET: '/api/TblBillEntryDetail/GetBillEntriesForDashBoard',
    addBillEntriesOTP: '/api/TblMail/SendBillEntryApprovalOTP_Cost',
    addBillEntriesOTPNew: '/api/TblMail/SendBillEntryApprovalOTP_Reason',
    addBillEntriesClosePATCH: '/api/TblBillEntryDetail/UpdateCloseBillEntry',
    addBillEntriesDebitorCreditNotePOST: '/api/TblDebitOrCreditNote/CreateTblDebitOrCreditNoteFromBillEntry',
    addBillEntriesDebitDetail: 'api/TblDebitOrCreditNote/CreateTblDebitOrCreditNoteAndDetail',
    addBillEntriesBRLNoGET: '/api/TblBillReceiving/GetTblUniqueBRNumber',
    addBillEntriesInvoiceNoGET: '/api/TblBillEntries/GetPartyIdByInvoiceNo',
    debitMemoDataGET: '/api/TblDebitOrCreditNote/GetDebitMemoDetail',
    debitMemoDetailPOST: '/api/TblDebitOrCreditNoteDetail/CreateTblDBEAndDetail',
    debitMemoQtyGET: '/api/TblDebitOrCreditNote/GetDebitMemoQtyAndNo',
    debitMemoReportGET: '/api/TblDebitOrCreditNote/GetTblDebitMemoReport',
    debitMemoReportPrintGET: '/api/TblDebitOrCreditNote/TblDebitorCreditMemoPrint',
    debitMemoReportDELETE: '/api/TblDebitOrCreditNoteDetail/DeleteTblDBEAndDetail'
};
const editbillEntries = {
    editbillEntriesreportGET: '/api/TblBillEntries/GetTblBillEntriess',
    editbillEntriesFormUpdate: '/api/TblBillEntries/EditBillEntries',
    editbillEntriesGridUpdate: '/api/TblBillEntryDetail/EditBillEntryDetail',
    editbillEntriesFormGET: '/api/TblBillEntries/GetEditTblBillEntries',
    editbillEntriesTableDataGET: '/api/TblBillEntryDetail/GetEditBillEntries',
    editbillEntriesCallOff: '/api/TblBillEntryDetail/CallOffBillEntryAndDetail',
    editbillEntriesInvoiceNo: '/api/TblBillEntries/GetPartyIdByInvoiceNoForEdit'
};

const closeBillEntryReport = {
    closebillentryReport: '/api/TblBillEntryDetail/GetCloseBillEntryReport',
};

// const editverification = {
//     editVerificationDataGET: '/api/TblBillEntries/GetEditVerificationDashboard',
//     editVerificationCalloff: '/api/TblBillEntryDetail/CallOffVerifyBillEntries'
// }

const verifiedBills = {
    verifiedBillDashBoardGET: '/api/TblBillEntryDetail/GetVerifyCallOffDashBoard',
    verifiedBillCallOffPATCH: 'api/TblBillEntryDetail/BillEntryAndDetailVerifyCallOff',
}

const verifyBillEntriesDK = {
    verifyBillEntriesGET: '/api/TblBillEntryDetail/GetVerifyBillEntryDashBoard',
    verifyBillEntriesDataGET: '/api/TblBillEntries/GetTblBillEntries',
    verifyBillEntriestableDataGET: '/api/TblBillEntryDetail/GetTblBillEntryDetailsByBillEntriesID',
    verifyBillEntriesUpdatePATCH: '/api/TblBillEntries/UpdateTblBillEntries',
    verifyBillEntriesID: '/api/TblBillEntryDetail/UpdateTblBillEntryDetail',
    tallyFormatGET: '/api/TblBillEntryDetail/GetTallyFormatData',
};

const billentryReportall = {
    billreportData: '/api/TblBillEntries/GetBillEntryReport',
    billreportStyleWiseData: '/api/TblBillEntryDetail/GetTblBillEntryStyle',
    billreportDetailData: '/api/TblBillEntries/GetBillEntryDetailReport',
    billreportConsolidateData: '/api/TblBillEntries/GetBillEntryReportConsolidated',
    billreportConsolidateDetailData: '/api/TblBillEntries/GetBillEntryReportDetailed',
    billreportsDebitOrCreditNotePrint: '/api/TblDebitOrCreditNote/TblDebitCreditNotePrint',
}

const billEntryStyle = {
    GetTblBillEntryStyle: '/api/TblBillEntryDetail/GetTblBillEntryStyle',
}

const billReceiving = {
    billReceivingGET: '/api/TblBillReceiving/GetTblBillReceiving',
    billReceivingGET_BY_ID: '/api/TblBillReceiving/GetTblBillReceiving',
    billReceivingPOST: '/api/TblBillReceiving/CreateTblBillReceiving',
    billReceivingPATCH: '/api/TblBillReceiving/UpdateTblBillReceiving',
    billReceivingDELETE: '/api/TblBillReceiving/DeleteTblBillReceiving',
    billReceivingGETPartyByInvoiceNO: '/api/TblBillEntries/GetPartyIdByInvoiceNo'
}

const billReceivingReport = {
    GETBillReceivingReport: '/api/TblBillReceiving/GetBRNReport',
    BillReceivingReportConsolidatedGET: 'api/TblBillReceiving/GetBRNReport_Consolidate',
}

const billReceivingVerify = {
    GETBillReceivingVerify: '/api/TblBillReceiving/GetBillReceiving_Program',
    VerifyBillReceivingAPI: '/api/TblBillReceiving/VerifyBillReceiving',
    GetVerifiedBRNsData: '/api/TblBillReceiving/GetVerifiedBRNs',
    VerifyBillReceivingCallOff: '/api/TblBillReceiving/VerifyBillReceivingCallOff'
}

const shippingPlan = {
    shippingPlanCreatePost: '/api/TblShipmentPlan/CreateShipmentPlan',
    shippingPlanGet: '/api/TblShipmentPlan/GetAllShipmentPlan',
    shippingPlanUpdateGet: '/api/TblShipmentPlan/GetShipmentPlan',
    shippingPlanUpdatePost: 'api/TblShipmentPlan/UpdateShipmentPlan',
    shippingPlanMasterDELETE: '/api/TblShipmentPlan/DeleteShipmentPlan',
    yarnPOSalesOrderList: '/api/TblYarnInwardDetail/GetPendingSaleOrderByProgram',
    checkValidation: '/api/TblShipmentPlanDetail/CheckGetShipmentPlanDetailByAvaliable'


}

const shippingPlanDetails = {
    shippingPlanDetailsCreatePost: 'api/TblShipmentPlanDetail/CreateShipmentPlanDetail',
    shippingPlanDetailsGet: '/api/TblShipmentPlanDetail/GetShipmentPlanDetailByShipmentDC',
    shippingPlanDetailsDelete: '/api/TblShipmentPlanDetail/DeleteShipmentPlanDetail',
    shippingPlanDetailsFromTo: '/api/TblShipmentPlanDetail/GetSaleOrderDetail?Action=SaleDetail'
}

const fabricroughCosting = {
    roughFabricCostingGET: '/api/TblFabricRoughCosting/GetTblFabricRoughCostings',
    roughFabricCostingHeaderPOST: '/api/TblFabricRoughCosting/CreateTblFabricRoughCosting',
    roughFabricCostingDetailPOST: '/api/TblFabricRoughCostingDetail/CreateTblFabricRoughCostingDetail',
    roughFabricCostingDetailGET: '/api/TblFabricRoughCostingDetail/GetTblFabricRoughCostingDetailofFRC',
    roughFabricCostingInvoiceGET: '/api/TblFabricRoughCosting/GetTblFabricRoughCosting',
    roughFabricCostingHeaderDELETE: '/api/TblFabricRoughCosting/DeleteTblFabricRoughCosting',
    roughFabricCostingHeaderEdit: '/api/TblFabricRoughCosting/GetTblFabricRoughCosting',
    roughFabricCostingHeaderPATCH: '/api/TblFabricRoughCosting/UpdateTblFabricRoughCosting'
}

const styleWiseReportAll = {
    GetReportsStyleWise: '/api/TblReports/GetReports_StyleWise',
    GetReportsStyleWiseDetails: '/api/TblReports/GetReports_StyleWiseSummary',
    GetReportByStyleWise: 'api/TblStyleMaster/GetTblStyleMasterNoIncludes',
    GetStatusReport: '/api/TblReports/GetReports_FabricStatusChart',
    POSTStatusReport: '/api/TblFabricStatusChart/CreateTblFabricStatusChart',
    GetStyleWiseWithColour: 'api/TblCompactingDCDetail/GetTblCODColourDCNO',
    GetStyleWiseWithCUDColour: 'api/TblCuttingDCDetail/GetTblCUDColourDCNO',
    POSTMovetoCutting: '/api/TblCuttingDCDetail/CreateDetailByMovetoCutting',
    GetReportByOcrClosed: '/api/TblSaleOrder/GetOCRClosedStyle',

    GetStatusCompactingReport: '/api/TblReports/GetReports_CompactingStatusChart',
    PostStatusCompactingReport: '/api/TblCompactingStatusReport/CreateCompactingStatusChart',
    getCompactingReportsDateWise: '/api/TblReports/GetReports_CompactingStatusChartByDate',
    getCompactingReportsStyleWise: '/api/TblReports/GetReports_CompactingStatusChartByStyle',

}

const supplierWiseReport = {
    GetReportsSupplierWise: '/api/TblReports/GetReports_SupplierWise',
    supplierPartyDetailGET: '/api/TblPartyDetail/GetAllTblPartyDetailOnlySupplier'
}

const compactingReport = {
    GetCompactingReport: '/api/TblCompactingRN/GetTblCompactingRN_Reports',
}



const fabricReports = {
    GETAllFabricReportsData: '/api/TblReports/GetReports_StyleDateWiseSummary'
}

// const projectionReport = {
//     yarnPRPrint: '/api/TblYarnProjection/TblYarnPRPrint'
// }

const contractorBillEntry = {
    contractorbillDataGET: '/api/TblContractorBill/GetTblContractorBills',
    contractorLoadNameGET: '/api/TblContractorBill/LoadContractorName',
    contractorbillCreatePOST: '/api/TblContractorBill/CreateTblContractorBill',
    contractorbillEntryDetailPOST: 'api/TblContractorBillDetail/CreateTblContractorBillDetail',
    contractorbillDetailEditPATCH: '/api/TblContractorBillDetail/UpdateTblContractorBillDetail',
    contractorbillMasterGET: '/api/TblContractorBill/GetTblContractorBill',
    contractorbillDetailGET: '/api/TblContractorBillDetail/GetTblContractorBillDetail',
    contractorbillMasterDELETE: '/api/TblContractorBill/DeleteTblContractorBill',
    contractorbillMasterUPDATE: '/api/TblContractorBill/UpdateTblContractorBill',
    contractorbillEntryDetailUPDATE: '/api/TblContractorBillDetail/UpdateTblContractorBillDetail',
    contractorBillDetailofPO: '/api/TblContractorBillDetail/GetTblContractorBillDetailofPO',
    contractorBillInvoice: '/api/TblContractorBill/TblContractorBillPrint',
    contractorPriceAmt: '/api/TblContractorBill/TblContractorTotalValue',


};

const processFlow = {
    processFlowGET_BY_ID: '/api/TblProcessFlow/GetProcessFlowsList',
    processFlowGET: '/api/TblProcessFlow/GetAllProcessFlow',
    processFlowPOST: '/api/TblProcessFlow/CreateProcessFlow',
    processFlowGETID: '/api/TblProcessFlow/GetProcessFlow',
    processFlowPATCH: '/api/TblProcessFlow/UpdateProcessFlow',
    processFlowDELETE: '/api/TblProcessFlow/DeleteProcessFlow',
    sequenceNumberGET: '/api/TblProcessFlow/GenerateSequenceNo'
};
const processSupplier = {
    processSupplierGET_BY_ID: '/api/TblProgramSupplier/GetTblProgramSupplierbyProcessFlow',
    processSupplierGET: '/api/TblProgramSupplier/GetAllTblProgramSupplier',
    processSupplierPOST: '/api/TblProgramSupplier/CreateProgramSupplier',
    processSupplierGETID: '/api/TblProgramSupplier/GetTblProgramSupplier',
    processSupplierPATCH: '/api/TblProgramSupplier/UpdateProgramSupplier',
    processSupplierDELETE: '/api/TblProgramSupplier/DeleteProgramSupplier',
    processSupplierDropdownGET: '/api/TblProgramSupplier/GetLoadBuyerUsingFilter?FldControllerName=TblProgramSupplier'
};
const programConstraint = {
    programConstraintGET: '/api/TblProgramConstraint/GetAllTblProgramConstraint',
    programConstraintPOST: '/api/TblProgramConstraint/CreateProgramConstraint',
    programConstraintGETID: '/api/TblProgramConstraint/GetTblProgramConstraint',
    programConstraintPATCH: '/api/TblProgramConstraint/UpdateProgramConstraint',
    programConstraintDELETE: '/api/TblProgramConstraint/DeleteProgramConstraint'
};
const programMapping = {
    programMappingGET: '/api/TblProgramMapping/GetTblProgramMappings',
    tableNameGET: '/api/TblProgramMapping/GetallTblName',
    programMappingPOST: '/api/TblProgramMapping/CreateTblProgramMapping',
    programMappingGETID: '/api/TblProgramMapping/GetTblProgramMapping',
    programMappingPATCH: '/api/TblProgramMapping/UpdateTblProgramMapping',
    programMappingDELETE: '/api/TblProgramMapping/DeleteTblProgramMapping',
    programPickups: '/api/TblProgramMapping/GetTblProgramMappings_PickupPrograms',
    pickupStyles: '/api/TblPickupDetail/GetPickup_Programwise',
    createPickupsPost: '/api/TblPickupDetail/CreateTblPickupProgram',
    pickupStylesPost: '/api/TblPickupDetail/GetPickupInfo_BySupplier',
};

const styleMaster = {
    GetTblBillEntryStyle: '/api/TblBillEntryDetail/GetTblBillEntryStyle',
    styleMasterGET: '/api/TblStyleMaster/GetTblStyleMasters',
    copyStyleMasterGET: '/api/TblCopyStyleMaster/GetTblCopyStyleMaster',
    copyStyleMaster1GET: '/api/TblCopyStyleMasterMain/GetTblCopyStyleMasterMain',
    multiCopyStyleMasterGET: '/api/TblCopyStyleDetail/GetByStyleId',
    multiCopyColorStyleMasterGET: '/api/TblCopyStyleMaster/GetColour',
    styleMasterGET_BY_ID: '/api/TblStyleMaster/GetTblStyleMastersbyMainID',
    styleMasterDeleteByGET_BY_ID: '/api/TblStyleMaster/GetTblStyleMasterInfoForDelete',
    styleMasterPOST: '/api/TblStyleMaster/CreateTblStyleMaster',
    createCopyStyleMasterPOST: '/api/TblStyleMaster/CopyTblStyleMaster',
    createCopyStyleMasterOneNewPOST: '/api/TblStyleMaster/CopyTblStyleMasterNewOption',
    copyStyleMasterPart1POST: '/api/TblCopyStyleMaster/CreateCopyStyleMain',
    copyStyleMasterPartPOST: '/api/TblCopyStyleMaster/CreateCopyStyle',
    styleMasterGETID: '/api/TblStyleMaster/GetTblStyleMaster',
    styleMasterPATCH: '/api/TblStyleMaster/UpdateTblStyleMaster',
    copyStyleMasterPATCH: '/api/TblCopyStyleMaster/UpdateCopyAll',
    styleMasterDELETE: '/api/TblStyleMaster/DeleteTblStyleMaster',
    copyStyleMasterDELETE: '/api/TblCopyStyleMaster/RemoveColour',
    styleMasterCheckDefaultValueGET: '/api/TblStyleDetailDefault/GetTblStyleDetailDefaultsCategoriesActive',
    styleMasterCheckMeasurementGET: '/api/TblStitchingMeasurement/CheckGetStitchingMeasurementByStyle',
    createStitchingMeasurementPOST: '/api/TblStitchingMeasurement/CreateStitchingMeasurements',
    updateStitchingMeasurementPATCH: '/api/TblStitchingMeasurement/UpdateStitchingMeasurement',
    copyStyleMasterAssignColor: '/api/TblCopyStyleMaster/UpdateColour',
    styleMasterUpdateApprovalStatusBtn: '/api/TblStyleMaster/UpdateTblStyleMasterApproval',
    sendVerifyOTP: '/api/TblMail/SendApprovalOTP_EditSubStyleInfo',
    beforeAuthorizeSendVerifyOTP: '/api/TblStyleMaster/CheckValidationForPrepareverifyAuth',
    authorizeSendVerifyOTP: '/api/TblMail/SendApprovalOTP_AuthorizeStyle',
    authorizeValidateOTP: '/api/TblMail/ValidateOTP',
    authorizeUpdateValidateOTP: '/api/TblMail/UpdateOTPApproval',
    authorizeSendVerifyOTPForYarnPO: '/api/TblMail/SendYarnApprovalOTP_Cost',
    authorizeSendVerifyOTPForYarnPONew: '/api/TblMail/SendYarnApprovalOTP_Reason',
    authorizeSendVerifyOTPForfabricPO: '/api/TblMail/SendFabricApprovalOTP_Cost',
    authorizeSendVerifyOTPForfabricPONew: '/api/TblMail/SendFabricApprovalOTP_Reason',
    authorizeSendVerifyOTPForDyeingDC: '/api/TblMail/SendDCApprovalOTP_Cost',
    authorizeSendVerifyOTPForDyeingDCNew: '/api/TblMail/SendDCApprovalOTP_Reason',
    fileUploadStyle: 'api/TblStyleMaster/StyleImageUpload',
    fileUploadGetList: 'api/TblStyleMaster/GetStyleImage',
    getSizeMeasurement: 'api/TblStitchingMeasurement/CreateStyleSizeMeasurements',
    getCostingActiveOnly: "/api/TblSimpleCosting/GetTblSimpleCostingActiveOnly",
    getFabricAuthorize: '/api/TblStylePrepProcessCostKG/UpdateKGApproval',
    getMerchAuthorize: '/api/TblStylePrepProcessCostKG/UpdatePCSApproval',
    getCheckAuthorize: '/api/TblStylePrepProcessCostKG/CheckVerified',
    salesOrderUserBasedFab: '/api/TblSaleOrder/GetTblSaleOrderForVerifyFabric',
    salesOrderUserBasedMerch: '/api/TblSaleOrder/GetTblSaleOrderForVerifyMerch',
    getOcrReports: '/api/TblCostingComparision/GenerateOCRAccessoriesCost',
    getOcrClosedReports: '/api/TblSaleOrder/GetClosedTblSaleOrder',
    styleMasterByTemplate: '/api/TblBarcodeTemplate/GetTblBCTemplateBySalesOrder',

};

const dyeingDetails = {
    dyeingDetailsGETALL: '/api/TblDyeingDetail/GetTblDyeingDetails',
    dyeingDetailsGET_BY_ID: '/api/TblDyeingDetail/GetTblDyeingDetail',
    dyeingDetailsPOST: '/api/TblDyeingDetail/CreateTblDyeingDetail',
    dyeingDetailsPATCH: '/api/TblDyeingDetail/UpdateTblDyeingDetail',
    dyeingDetailsDELETE: '/api/TblDyeingDetail/DeleteTblDyeingDetail'
};


const styleMasterMain = {
    styleMasterMainGET: '/api/TblStyleMasterMain/GetTblStyleMasterMains',
    styleMasterMainPOST: '/api/TblStyleMasterMain/CreateTblStyleMasterMain_New',
    styleMasterMainGETID: '/api/TblStyleMasterMain/GetTblStyleMasterMain',
    styleMasterMainPATCH: '/api/TblStyleMasterMain/UpdateTblStyleMasterMain',
    styleMasterMainDELETE: '/api/TblStyleMasterMain/DeleteTblStyleMasterMain',
    styleMasterMainBuyerName: '/api/TblStyleMasterMain/GetLoadBuyerUsingFilter?FldControllerName=TblStyleMasterMain',
    styleMasterStyleNo: '/api/TblStyleMasterMain/GetGenerateStyleNumber',
    checkDemandByStyleId: '/api/TblSaleOrder/GetDemandStatusByStyle',
    checkDemandBySalesOrder: '/api/TblSaleOrder/GetDemandStatusByStyle',
    styleFabricInfo: '/api/TblStyleDetail/GetTblStyleDetailListByDetail',
    stylePreMain: '/api/TblStyleMasterMain/GetTblStyleMasterMain',
    styleUpdateGet: '/api/TblStitchingMeasurement/CheckGetStyleSizeMeasurementByStyle',
    styleDeleteGet: '/api/TblStitchingMeasurement/DeleteStyleSizeMeasurementByStyle',
    styleTrackChanges: '/api/TblStyleMaster/GetTrackStyleChanges',


};

const styleDetails = {
    styleDetailsGET: '/api/TblStyleDetail/GetTblStyleDetails',
    styleDetailsGET_BY_ID: '/api/TblStyleDetail/GetTblStyleDetailList',
    styleDetailsPOST: '/api/TblStyleDetail/CreateTblStyleDetail',
    styleDetailsGETID: '/api/TblStyleDetail/GetTblStyleDetail',
    styleDetailsFabricInfoPATCH: '/api/TblStylePrepFabric/UpdateStyleDetailbyStyle?Action=UPDATE',
    styleDetailsPATCH: '/api/TblStyleDetail/UpdateTblStyleDetail',
    styleDetailsPcsWeightPATCH: '/api/TblStyleDetail/UpdateStyleDetailGSMByStyleSheetID',
    styleDetailsDELETE: '/api/TblStyleDetail/DeleteTblStyleDetail',
    styleDetailUpload: '/api/TblImagesInfo/CreateTblStyleDetailTemplates',
    imageUploadPrevImageGet: '/api/TblImagesInfo/GetTblImagesInfo',
    styleDetailCheck: '/api/TblEANArticleMaster/CheckAvalibleEANArticleMasterBySalesStyle',
    postEANCreateWhile: 'api/TblEANArticleMaster/CreateAddTblEANArticleMaster',
    postSalesOrderSalesAdd: '/api/TblStyleMaster/CopySpecficStyleDetail'
};

const defaultStyleMaster = {
    defaultStyleMasterGET: '/api/TblStyleDetailDefault/GetTblStyleDetailDefaults',
    defaultStyleMasterByIdGET: '/api/TblStyleDetailDefault/GetTblStyleDetailDefaults',
    defaultStyleMasterGET_SET_ACTIVE: '/api/TblStyleDetailDefault/UpdateTblStyleDetailDefaultSetIsActive',
    defaultStyleMasterPOST: '/api/TblStyleDetailDefault/CreateTblStyleDetailDefault',
    defaultStyleMasterGETID: '/api/TblStyleDetailDefault/GetTblStyleDetailDefault',
    defaultStyleMasterPATCH: '/api/TblStyleDetailDefault/UpdateTblStyleDetailDefault',
    defaultStyleMasterDELETE: '/api/TblStyleDetailDefault/DeleteTblStyleDetailDefault'
};

const salesOrder = {
    salesOrderGET: '/api/TblSaleOrder/GetAllTblSaleOrder',
    salesOrderGETNew: '/api/TblSaleOrder/GetAllTblSaleOrderForOCR',
    salesOrderPOST: '/api/TblSaleOrder/CreateSaleOrder',
    salesOrderGETID: '/api/TblSaleOrder/GetTblSaleOrder',
    salesOrderPATCH: '/api/TblSaleOrder/UpdateSaleOrder',
    salesOrderDELETE: '/api/TblSaleOrder/DeleteSaleOrder',
    salesOrderCancelPATCH: '/api/TblSaleOrder/CancelSalesOrder',
    // salesOrderDispatch: '/api/TblSaleOrder/GenerateDemand',
    salesOrderApprovalStatus: '/api/TblSaleOrder/GetStylePreprationApprovalStatus',
    demandStatus: '/api/TblSaleOrder/GetDemandStatus',
    salesOrderApprovalSummary: '/api/TblSaleOrder/GetSaleOrderDtlApprovalSummary',
    styleDetailsApprovalSummary: '/api/TblSaleOrder/GetStyleDetailApprovalSummary',
    styleDetailsApprovalHeader: '/api/TblSaleOrder/GetStyleDetailApprovalHeader',
    styleDetailsApprovalDetail: '/api/TblSaleOrder/GetStyleDetailApprovalDetail',
    styleDetailsApprovalStyle: '/api/TblSaleOrder/GetSDAHofAllStyles',
    styleDetailsUpdateApprovalStatus: '/api/TblSaleOrder/UpdateApprovalStatus',
    // salesOrderDispatch: '/api/TblSaleOrder/GenerateDemandAgainstSaleOrder',
    salesOrderDispatch: '/api/TblSaleOrder/GenerateYarnDemand',
    salesOrderDispatchFabric: '/api/TblSaleOrder/GenerateFabricDemand',
    salesOrderDispatchAccessory: '/api/TblSaleOrder/GenerateAccessoryDemand',
    salesOrderDispatchFinal: '/api/TblStylePrepProcessCostKG/InsertStylePrepProcessCost',
    // salesOrderDemandGETID: '/api/TblSaleOrder/CheckTblSaleOrderStylePreParationFabric'
    salesOrderDemandGETID: '/api/TblSaleOrder/GetYarnDemand',
    salesOrderDemandFabricGETID: '/api/TblSaleOrder/GetFabricDemand',
    salesOrderDemandFabricColorGETID: '/api/TblSaleOrder/GetFabricDemandWithColour',
    AccessoriesDemandGETID: '/api/TblSaleOrder/GetAccessoriesDemand',
    AccessoriesDemandSummaryGETID: '/api/TblSaleOrder/GetAccessoriesDemandSummary',
    salesOrderBuyerName: '/api/TblSaleOrder/GetLoadBuyerUsingFilter?FldControllerName=TblSaleOrder',
    demandInvoiceGET: '/api/TblSaleOrder/GetTblDemandPrint',
    demandYarnRequirementInvoiceGET: '/api/TblSaleOrder/GetTblDemandYarnReqPrint',
    demandFabRequirementInvoiceGET: '/api/TblSaleOrder/GetTblDemandFabReqPrint',
    demandColorwiseFabInvoiceGET: '/api/TblSaleOrder/GetTblDemandColourWiseFabPrint',
    demandAccessReqInvoiceGET: '/api/TblSaleOrder/GetTblDemandAccessPrint',
    demandPWCInvoiceGET: '/api/TblSaleOrder/GetTblDemandPCWPrint',
    demandColorSizeReqInvoiceGET: '/api/TblSaleOrder/GetTblDemandColorSizeWiseReq',
    demandprocessCostPerPcsInvoiceGET: '/api/TblSaleOrder/GetTblDemandStylePrepareCostPerPCs',
    salesOrderCancelOTP: '/api/TblMail/SendApprovalOTP_CancelSaleOrder',
    // salesOrderCancelDemand: '/api/TblSaleOrder/DeleteDemand',
    salesOrderCancelDemand: '/api/TblSaleOrder/DeleteDemand',
    salesOrderGetStyleStatusId: '/api/TblSaleOrder/GetStyleStatus',
    programStyleCheck: '/api/TblStyleMaster/UpdatePartColorTblStyleMaster',
    checkSalesCountLoader: '/api/TblSaleOrder/TempTableCompletionStatus',
    checkActiveSupplier: '/api/TblReports/GetReports_ActiveSupplier',
    salesOrderCompare: '/api/TblCostingComparision/GenerateCostingComparision',
    salesOrdersinglePrint: '/api/TblCostingComparision/GenerateCostingComparisionSinglePcFormat',
    salesOrdersinglePrint2: '/api/TblCostingComparision/GetTblCostingComparisionSummary',

    GenerateCostingComparisionPeriodWise: '/api/TblCostingComparision/GenerateCostingComparisionPeriodWise',
    GenerateCostingFabricTable1: '/api/TblCostingComparision/GenerateCostingFabricTable1',
    GenerateCostingFabricTable2: '/api/TblCostingComparision/GenerateCostingFabricTable2',
    saleOrderDemandRevertStatus: '/api/TblSaleOrder/UpdateSaleOrderRevertDemandStatus',
    salesOrderPatternUpdate: '/api/TblSaleOrder/UpdatePatternInSaleOrder',
    GenerateCostingFabricTable3: '/api/TblCostingComparision/GenerateCostingFabricAllKgsPrograms',
    salesOrderStatus: '/api/TblSaleOrder/GetPendingBillSaleOrder',
    salesOrderTransaction: '/api/TblCostingComparision/GenerateAllFabricTransactions',
    salesOrderToggleRestrict: '/api/TblSaleOrder/UpdateTblSaleOrderToggleRestrict',
    demandOcrInvoiceGet: '/api/TblSaleOrder/GetTblDemandBECost',
    salesOrderOCROpenOTP: '/api/TblMail/SalesOrderOpenAlertOTP',
    salesOrderReqReportsStyleGET: '/api/TblSaleOrder/GetTblSOForReqrmntsDtlbyStyle'
};


const stockReportCP = {
    getFabricStockCP: 'api/TblReports/GetFabricStock'
}

const programWiseReportImages = {
    getProgramImages: '/api/TblImagesInfo/GetDisplayImages'
}

const salesOrderDetails = {
    salesOrderDetailsGET_BY_ID: '/api/TblSaleOrderDetail/GetSaleOrderDetailsList',
    styleNumberGET_BY_Season_ID: '/api/TblSaleOrderDetail/GetTblSaleOrderDetailMain',
    subStyleNumberGET_BY_StyleNumber: '/api/TblSaleOrderDetail/GetTblSaleOrderDetailSubStyle',
    salesOrderDetailsGET: '/api/TblSaleOrderDetail/GetAllTblSaleOrderDetail',
    fetchSizeRatioGET: '/api/TblSizeRatio/GetSizeRatioList',
    salesOrderDetailsPOST: '/api/TblSaleOrderDetail/CreateTblSaleOrderDetail',
    salesOrderDetailsGETID: '/api/TblSaleOrderDetail/GetTblSaleOrderDetail',
    salesOrderDetailsPATCH: '/api/TblSaleOrderDetail/UpdateTblSaleOrderDetail',
    salesOrderDetailsDELETE: '/api/TblSaleOrderDetail/DeleteTblSaleOrderDetail',
    salesOrderDetailsStyleMaster: '/api/TblTempSaleOrderDetail/GetTblStyleMasterAvaliable',
    salesOrderDetailsStyleMasterPOST: '/api/TblTempSaleOrderDetail/GenerateTempSaleOrderDetails',
    salesOrderDetailsSubStyleNumberGET: '/api/TblTempSaleOrderDetail/GetTempSaleOrderDetailByUserId',
    salesOrderDetailsTempTablePOST: '/api/TblTempSaleOrderDetail/InsertTempSaleOrderDetail',
    salesOrderDetailsTempTableDELETE: '/api/TblTempSaleOrderDetail/DeleteTempSaleOrderDetailByIds',
    salesOrderDetailsCompleteTempTableDELETE: '/api/TblTempSaleOrderDetail/DeleteTempSaleOrderDetailByUserId',
    salesOrderDetailsTempTableBulkPOST: '/api/TblTempSaleOrderDetail/UpdateTempSaleOrderDetailBulk',
    EANArticleMasterPOST: '/api/TblEANArticleMaster/CreateTblEANArticleMaster',
    EANArticleMasterPATCH: '/api/TblEANArticleMaster/UpdateTblEANArticleMaster',
    EANArticleMasterGET_BY_ID: '/api/TblEANArticleMaster/GetTblEANArticleMasterBySalesStyle',
    EANArticleMasterDELETE: '/api/TblEANArticleMaster/DeleteTblEANArticleMasterByStyle',
    salesYarnPOAllow: '/api/TblSaleOrder/ToggleTblSaleOrdersAllowYarnPO',
    salesFabPOAllow: '/api/TblSaleOrder/ToggleTblSaleOrdersAllowFabricPO',
    salesOrderAdd: '/api/TblSaleOrderDetail/CreateAddTblSaleOrderDetail',
    salesOrderDetailsUpdate: '/api/TblSaleOrderDetail/UpdateMultipleSaleOrderDetail',
    salesOrderEANUpdate: '/api/TblEANArticleMaster/UpdateMultipleTblEANArticleMaster?Action=Update',
    salesOrderDetailsTempTableCreate: '/api/TblSaleOrderDetail/CreateTblTempSaleOrderDetail',
    salesOrderNewColorAdd: '/api/TblSaleOrderDetail/CreateAddTblSaleOrderDetailNewColour'
};


const cuttingReport = {
    cuttingReportHeaderGET: '/api/TblCuttingReport/GetAllTblSaleOrder',
    cuttingReportGSMBYDateGET: '/api/TblCuttingReport/GetCuttingReportByDate',
    cuttingReportPrint: '/api/TblCuttingReport/GetCuttingReport',
    cuttingReportPrintPOST: '/api/TblCuttingReport/CreateCuttingReport',
    cuttingReports: 'api/TblCuttingReport/GetCuttingInwardByDate'
}


const articleMaster = {
    articleMasterGET: '/api/TblArticleMaster/GetTblArticleMasters',
    articleMasterPOST: '/api/TblArticleMaster/CreateTblArticleMasterRangeInsert',
    articleMasterPATCH: '/api/TblArticleMaster/UpdateTblArticleMaster',
    articleMasterEditGET: '/api/TblArticleMaster/GetTblArticleMaster',
    articleMasterDELETE: '/api/TblArticleMaster/DeleteTblArticleMaster',
    articleMasterByArticleNoGET: '/api/TblArticleMaster/GetTblArticleMasterByArticleNo',
    articleMasterConsumedGET: '/api/TblArticleMaster/GetTblArticleMasterConsumed',
}

const seasonMaster = {
    seasonMasterGET: '/api/TblSeasonMaster/GetAllTblSeasonMaster',
    seasonMasterPOST: '/api/TblSeasonMaster/CreateSeasonMaster',
    seasonMasterGET_SINGLE_USER_ID: '/api/TblSeasonMaster/GetTblSeasonMaster',
    seasonMasterPATCH: '/api/TblSeasonMaster/UpdateSeasonMaster',
    seasonMasterDELETE: '/api/TblSeasonMaster/DeleteSeasonMaster'
};

const yearMaster = {
    yearMasterGET: '/api/TblYearMaster/GetAllTblYearMaster',
    yearMasterPOST: '/api/TblYearMaster/CreateYearMaster',
    yearMasterGET_SINGLE_USER_ID: '/api/TblYearMaster/GetTblYearMaster',
    yearMasterPATCH: '/api/TblYearMaster/UpdateYearMaster',
    yearMasterDELETE: '/api/TblYearMaster/DeleteYearMaster'
};

const yarnProjection = {
    yarnProjectionGET: '/api/TblYarnProjection/GetTblYarnProjections',
    yarnProjectionPOST: '/api/TblYarnProjection/CreateTblYarnProjection',
    yarnProjectionGET_SINGLE_USER_ID: '/api/TblYarnProjection/GetTblYarnProjection',
    yarnProjectionPATCH: '/api/TblYarnProjection/UpdateTblYarnProjection',
    yarnProjectionDELETE: '/api/TblYarnProjection/DeleteTblYarnProjection',
    yarnProjectionfetchPrNoGET1: '/api/TblYarnProjection/GetTblYarnProjectionsofGroupPRNo',
    yarnProjectionfetchPrNoGET: '/api/TblYarnProjection/GetTblYarnProjectionsByGroupPRNo',
    yarnProjectionfetchCombinedSlNo: '/api/TblYarnProjection/GetTblYarnProjectionGroupSlNo',
    yarnProjectionReportsGET: '/api/TblYarnProjection/GetTblYarnProjectionsofMonthAndYear',
    yarnProjectionReportsOverAllGET: 'api/TblYarnProjection/GetTblYarnProjectionsOverall',
    yarnProjectionOutstandingGET: '/api/TblYarnProjection/GetTblYarnProjectionOutstanding',
};

const costCenterReports = {
    getReports: '/api/TblBillEntries/GetBillEntryReportGeneralStyles',
    getStylePrepReports: '/api/TblBillEntries/GetBillEntriesReportPreparationStyles',
    getStylePrepReportsMonthlySplit: '/api/TblBillEntries/GetBillEntryReportGeneralStyles_MonthlySplitup',
    getStylePrepReportsItemSplit: '/api/TblBillEntries/GetBillEntryReportGeneralStyles_ItemSplitup'
}

const fabricProjection = {
    fabricProjectionGET: '/api/TblFabricProjection/GetTblFabricProjections',
    fabricProjectionPOST: '/api/TblFabricProjection/CreateTblFabricProjection',
    fabricProjectionGET_SINGLE_USER_ID: '/api/TblFabricProjection/GetTblFabricProjection',
    fabricProjectionPATCH: '/api/TblFabricProjection/UpdateTblFabricProjection',
    fabricProjectionDELETE: '/api/TblFabricProjection/DeleteTblFabricProjection',
    fabricProjectionfetchPrNoGET: '/api/TblFabricProjection/GetTblFabricProjectionsofGroupPRNo',
    fabricProjectionfetchCombinedSlNo: '/api/TblFabricProjection/GetTblFabricProjectionGroupSlNo',
    fabricProjectionPrint: '/api/TblFabricProjection/GetTblFabricProjectionsByGroupPRNo'

}


const cuttingProgram = {
    cuttingProgramDetailGet: '/api/TblSaleOrder/GetTblCuttingProgramReq',
    cuttingInwardDetailGet: '/api/TblSaleOrder/GetTblCuttingInwardReq',
    GetCUDConsolidatedReportAPI: '/api/TblSaleOrder/GetCUDConsolidatedReport',
    GetTblSaleOrderByStyle: '/api/TblSaleOrder/GetTblSaleOrderByStyle',
}



const stylePreparationsAllInformation = {
    allInformationGET: '/api/TblStyleDetail/GetTblStyleDetails'
};

const updateFabricPO = {
    updatefabricPoApiCall: '/api/TblFabricPODetail/GetStylePreParationbyStylemasterFabricUpdate'
};

const fabricInformation = {
    fabricGET: '/api/TblStylePrepFabric/GetTblStylePrepFabrics',
    fabricMasterAllGET: '/api/TblStylePrepFabric/GetTblStylePrepFabricMasterDetail',
    fabricByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStyles?Action=FABRICS',
    // fabricByStyleDetailIdGET: '/api/TblStylePrepFabric/CheckGetTblStylePrepFabric',
    fabricPOST: '/api/TblStylePrepFabric/CreateTblStylePrepFabricMultipleStyles',
    // fabricPOST: '/api/TblStylePrepFabric/CreateTblStylePrepFabric',
    fabricGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetTblStylePrepFabric',
    fabricPATCH: '/api/TblStylePrepFabric/UpdateTblStylePrepFabric',
    fabricDELETE: '/api/TblStylePrepFabric/DeletePartDetailsByGroupId?Action=FABRICS',
    // fabricDELETE: '/api/TblStylePrepFabric/DeleteTblStylePrepFabric'
    fabricInfoInvoiceGET: '/api/TblStylePrepFabric/GetTblStylePrepFabricPrint',
    updateSaleOrderAlterRegenerateGET: '/api/TblStylePrepYarn/UpdateSaleOrderAlterRegenerate',
    sendFabVerifyOTP: '/api/TblMail/SendApprovalOTP_EditSubStyleData',
    fabricInformationAddGET: '/api/TblStyleDetail/GetTblStyleDetailListByDetailMaterialCount'
};

const partDetails = {
    partDetailsGET: '/api/TblStylePrepPartDetail/GetTblStylePrepPartDetails',
    partDetailsPOST: '/api/TblStylePrepPartDetail/CreateTblStylePrepPartDetailMultipleStyles',
    partDetailsFabricGroupGET: '/api/TblStylePrepFabric/GetTblStylePrepFabricMasterPartsDetail',
    partDetailsByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStyles?Action=PARTDETAIL',
    fabricIdBasedOnFabricGroupAndFabricTypeGET: '/api/TblStylePrepPartDetail/GetYarnFabric?Action=FABRICS',
    yarnIdBasedOnYarnGroupAndYarnTypeGET: '/api/TblStylePrepPartDetail/GetYarnFabric?Action=YARN',
    partIdBasedOnPartGET: '/api/TblStylePrepPartDetail/GetYarnFabric?Action=PARTMASTER',

    // partDetailsByStyleDetailIdGET: '/api/TblStylePrepPartDetail/GetTblStylePrepPartDetailCollection',
    // partDetailsPOST: '/api/TblStylePrepPartDetail/CreateTblStylePrepPartDetail',
    partDetailsGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetDetailsByGroupId',
    // partDetailsGET_SINGLE_USER_ID: '/api/TblStylePrepPartDetail/GetTblStylePrepPartDetail',
    partDetailsPATCH: '/api/TblStylePrepFabric/UpdatePartdetailbyUniqueID',
    // partDetailsPATCH: '/api/TblStylePrepPartDetail/UpdateTblStylePrepPartDetail',
    partDetailsDELETE: '/api/TblStylePrepFabric/DeletePartDetailsByGroupId?Action=PARTDETAIL'
};

const partMaster = {
    partMasterGET: 'api/TblStylePrepPartMaster/GetTblStylePrepPartMasters',
    partMasterPOST: '/api/TblStylePrepPartMaster/CreateTblStylePrepPartMasterMultipleStyles',
    partMasterByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStyles?Action=PARTMASTER',
    // partMasterByStyleDetailIdGET: '/api/TblStylePrepPartMaster/CheckGetTblStylePrepPartMaster',
    partMasterGET_SINGLE_USER_ID: '/api/TblStylePrepPartMaster/GetTblStylePrepPartMaster',
    partMasterPATCH: '/api/TblStylePrepPartMaster/UpdateTblStylePrepPartMaster',
    partMasterDELETE: '/api/TblStylePrepFabric/DeletePartDetailsByGroupId?Action=PARTMASTER',
    printingTypeGET: '/api/TblPrintingPartDCDetail/GetPrintType',
    // partMasterDELETE: '/api/TblStylePrepPartMaster/DeleteTblStylePrepPartMaster'
};

const pcsWeight = {
    pcsWeightByIdGET: '/api/TblStylePrepPCSWeight/CheckGetTblStylePrepPCSWeight',
    pcsPartDetailInfoGET: '/api/TblStylePrepFabric/GetStylePartdetailInfo',
    pcsWeightByIdStyleGET: '/api/TblStylePrepPCSWeight/CheckGetTblStylePrepPCSWeightByStyle',
    // pcsWeightByIdGET: '/api/TblStylePrepPCSWeight/GetStylePrepPCSWeightByPartDetail',
    pcsWeightGET: '/api/TblStylePrepPCSWeight/GetAllStylePrepPCSWeight',
    // pcsWeightPOST: '/api/TblStylePrepPCSWeight/CreateTblStylePrepPCSWeightMultipleStyles',
    pcsWeightPOST: '/api/TblStylePrepPCSWeight/InsertStylePrepPCSWeightBulk',
    // pcsWeightPOST: '/api/TblStylePrepPCSWeight/CreateStylePrepPCSWeight',
    pcsWeightGET_SINGLE_USER_ID: '/api/TblStylePrepPCSWeight/GetStylePrepPCSWeight',
    pcsWeightPATCH: '/api/TblStylePrepPCSWeight/UpdateStylePrepPCSWeightBulk',
    // pcsWeightPATCH: '/api/TblStylePrepPCSWeight/UpdateStylePrepPCSWeight',
    pcsWeightDELETE: '/api/TblStylePrepPCSWeight/DeleteStylePrepPCSWeight',
    programMappingByNameGET: '/api/TblStylePrepPCSWeight/GetProgramMappingKgPcs',
    pcsWeightPartColor: '/api/TblStylePrepPartMaster/GetTblStylePrepPartInfo',
    pcsWeightPartColorName: '/api/TblStylePrepPartComboColor/CheckGetTblStylePrepPartComboColorPart',
    pcsWeightDropdownUpdate: '/api/TblStylePrepDia/UpdateStylePrepDiaByPCS'
};

const comboColor = {
    comboColorByIdGET: '/api/TblStylePrepPCSWeight/CheckGetTblStylePrepPCSWeight',
    // comboColorByIdGET: '/api/TblStylePrepPCSWeight/GetStylePrepPCSWeightByPartDetail',
    comboColorGET: '/api/TblStylePrepPartComboColor/CheckGetTblStylePrepPartComboColorStyleMasterdetail',
    comboColorLists: '/api/TblCuttingDCDetail/GetStylePartWithColor',
    comboColorResetGET: '/api/TblStylePrepPartComboColor/ResetTblStylePrepPartComboColor',
    // comboColorPOST: '/api/TblStylePrepPCSWeight/CreateTblStylePrepPCSWeightMultipleStyles',
    comboColorPOST: '/api/TblStylePrepPCSWeight/InsertStylePrepPCSWeightBulk',
    // comboColorPOST: '/api/TblStylePrepPCSWeight/CreateStylePrepPCSWeight',
    comboColorGET_SINGLE_USER_ID: '/api/TblStylePrepPCSWeight/GetStylePrepPCSWeight',
    comboColorPATCH: '/api/TblStylePrepPartComboColor/UpdateStylePrepPartComboColorBulk',
    // comboColorPATCH: '/api/TblStylePrepPartComboColor/UpdateStylePrepPartComboColor',
    comboColorDELETE: '/api/TblStylePrepPCSWeight/DeleteStylePrepPCSWeight',
    comboColorInvoiceGET: '/api/TblStylePrepPartComboColor/GetTblStylePrepComboColorPrint',
    foldingFabricPost: '/api/TblStylePrepPCSWeight/CreateStylePrepFoldingFabric',
    foldingFabricGet: '/api/TblStylePrepPCSWeight/GetTblStylePrepFoldingFabric',
    foldingFabricDelete: '/api/TblStylePrepPCSWeight/DeleteStylePrepFoldingFabric',
    foldingDetailGet: '/api/TblStylePrepPCSWeight/GetStyleWiseFoldingFabric',
};

const stylePreDia = {
    stylePreDiaByIdGET: '/api/TblStylePrepDia/CheckGetTblStylePrepDia',
    stylePreDiaByPartGET: '/api/TblStylePrepDia/GetStylePrepDiaByPart',
    stylePreDiaByStyleAndSubStyleGET: '/api/TblStylePrepDia/GetTblStylePrepDiastylemasteMultipleDetails',
    // stylePreDiaByIdGET: '/api/TblStylePrepDia/GetStylePrepDiaByPartDetail',
    stylePreDiaGET: '/api/TblStylePrepDia/GetAllStylePrepDia',
    stylePreDiaPOST: '/api/TblStylePrepDia/CreateTblStylePrepDiaMultipleStyles',
    // stylePreDiaPOST: '/api/TblStylePrepDia/CreateStylePrepDia',
    // stylePreDiaPOST: '/api/TblStylePrepDia/CreateStylePrepDia',
    stylePreDiaGET_SINGLE_USER_ID: '/api/TblStylePrepDia/GetStylePrepDia',
    stylePreDiaPATCH: '/api/TblStylePrepDia/UpdateStylePrepDia',
    stylePreDiaDELETE: '/api/TblStylePrepDia/DeleteStylePrepDia'
};

const yarnInformation = {
    yarnInformationGET: '/api/TblStylePrepYarn/GetTblStylePrepYarns',
    yarnMasterAllGET: '/api/TblYarnMaster/GetAllYarnMaster',
    yarnMasterAllByStyleGET: '/api/TblYarnMaster/GetAllYarnMasterByStyle',
    yarnInformationPOST: '/api/TblStylePrepYarn/CreateTblStylePrepYarnMultipleStyles',
    yarnByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStyles?Action=YARN',
    yarnByStyleDetailIdWithGroupDistinctGET: '/api/TblStylePrepFabric/GetstylePreInfoStyles?Action=YARNS',
    // yarnByStyleDetailIdGET: '/api/TblStylePrepYarn/CheckGetTblStylePrepYarn',
    // yarnInformationPOST: '/api/TblStylePrepYarn/CreateTblStylePrepYarn',
    yarnInformationGET_SINGLE_USER_ID: '/api/TblStylePrepYarn/GetTblStylePrepYarn',
    yarnInformationPATCH: '/api/TblStylePrepYarn/UpdateTblStylePrepYarn',
    yarnInformationDELETE: '/api/TblStylePrepFabric/DeletePartDetailsByGroupId?Action=YARNS'
    // yarnInformationDELETE: '/api/TblStylePrepYarn/DeleteTblStylePrepYarn'
};

const accessoriesRequirement = {
    accessoriesRequirementGET: '/api/TblStylePrepAccessoriesMaster/GetTblStylePrepAccessoriesMasters',
    accessoriesRequirementPOST: '/api/TblStylePrepAccessoriesMaster/CreateTblStylePrepAccessoriesMasterMultipleStyles1',
    // accessoriesRequirementPOST: '/api/TblStylePrepAccessoriesMaster/CreateTblStylePrepAccessoriesMasterMultipleStyles',
    // accessoriesRequirementByStyleDetailIdGET: '/api/TblStylePrepAccessoriesMaster/CheckGetTblStylePrepAccessoriesMaster',
    accessoriesRequirementByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCS?Action=ACCMAS',
    // accessoriesRequirementPOST: '/api/TblStylePrepAccessoriesMaster/CreateTblStylePrepAccessoriesMaster',
    // accessoriesRequirementGET_SINGLE_USER_ID: '/api/TblStylePrepAccessoriesMaster/GetTblStylePrepAccessoriesMaster',
    accessoriesRequirementGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCSByGroupId?Action=ACCMAS',
    // accessoriesRequirementPATCH: '/api/TblStylePrepAccessoriesMaster/UpdateTblStylePrepAccessoriesMaster',
    // accessoriesRequirementPATCH: '/api/TblStylePrepAccessoriesMaster/UpdateTblStylePrepAccessoriesMasterbyStyle',
    accessoriesRequirementPATCH: '/api/TblStylePrepAccessoriesMaster/UpdateTblStylePrepAccessoriesMasterbyStyle',
    accessoriesRequirementDELETE: '/api/TblStylePrepFabric/DeletestylePreInfoStylesKGPCSByUniqueId?Action=ACCMAS',
    verifiedAccessoriesReq: '/api/TblStylePrepPCSWeight/UpdateStylePrepAccessoriesMasterByStyle',
    accessoriesRequirementInvoiceGET: 'api/TblStylePrepAccessoriesMaster/GetTblStylePrepAccessoriesPrint'
};

const processCostPerKg = {
    processCostPerKgGET: '/api/TblStylePrepProcessCostKG/GetTblStylePrepProcessCostKGs',
    processCostPerKgInsertCostGET: '/api/TblStylePrepProcessCostKG/InsertStylePrepProcessCost',
    processCostPerKgInsertAllCostGET: '/api/TblStylePrepProcessCostKG/UpdateTblStylePrepProcessCostKGbyStyleAll',
    programProcessCostPerKgInsert2CostGET: '/api/TblStylePrepProcessCostKG/InsertStylePrepProcessCostByAddon',
    programProcessCostPerKgInsertCostGET: '/api/TblStylePrepProcessCostKG/CreateProcessAssignStyleMastersbystyle',
    checkProcessCostPerKgAddOnGET: '/api/TblStylePrepProcessCostKG/InsertCheckGetTblStylePrepProcessCostKGAddOn',
    checkProcessCostPerKgInsertCostGET: '/api/TblStylePrepProcessCostKG/InsertCheckGetTblStylePrepProcessCostKG',
    processCostPerKgCheckAssignGET: '/api/TblProcessAssignStyleMaster/CheckTblProcessAssignStyleMasterdetailByid',
    processCostPerKgPOST: '/api/TblStylePrepProcessCostKG/CreateTblStylePrepProcessCostKGMultipleStyles',
    // processCostPerKgByStyleDetailIdGET: '/api/TblStylePrepProcessCostKG/CheckGetTblStylePrepProcessCostKG',
    processCostPerKgByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCS?Action=KG',
    // processCostPerKgPOST: '/api/TblStylePrepProcessCostKG/CreateTblStylePrepProcessCostKG',
    processCostPerKgGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCSByGroupId?Action=KG',
    processCostPerKgPATCH: '/api/TblStylePrepProcessCostKG/UpdateTblStylePrepProcessCostKGbyStyle',
    processCostPerKgDELETE: '/api/TblStylePrepFabric/DeletestylePreInfoStylesKGPCSByUniqueId?Action=KG',
    processCostPerKgInvoiceGET: '/api/TblStylePrepProcessCostKG/GetTblStylePrepPrgmWiseCostPrint',
    GetFabricCostData: '/api/TblSaleOrder/GetTblStyleVerifyFabric',
    getprocessGetIdsForCheckout: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCSByGroupId?Action=ACCMASSTYLE',
    GetLoadProcessChecker: '/api/TblProcessAssignStyleMaster/CreateUpdateNewProgramWhileProcessChange',
    fabricCostingClose: '/api/TblCostingComparision/CreateTblFabricCostingS2'
};

const priceList = {
    priceListGET: '/api/TblPriceList/GetTblPriceLists',
    priceListGET_BY_ID: '/api/TblPriceList/GetTblPriceList',
    priceListPOST: '/api/TblPriceList/CreateTblPriceList',
    priceListPATCH: '/api/TblPriceList/UpdateTblPriceList',
    priceListDELETE: '/api/TblPriceList/DeleteTblPriceList'
};

const processCostPerPcsDetails = {
    processCostPerPcsDetailsGET: '/api/TblStylePrepProcessCostPCDetail/GetTblStylePrepProcessCostPCDetails',
    processCostPerPcsDetailsPOST: '/api/TblStylePrepProcessCostPCDetail/CreateTblStylePrepProcessCostPCDetailMultipleStyles',
    // processCostPerPcsByStyleDetailIdGET: '/api/TblStylePrepProcessCostPCDetail/CheckGetTblStylePrepProcessCostPCDetail',
    processCostPerPcsByStyleDetailIdGET: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCS?Action=PCS',
    // processCostPerPcsPOST: '/api/TblStylePrepProcessCostPC/CreateTblStylePrepProcessCostPC',
    processCostPerPcsDetailsGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetstylePreInfoStylesKGPCSByGroupId?Action=PCS',
    processCostPerPcsDetailsPATCH: '/api/TblStylePrepProcessCostPCDetail/UpdateStylePrepProcessCostPCDetailbyUniqueID',
    processCostPerPcsDetailsDELETE: '/api/TblStylePrepFabric/DeletestylePreInfoStylesKGPCSByUniqueId?Action=PCS',
    ratePerPcsInvoiceDataGET: '/api/TblTempStyleDetail/GetTblStylePreparationCost',
    processCostPerPcsInvoiceGET: '/api/TblStylePrepProcessCostPC/GetTblStylePrepCostPerPCs'
};

const stylePreparation = {
    stylePreparationAddSelectedStyleGET: '/api/TblTempStyleDetail/GetStyleDetail',
    stylePreparationAddSelectedStylePOST: '/api/TblTempStyleDetail/CreateTempStyleDetail',
    stylePreparationAddSelectedStyleGET_SINGLE_USER_ID: '/api/TblStylePrepFabric/GetTblStylePrepFabric',
    stylePreparationAddSelectedStylePATCH: '/api/TblStylePrepFabric/UpdateTblStylePrepFabric',
    stylePreparationAddSelectedStyleDELETE: '/api/TblStylePrepFabric/DeleteTblStylePrepFabric',
    stylePrepInvoiceGET: '/api/TblTempStyleDetail/GetTblStylePreparationPrint'
};

const fabricPoMaster = {
    fabricPoMasterGET: '/api/TblFabricPO/GetTblFabricPOs',
    fabricPoMasterPOST: '/api/TblFabricPO/CreateTblFabricPO',
    fabricPoMasterGETID: '/api/TblFabricPO/GetTblFabricPO',
    fabricPoMasterPATCH: '/api/TblFabricPO/UpdateTblFabricPO',
    fabricPoMasterDELETE: '/api/TblFabricPO/DeleteTblFabricPO',
    fabricPoInvoiceGET: '/api/TblFabricPO/TblFabricPOPrint'
};

const fabricPoMasterDK = {
    fabricPoMasterDKGET: '/api/TblFabricPOBulk/GetTblFabricPOBulks',
    fabricPoDKInvoiceGET: '/api/TblFabricPOBulk/TblFabricPOBulkPrint',
    fabricPoMasterDKPOST: '/api/TblFabricPOBulk/CreateTblFabricPOBulk',
    fabricPoMasterDKGETID: '/api/TblFabricPOBulk/GetTblFabricPOBulk',
    fabricPoMasterDKPATCH: '/api/TblFabricPOBulk/UpdateTblFabricPOBulk',
    fabricPoMasterDKDELETE: '/api/TblFabricPOBulk/DeleteTblFabricPOBulk'
};

const generalPoMasterDK = {
    generalPoMasterDKGET: '/api/TblGeneralPOBulk/GetTblGeneralPOBulks',
    generalPoMasterDKPOST: '/api/TblGeneralPOBulk/CreateTblGeneralPOBulk',
    generalPoMasterDKGETID: '/api/TblGeneralPOBulk/GetTblGeneralPOBulk',
    generalPoMasterDKPATCH: '/api/TblGeneralPOBulk/UpdateTblGeneralPOBulk',
    generalPoMasterDKDELETE: '/api/TblGeneralPOBulk/DeleteTblGeneralPOBulk',
    generalPoDKInvoiceGET: '/api/TblGeneralPOBulk/TblGeneralPOBulkPrint',
    generalPOStyleDKGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasic'
};

const accessoriesPoMasterDK = {
    accessoriesPoMasterDKGET: '/api/TblAccessoriesPOBulk/GetTblAccessoriesPOBulks',
    accessoriesPoMasterDKPOST: '/api/TblAccessoriesPOBulk/CreateTblAccessoriesPOBulk',
    accessoriesPoMasterDKGETID: '/api/TblAccessoriesPOBulk/GetTblAccessoriesPOBulk',
    accessoriesPoMasterDKPATCH: '/api/TblAccessoriesPOBulk/UpdateTblAccessoriesPOBulk',
    accessoriesPoMasterDKDELETE: '/api/TblAccessoriesPOBulk/DeleteTblAccessoriesPOBulk',
    accessoriesPoProgramGET: '/api/TblAccessoriesPOBulk/GetTblProgramList',
    accessoriesPOStyleDKGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasic',
    accessoriesPoDKInvoiceGET: '/api/TblAccessoriesPOBulk/TblAccessoriesPOBulkPrint',
    accessoriesPoMasterPONoDKGET: '/api/TblAccessoriesPOBulk/GetTblAccessoriesPOBulkPONo'
};

const fabricPoDetails = {
    fabricPoDetailsGET: '/api/TblFabricPODetail/GetTblFabricPODetails',
    fabricPoDetailsGET_BY_ID: '/api/TblFabricPODetail/GetTblFabricPODetailofPO',
    fabricPoDetailsPOST: '/api/TblFabricPODetail/CreateTblFabricPODetail',
    fabricPoDetailsPOSTBulk: '/api/TblFabricPODetail/CreateTblFabricPODetailsBulk',
    fabricPoDetailsGETID: '/api/TblFabricPODetail/GetTblFabricPODetail',
    fabricPoDetailsPATCH: '/api/TblFabricPODetail/UpdateReCreateTblFabricPODetail',
    fabricPoDetailsDELETE: '/api/TblFabricPODetail/DeleteTblFabricPODetail',
    fabricPOFabricGroupList: '/api/TblFabricMaster/GetAllFabricMaster',
    fabricP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterFabric',
    // fabricP0DetailsUpdateListGET: '/api/TblSaleOrder/UpdateStylePreParationbyStylemasterFabric',
    fabricP0DetailsUpdateListGET: '/api/TblSaleOrder/UpdateStylePreParationbyStylemasterFabrics',
    FabricDCDetailsDiaFrmStyleGET: '/api/TblFabricPODetail/GetStylePrepDia',
    FabricPODetailsGaugeFrmStyleGET: '/api/TblFabricPODetail/GetStylePrepLoopGauge',
    FabricPODetailsLoopFrmStyleGET: '/api/TblFabricPODetail/GetStylePrepLoopLength',
    fabricCurrentRate: '/api/TblSaleOrder/GetYarnFabricPORaisedQty',
    editPrevListGetFabric: 'api/TblFabricPODetail/GetTblFabricPODetailofPODetailNo'
};

const fabricPoDetailsDK = {
    fabricPoDetailsDKGET: '/api/TblFabricPODetailBulk/GetTblFabricPODetailBulks',
    fabricPoDetailsDKGET_BY_ID: '/api/TblFabricPODetailBulk/GetTblFabricPODetailBulkofPO',
    fabricPoDetailsDKPOST: '/api/TblFabricPODetailBulk/CreateTblFabricPODetailBulk',
    fabricPoDetailsDKGETID: '/api/TblFabricPODetailBulk/GetTblFabricPODetailBulk',
    fabricPoDetailsDKPATCH: '/api/TblFabricPODetailBulk/UpdateTblFabricPODetailBulk',
    fabricPoDetailsDKDELETE: '/api/TblFabricPODetailBulk/DeleteTblFabricPODetailBulk',
    fabricPoDetailsDKPreviousGetListGET: '/api/TblFabricPOBulk/GetPreviousTblFabricPOBulks'
};

const generalPoDetailsDK = {
    generalPoDetailsDKGET: '/api/TblGeneralPODetailBulk/GetTblGeneralPODetailBulks',
    generalPoDetailsDKGET_BY_ID: '/api/TblGeneralPODetailBulk/GetTblGeneralPODetailBulkofPO',
    generalPoDetailsDKPOST: '/api/TblGeneralPODetailBulk/CreateTblGeneralPODetailBulk',
    generalPoDetailsDKGETID: '/api/TblGeneralPODetailBulk/GetTblGeneralPODetailBulk',
    generalPoDetailsDKPATCH: '/api/TblGeneralPODetailBulk/UpdateTblGeneralPODetailBulk',
    generalPoDetailsDKDELETE: '/api/TblGeneralPODetailBulk/DeleteTblGeneralPODetailBulk',
    generalPoDetailsDKPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterFabric'
};

const accessoriesPoDetailsDK = {
    accessoriesPoDetailsDKGET: '/api/TblAccessoriesPODetailBulk/GetTblAccessoriesPODetailBulks',
    accessoriesPoDetailsDKGET_BY_ID: '/api/TblAccessoriesPODetailBulk/GetTblAccessoriesPODetailBulkofPO',
    accessoriesPoDetailsDKPOST: '/api/TblAccessoriesPODetailBulk/CreateTblAccessoriesPODetailBulk',
    accessoriesPoDetailsDKGETID: '/api/TblAccessoriesPODetailBulk/GetTblAccessoriesPODetailBulk',
    accessoriesPoDetailsDKPATCH: '/api/TblAccessoriesPODetailBulk/UpdateTblAccessoriesPODetailBulk',
    accessoriesPoDetailsDKDELETE: '/api/TblAccessoriesPODetailBulk/DeleteTblAccessoriesPODetailBulk',
    accessoriesPoDetailsDKPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterFabric'
};

const yarnPO = {
    yarnP0GET: '/api/TblYarnPO/GetTblYarnPOs',
    yarnP0InvoiceGET: '/api/TblYarnPO/TblYarnPOPrint',
    yarnPOPOST: '/api/TblYarnPO/CreateTblYarnPO',
    yarnPOGETID: '/api/TblYarnPO/GetTblYarnPO',

    yarnPOPATCH: '/api/TblYarnPO/UpdateTblYarnPO',
    yarnPODELETE: '/api/TblYarnPO/DeleteTblYarnPO',
    yarnPOSectionGET: '/api/TblSection/GetTblSectionsofUnit',
    yarnPOSupplierGET: '/api/TblYarnPO/GetLoadBuyerUsingFilter',
    yarnPOUnitGET: '/api/TblUnitMaster/GetTblUnitListofCompany',
    yarnPOPendingSupplierGET: '/api/TblYarnInward/GetInwardSupplier',
    yarnPOPendingDeliveryAtGET: '/api/TblProgramSupplier/GetLoadBuyerUsingFilter?FldControllerName=TblProgramSupplier',
    yarnPOProgramGET: '/api/TblYarnPO/GetTblProgramList',
    yarnPOSalesOrderList: '/api/TblSaleOrder/GetPendingTblSaleOrder',
    yarnPOSalesOrderListNewApi: '/api/TblYarnInwardDetail/GetPendingSaleOrderByProgram',
    yarnPOStyleMasterList: '/api/TblStyleMaster/GetTblStyleMasterofSaleOrder',
    yarnP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterYarn',
    yarnLotNoInvoiceGET: '/api/TblKnittingDC/TblKnittingDCLotPrint',
    millNoLists: '/api/TblYarnPODetail/GetMillProjectionInfo'
};

const fabricPo = {
    fabricPOGETID: '/api/TblFabricPO/GetTblFabricPO'
};

const getLoadingContentforSalesOrder = {
    loadingContent: '/api/TblSaleOrder/CheckDemand'
}


const getLoadingDemandforSalesOrder = {
    demandContent: 'api/TblSaleOrder/GenerateDemandUsingTempTable'
}


const yarnPODK = {
    yarnP0DKGET: '/api/TblYarnPOBulk/GetTblYarnPOs',
    yarnPODKPOST: '/api/TblYarnPOBulk/CreateTblYarnPOBulk',
    yarnPODKGETID: '/api/TblYarnPOBulk/GetTblYarnPOBulk',
    yarnPODKInvoiceGET: '/api/TblYarnPOBulk/TblYarnPOBulkPrint',
    yarnPODKPATCH: '/api/TblYarnPOBulk/UpdateTblYarnPOBulk',
    yarnPODKDELETE: '/api/TblYarnPOBulk/DeleteTblYarnPOBulk',
    yarnPODKProgramGET: '/api/TblYarnPOBulk/GetTblProgramList',
    yarnPOSupplierDKGET: '/api/TblYarnPOBulk/GetLoadBuyerUsingFilter',
    yarnPODKEditIdGET: '/api/TblYarnPOBulk/GetYarnPOEditId'
};

const section = {
    sectionGET: '/api/TblSection/GetTblSections',
    sectionPOST: '/api/TblSection/CreateTblSection',
    sectionGETID: '/api/TblSection/GetTblSection',
    sectionPATCH: '/api/TblSection/UpdateTblSection',
    sectionDELETE: '/api/TblSection/DeleteTblSection'
};

const warehouseStyle = {
    GETAllWarehouseStyle: '/api/TblWHStyleMaster/GetTblWHStyleMasters',
    GETBYIDWarehouseStyle: '/api/TblWHStyleMaster/GetTblWHStyleMaster',
    POSTWarehouseStyle: '/api/TblWHStyleMaster/CreateTblWHStyleMaster',
    PATCHWarehouseStyle: '/api/TblWHStyleMaster/UpdateTblWHStyleMaster',
    DELETEWarehouseStyle: '/api/TblWHStyleMaster/DeleteTblWHStyleMaster',
    PRINTWarehouseStyle: '/api/TblWHStyleMaster/TblWHStylePrint'
}

const styleUpCharge = {
    getStyleUpChargeKGSDashboard: '/api/TblUpchargeProcessCostKG/GetStyleUpchargeInfoKGPCS',
    getStyleUpChargeKGSProgram: '/api/TblUpchargeProcessCostKG/GetStyleUpchargeInfoKGPCSByProgram',
    getAccessoriesList: '/api/TblUpchargeAccessoriesMasterRequirement/GetStyleAccessoriesByAccessories',
    postStyleUpChargeKGS: '/api/TblUpchargeProcessCostKG/CreateTblUpchargeProcessCostKGBulk',
    getDetailsStyleUpChargeKGS: '/api/TblUpchargeProcessCostKG/GetStyleUpchargeInfoKGDtl',
    upChargeVerify: '/api/TblUpchargeProcessCostKG/UpdateUpchargeVerify',
    upChargeAuthorize: '/api/TblUpchargeProcessCostKG/UpdateUpchargeAuthorize',
    upChargeVerifyAuthorize: '/api/TblUpchargeProcessCostKG/UpdateUpchargeVerify_Authorize',
    deleteStyleUpCharge: '/api/TblUpchargeProcessCostKG/DeleteTblUpchargeProcessCostKG',
    postStyleUpChargePCS: '/api/TblUpchargeProcessCostPCDetail/CreateTblUpchargeProcessCostPCBulk',
    getDetailsStyleUpChargePCS: '/api/TblUpchargeProcessCostPCDetail/GetStyleUpchargeInfoPCDtl',
    postStyleUpChargeAcc: '/api/TblUpchargeAccessoriesMasterRequirement/CreateTblUpchargeAccessoriesMasterRequirementBulk',
    deletePcsWeight: '/api/TblUpchargeProcessCostPCDetail/DeleteTblUpchargeProcessCostPCDetail',
    getDetailsStyleUpChargeACC: '/api/TblUpchargeAccessoriesMasterRequirement/GetStyleUpchargeInfoAccDtl',
    deleteAccReq: '/api/TblUpchargeAccessoriesMasterRequirement/DeleteTblUpchargeAccessoriesByAccessories',
    accessoriesDropDownData: '/api/TblUpchargeAccessoriesMasterRequirement/GetStyleAccessoriesListByStyle',
    upchargeReportsAll: '/api/TblUpchargeProcessCostKG/GetStyleUpchargeReportByStyle'
}

const salesOrderReqAproval = {
    salesOrderReqDashboardGet: '/api/TblSaleOrder/GetTblSOForReqrmnts',
    salesOrderReqDetailGet: '/api/TblSaleOrder/GetTblSOForReqrmntsDtl',
    salesOrderReqAuthorize: '/api/TblSaleOrder/UpdateTblSORqrmntAuthorize',
    salesOrderDelete: '/api/TblSaleOrder/DeleteSORqrmnt'

}

const warehouseStyleDetail = {
    GETAllWarehouseStyleDetail: '/api/TblWHStyleDetail/GetTblWHStyleDetails',
    GETBYIDWarehouseStyleDetail: '/api/TblWHStyleDetail/GetTblWHStyleDetail',
    POSTWarehouseStyleDetail: '/api/TblWHStyleDetail/CreateTblWHStyleDetailRangeInsert',
    DELETEWarehouseStyleDetail: '/api/TblWHStyleDetail/DeleteTblWHStyleDetail',
    GETAllProductStocks: '/api/TblProductStock/GetAllTblProductStocksForWHStyleDetail'
}


const yarnPODetails = {
    yarnP0DetailsGET: '/api/TblYarnPODetail/GetTblYarnPODetails',
    yarnP0DetailsGET_BY_ID: '/api/TblYarnPODetail/GetTblYarnPODetailofPO',
    yarnPODetailsPOST: '/api/TblYarnPODetail/CreateTblYarnPODetail',
    yarnPODetailsGETID: '/api/TblYarnPODetail/GetTblYarnPODetail',
    yarnPODetailsPATCH: '/api/TblYarnPODetail/UpdateTblYarnPODetail',
    yarnPODetailsWithPendingIdPATCH: '/api/TblYarnPODetail/UpdateReCreateTblYarnPODetail',
    yarnPODetailsDELETE: '/api/TblYarnPODetail/DeleteTblYarnPODetail',
    yarnPODetailsYarnGroupList: '/api/TblYarnMaster/GetAllYarnMaster',
    yarnP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterYarn',
    yarnP0DetailsApproveStatusChangeGET: '/api/TblYarnPO/UpdateTblYarnPOApproval',
    // yarnP0DetailsUpdateListGET: '/api/TblSaleOrder/UpdateStylePreParationbyStylemasterYarn',
    yarnP0DetailsUpdateListGET: '/api/TblSaleOrder/UpdateStylePreParationbyStylemasterYarns',
    editPrevListGet: 'api/TblYarnPODetail/GetTblYarnPOMultipleDetailofPODetailNo'

};

const yarnPODKDetails = {
    yarnP0DKDetailsGET: '/api/TblYarnPODetailBulk/GetTblYarnPODetailBulks',
    yarnP0DKDetailsGET_BY_ID: '/api/TblYarnPODetailBulk/GetTblYarnPODetailBulkofPO',
    yarnPODKDetailsPOST: '/api/TblYarnPODetailBulk/CreateTblYarnPODetailBulk',
    yarnPODKDetailsGETID: '/api/TblYarnPODetailBulk/GetTblYarnPODetailBulk',
    yarnPODKDetailsPATCH: '/api/TblYarnPODetailBulk/UpdateTblYarnPODetailBulk',
    yarnPODKDetailsDELETE: '/api/TblYarnPODetailBulk/DeleteTblYarnPODetailBulk'
};

const requestForm = {
    requestFormGET: '/api/TblRequestForm/GetAllTblRequestForm',
    requestFormPOST: '/api/TblRequestForm/CreateRequestForm',
    requestFormGET_SINGLE_USER_ID: '/api/TblRequestForm/GetTblRequestForm',
    requestFormMultipleGET: '/api/TblRequestForm/GetTblRequestForms',
    requestFormMultipleclose: '/api/TblRequestForm/UpdateClose'
};

const knittingDCMaster = {
    knittingDCMasterGET: '/api/TblKnittingDC/GetTblKnittingDCs',
    knittingDCSupplierListMasterGET: '/api/TblYarnPO/GetLoadBuyerUsingFilter',
    knittingDCMasterPOST: '/api/TblKnittingDC/CreateTblKnittingDC',
    knittingDCMasterGETID: '/api/TblKnittingDC/GetTblKnittingDC',
    knittingDCMasterPATCH: '/api/TblKnittingDC/UpdateTblKnittingDC',
    knittingDCMasterDELETE: '/api/TblKnittingDC/DeleteTblKnittingDC',
    knittingDCMasterOfYarnPOGET: '/api/TblKnittingDCDetailBulk/GetPONOOfYarnPOBulks',
    knittingDCInvoiceGET: '/api/TblKnittingDC/TblKnittingDCPrint',
    knittingDCInvoiceGETSecond: '/api/TblKnittingDC/TblKnittingDCPrint2'
};

const knittingDCMasterDK = {
    knittingDCMasterDKGET: '/api/TblKnittingDCBulk/GetTblKnittingDCBulks',
    knittingDCDKInvoiceGET: '/api/TblKnittingDCBulk/TblKnittingDCBulkPrint',
    knittingDCMasterDKOfYarnPOGET: '/api/TblKnittingDCDetailBulk/GetPONOOfYarnPOBulks',
    knittingDCMasterDKGRNByYarnPOGET: '/api/TblKnittingDCDetailBulk/GetYarnInwardDetailBulks',
    knittingDCMasterDKPOST: '/api/TblKnittingDCBulk/CreateTblKnittingDCBulk',
    knittingDCMasterDKGETID: '/api/TblKnittingDCBulk/GetTblKnittingDCBulk',
    knittingDCMasterDKPATCH: '/api/TblKnittingDCBulk/UpdateTblKnittingDCBulk',
    knittingDCMasterDKDELETE: '/api/TblKnittingDCBulk/DeleteTblKnittingDCBulk',
    knittingDCMasterDFabricByYarnPOGET: 'api/TblFabricMaster/GetTblFabricMasterId',
    postKnittBulkCloseIcon: '',
    updateAllKnittBulkCloseIcon: ''
};

const stitchingDCMaster = {
    stitchingDCMasterGET: '/api/TblStitchingDC/GetTblStitchingDCs',
    stitchingDCSupplierListMasterGET: '/api/TblYarnPO/GetLoadBuyerUsingFilter',
    stitchingDCMasterPOST: '/api/TblStitchingDC/CreateTblStitchingDC',
    stitchingDCMasterGETID: '/api/TblStitchingDC/GetTblStitchingDC',
    stitchingDCMasterPATCH: '/api/TblStitchingDC/UpdateTblStitchingDC',
    stitchingDCMasterDELETE: '/api/TblStitchingDC/DeleteTblStitchingDC',
    stitchingDCMasterOfYarnPOGET: '/api/TblStitchingDCDetailBulk/GetPONOOfYarnPOBulks',
    stitchingDCInvoiceGET: '/api/TblStitchingDC/TblStitchingDCPrint',
    stitchingDCAccessGET: '/api/TblStitchingDC/TblStitchingAccessoriesPrint',
    stitchingDCBarcodeeGET: '/api/TblStitchingDC/GetTblBCTemplateByStitchingDC',
    stitchingDCBarcodeePrintGET: '/api/TblStitchingDC/GetTblBCTemplateByStitchingDCPrint',

    stitchingDCDetailGet: 'api/TblStitchingDCDetail',
    stitchingDeliveryNotePrint: 'api/TblStitchingDC/TblSTDDeliveryNotesPrint',
    barcodeToggle: 'api/TblStitchingDCDetail/ToggleTblDCBarCode',
    barcodeToggleShowHide: '/api/TblStitchingDCDetail/ToggleDCBarPrintCode',
    // stitchingBundleGet: '/api/TblStitchingDCDetail/GetTblStitchingDCInwardBundleofDC',

    stitchingBundleGet: 'api/TblStitchingDCDetail/GetPreviousProgramBundle'
};

const despatchDCMaster = {
    despatchDCMasterGET: '/api/TblDespatchDC/GetTblDespatchDCs',
    despatchDCSupplierListMasterGET: '/api/TblYarnPO/GetLoadBuyerUsingFilter',
    despatchDCMasterPOST: '/api/TblDespatchDC/CreateTblDespatchDC',
    despatchDCMasterGETID: '/api/TblDespatchDC/GetTblDespatchDC',
    despatchDCMasterPATCH: '/api/TblDespatchDC/UpdateTblDespatchDC',
    despatchDCMasterDELETE: '/api/TblDespatchDC/DeleteTblDespatchDC',
    despatchDCMasterOfYarnPOGET: '/api/TblDespatchDCDetailBulk/GetPONOOfYarnPOBulks',
    despatchDCInvoiceGET: '/api/TblDespatchDC/TblDespatchDCPrint',
    despatchSupplierList: '/api/TblProgramSupplier/GetLoadBuyerUsingFilter?FldControllerName=TblDespatchDC'
};

const generalDCMasterDK = {
    generalDCMasterDKGET: '/api/TblGeneralDCBulk/GetTblGeneralDCBulks',
    generalDCMasterDKPOST: '/api/TblGeneralDCBulk/CreateTblGeneralDCBulk',
    generalDCMasterDKGETID: '/api/TblGeneralDCBulk/GetTblGeneralDCBulk',
    generalDCMasterDKPATCH: '/api/TblGeneralDCBulk/UpdateTblGeneralDCBulk',
    generalDCMasterDKDELETE: '/api/TblGeneralDCBulk/DeleteTblGeneralDCBulk',
    generalDCDKInvoiceGET: '/api/TblGeneralDCBulk/TblGeneralDCBulkPrint',
    generalDCStyleDKGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasic'
};

const accessoriesDCMasterDK = {
    accessoriesDCMasterDKGET: '/api/TblAccessoriesDCBulk/GetTblAccessoriesDCBulks',
    accessoriesDCMasterDKPOST: '/api/TblAccessoriesDCBulk/CreateTblAccessoriesDCBulk',
    accessoriesDCMasterDKGETID: '/api/TblAccessoriesDCBulk/GetTblAccessoriesDCBulk',
    accessoriesDCMasterDKPATCH: '/api/TblAccessoriesDCBulk/UpdateTblAccessoriesDCBulk',
    accessoriesDCMasterDKDELETE: '/api/TblAccessoriesDCBulk/DeleteTblAccessoriesDCBulk',
    accessoriesDCStyleDKGET: '/api/TblStyleMasterBasic/GetAllTblStyleMasterBasic',
    accessoriesDCDKInvoiceGET: '/api/TblAccessoriesDCBulk/TblAccessoriesDCBulkPrint'
    //accessoriesDCMasterDKOfAccessoriesPOGET: '/api/TblAccessoriesDCDetailBulk/GetPONOOfAccessoriesPOBulks',
};

const knittingDCDetails = {
    knittingDCDetailsGET: '/api/TblKnittingDCDetail/GetTblKnittingDCDetails',
    knittingDCDetailsFabricFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepFabric',
    knittingDCDetailsDiaFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepDia',
    knittingDCDetailsRatePrKgFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepCost',
    knittingDCDetailsGET_BY_ID: '/api/TblKnittingDCDetail/GetTblKnittingDCDetailofDC',
    knittingDCDetailsPOST: '/api/TblKnittingDCDetail/CreateTblKnittingDCDetail',
    knittingDCDetailsGETID: '/api/TblKnittingDCDetail/GetTblKnittingDCDetail',
    knittingDCDetailsPATCH: '/api/TblKnittingDCDetail/UpdateTblKnittingDCDetail',
    knittingDCDetailsDELETE: '/api/TblKnittingDCDetail/DeleteTblKnittingDCDetail',
    knittingDcDetailsColorFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepColour',
    knittingDcDetailsColorFrmStyleDyeingGET: '/api/TblDyeingDCDetail/GetStylePrepColour',
    knittingDcDetailsRateFrmStyleGET: '/api/TblDyeingDCDetail/GetStylePrepCost',
    knittingDcDetailsPreviousGetListGET: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    knittingFabricdropGetList: 'api/TblFabricMaster/GetTblFabricMasterId',
    knittingFldProgram: 'api/TblknittingDC/GetTblknittingDC',
    knittingDCDetailsGaugeFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepLoopGauge',
    knittingDCDetailsLoopLengthFrmStyleGET: '/api/TblKnittingDCDetail/GetStylePrepLoopLength',
    knittingDcDetailsGetListYarnStockGET: '/api/TblYarnInwardDetail/GetListForYarnStock',
};

const stitchingDCDetails = {
    stitchingDCDetailsGET: '/api/TblStitchingDCDetail/GetTblStitchingDCDetails',
    stitchingDCDetailsSecondGridGET: '/api/TblStitchingDCDetail/GetStitchingDN',
    stitchingDCDetailsFirstGridGET: '/api/TblStitchingDCDetail/GetStitchingQty',
    // stitchingDCDetailsFirstGridGET: '/api/TblYarnInwardDetail/',

    stitchingDCDetailsGET_BY_ID: '/api/TblStitchingDCDetail/GetTblStitchingDCDetailofDC',
    stitchingDCDetailsDNGET_BY_ID: '/api/TblStitchingDCDetail/GetTblStitchingDNofDC',
    stitchingDCDetailsPOST: '/api/TblStitchingDCDetail/CreateTblStitchingDCDetail',
    stitchingDCDetails2POST: '/api/TblStitchingDCDetail/CreateTblStitchingDNQty',
    stitchingDCDetailsGETID: '/api/TblStitchingDCDetail/GetTblStitchingDCDetail',
    stitchingDCDetailsPATCH: '/api/TblStitchingDCDetail/UpdateTblStitchingDCDetail',
    stitchingDCDetailsDELETE: '/api/TblStitchingDCDetail/DeleteTblStitchingDCDetail',
    stitchingDcDetailsPreviousGetListGET: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    stitchingBarcodeGet: 'api/TblBarcodeTemplate',
    stitchingWithAccGet: 'api/TblStitchingDCDetail',
    stitchingWithDNPost: '/api/TblStitchingDCDetail/CreateTblStitchingDNQty',
    stitchingAccessoriesDELETE: '/api/TblStitchingDCDetail/DeleteTblStichingAccessoriesDCDetail',
    stitchingBarCodeDELETE: '/api/TblStitchingDCDetail/DeleteTblStitchingDCBarCode',
    RestitchingDCDetailsPOST: '/api/TblStitchingDCDetail/ReCreateTblStitchingDCDetail',
    stitchingFoldingFabric: '/api/TblStylePrepPCSWeight/GetFoldingFabricValueByStyle',
    foldingFabricPrint: '/api/TblStitchingDC/TblStitchingFoldingFabricPrint',
    getStitchingReports: '/api/TblReports/GetStitchingReports'

};

const despatchDCDetails = {
    despatchDCDetailsGET: '/api/TblDespatchDCDetail/GetTblDespatchDCDetails',
    despatchDCDetailsSecondGridGET: '/api/TblDespatchDCDetail/GetDespatchDN',
    despatchDCDetailsFirstGridGET: '/api/TblDespatchDCDetail/GetDespatchQty',
    despatchDCDetailsGET_BY_ID: '/api/TblDespatchDCDetail/GetTblDespatchDCDetailofDC',
    despatchDCDetailsPOST: '/api/TblDespatchDCDetail/GetDEDQty',
    despatchDCDetails2POST: '/api/TblDespatchDCDetail/CreateTblDespatchDCDetailsBulk',
    // despatchDCDetails2POST: '/api/TblDespatchDCDetail/CreateTblDespatchDCDetail',
    // despatchDCDetails2POST: '/api/TblDespatchDCDetail/CreateTblDespatchDNQty',
    despatchDCDetailsGETID: '/api/TblDespatchDCDetail/GetTblDespatchDCDetail',
    despatchDCDetailsPATCH: '/api/TblDespatchDCDetail/UpdateTblDespatchDCDetail',
    despatchDCDetailsDELETE: '/api/TblDespatchDCDetail/DeleteTblDespatchDCDetail',
    despatchDcDetailsPreviousGetListGET: '/api/TblDespatchDCDetail/GetPreviousGetList'
};

const knittingDCDetailsDK = {
    knittingDCDetailsDKGET: '/api/TblKnittingDCDetailBulk/GetTblKnittingDCDetailBulks',
    knittingDCDetailsDKGET_BY_ID: '/api/TblKnittingDCDetailBulk/GetTblKnittingDCDetailBulkofDC',
    knittingDCDetailsDKPOST: '/api/TblKnittingDCDetailBulk/CreateTblKnittingDCDetailBulk',
    knittingDCDetailsDKGETID: '/api/TblKnittingDCDetailBulk/GetTblKnittingDCDetailBulk',
    knittingDCDetailsDKPATCH: '/api/TblKnittingDCDetailBulk/UpdateTblKnittingDCDetailBulk',
    knittingDCDetailsDKDELETE: '/api/TblKnittingDCDetailBulk/DeleteTblKnittingDCDetailBulk',
    knittingDCDetailsDKPreviousGetListGET: '/api/TblYarnPO/GetPreviousTblYarnPOs'
};

const generalDCDetailsDK = {
    generalDCDetailsDKGET: '/api/TblGeneralDCDetailBulk/GetTblGeneralDCDetailBulks',
    generalDCDetailsDKGET_BY_ID: '/api/TblGeneralDCDetailBulk/GetTblGeneralDCDetailBulkofDC',
    generalDCDetailsDKPOST: '/api/TblGeneralDCDetailBulk/CreateTblGeneralDCDetailBulk',
    generalDCDetailsDKGETID: '/api/TblGeneralDCDetailBulk/GetTblGeneralDCDetailBulk',
    generalDCDetailsDKPATCH: '/api/TblGeneralDCDetailBulk/UpdateTblGeneralDCDetailBulk',
    generalDCDetailsDKDELETE: '/api/TblGeneralDCDetailBulk/DeleteTblGeneralDCDetailBulk',
    generalDCDetailsDKPreviousGetListGET: '/api/TblYarnPO/GetPreviousTblYarnPOs'
};

const accessoriesDCDetailsDK = {
    accessoriesDCDetailsDKGET: '/api/TblAccessoriesDCDetailBulk/GetTblAccessoriesDCDetailBulks',
    accessoriesDCDetailsDKGET_BY_ID: '/api/TblAccessoriesDCDetailBulk/GetTblAccessoriesDCDetailBulkofDC',
    accessoriesDCDetailsDKPOST: '/api/TblAccessoriesDCDetailBulk/CreateTblAccessoriesDCDetailBulk',
    accessoriesDCDetailsDKGETID: '/api/TblAccessoriesDCDetailBulk/GetTblAccessoriesDCDetailBulk',
    accessoriesDCDetailsDKPATCH: '/api/TblAccessoriesDCDetailBulk/UpdateTblAccessoriesDCDetailBulk',
    accessoriesDCDetailsDKDELETE: '/api/TblAccessoriesDCDetailBulk/DeleteTblAccessoriesDCDetailBulk',
    accessoriesDCDetailStyleDKGET: '/api/TblAccessoriesDCDetailBulk/GetStyleNumber',
    accessoriesDCMasterDKOfAccessoriesPOGET: '/api/TblAccessoriesDCDetailBulk/GetPONO',
    GRNByAccessoriesPOGET: '/api/TblAccessoriesDCDetailBulk/GetAccessoriesInwardDetailBulks',
    accessoriesDCIronPackDKGET: '/api/TblIroningAndPackingDCBulk/GetIPDBySupplierBulks',
    accessoriesDCStitchingDKGET: '/api/TblStitchingDCBulk/GetSupplierAgainstId'
    //accessoriesDCDetailsDKPreviousGetListGET: '/api/TblAccessoriesDCDetailBulk/GetAccessoriesInwardDetailBulks'
};

const dyeingDCMaster = {
    dyeingDCMasterGET: '/api/TblDyeingDC/GetTblDyeingDCs',
    dyeingDCMasterPOST: '/api/TblDyeingDC/CreateTblDyeingDC',
    dyeingDCMasterGETID: '/api/TblDyeingDC/GetTblDyeingDC',
    dyeingDCMasterPATCH: '/api/TblDyeingDC/UpdateTblDyeingDC',
    dyeingDCMasterDELETE: '/api/TblDyeingDC/DeleteTblDyeingDC',
    dyeingDCInvoiceGET: '/api/TblDyeingDC/TblDyeingDCPrint',
    dyeingDCDetailsDiaFrmStyleGET: '/api/TblDyeingDCDetail/GetStylePrepDia',
    dyeingDCDetailsWeightFrmStyleGET: '/api/TblStyleMaster/GetStyleFabricRequirementWeight'

};

const dyeingDCDKMaster = {
    dyeingDCDKMasterGET: '/api/TblDyeingDCBulk/GetTblDyeingDCBulks',
    dyeingDCDKInvoiceGET: '/api/TblDyeingDCBulk/TblDyeingDCBulkPrint',
    dyeingDCDKMasterPOST: '/api/TblDyeingDCBulk/CreateTblDyeingDCBulk',
    dyeingDCDKMasterGETID: '/api/TblDyeingDCBulk/GetTblDyeingDCBulk',
    dyeingDCDKMasterPATCH: '/api/TblDyeingDCBulk/UpdateTblDyeingDCBulk',
    dyeingDCDKMasterDELETE: '/api/TblDyeingDCBulk/DeleteTblDyeingDCBulk',
    dyeingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber'
};

const costing = {
    costingHeaderCreate: '/api/TblSimpleCosting/CreateTblSimpleCosting',
    costingHeaderDataGET: '/api/TblSimpleCostingDetail/GetTblSimpleCostingDetailForGrid',
    costingHeaderDetailCreate: '/api/TblSimpleCostingDetail/CreateTblSimpleCostingDetail',
    costingHeaderSerialNo: '/api/TblSimpleCostingDetail/GenerateSerialNo',
    costingHeaderMainGET: '/api/TblSimpleCosting/GetTblSimpleCostings',
    costingDetailEDIT: '/api/TblSimpleCostingDetail/UpdateTblSimpleCostingDetail',
    costingDetailDELETE: '/api/TblSimpleCostingDetail/DeleteTblSimpleCostingDetail',
    costinguserassignUPDATE: '/api/TblSimpleCosting/UpdateTblSimpleCostingAssignedUser',
    costingcomparisionGET: '/api/TblSimpleCosting/GetTblSimpleCostingComparision',
    costingDetailSaveallUPDATE: '/api/TblSimpleCosting/UpdateTblSimpleCostingOverAll',
    costinginvoiceDataGET: '/api/TblSimpleCostingDetail/GetTblSimpleCostingDetailForPrint',
}

const cashRequisition = {
    cashRequisitionFormGET: '/api/TblCashRequisitionForm/GetTblCashRequisitionForms',
    cashRequisitionFormGETBYID: '/api/TblCashRequisitionForm/GetTblCashRequisitionForm',
    cashRequisitionFormPOST: '/api/TblCashRequisitionForm/CreateTblCashRequisitionForm',
    cashRequisitionFormPATCH: '/api/TblCashRequisitionForm/UpdateTblCashRequisitionForm',
    cashRequisitionFormDELETE: '/api/TblCashRequisitionForm/DeleteTblCashRequisitionForm',
    GetTblCashRequisitionFormUsingCRFNo: '/api/TblCashRequisitionForm/GetTblCashRequisitionFormUsingCRFNo',
    CreateTblCashRequisitionFormDetail: '/api/TblCashRequisitionFormDetail/CreateTblCashRequisitionFormDetail',
    GetTblCashRequisitionFormDetails: '/api/TblCashRequisitionFormDetail/GetTblCashRequisitionFormDetails',
    GetTblCashRequisitionFormDetailsBYID: '/api/TblCashRequisitionFormDetail/GetTblCashRequisitionFormDetail',
    UpdateTblCashRequisitionFormDetail: '/api/TblCashRequisitionFormDetail/UpdateTblCashRequisitionFormDetail',
    DeleteTblCashRequisitionFormDetail: '/api/TblCashRequisitionFormDetail/DeleteTblCashRequisitionFormDetail',
    GetTblCashRequisitionFormsofRequisitorName: '/api/TblCashRequisitionForm/GetTblCashRequisitionFormsofRequisitorName',
    billUpload: '/api/TblCashRequisitionFormDetail/CashRequisitionFormDetailUpload',
    billUploadGetList: '/api/TblCashRequisitionFormDetail/GetCashRequisitionFormDetail',
    CashRequisitionStyles: '/api/TblCashRequisitionForm/GetTblCashRequisitionStyles',
    VerifyPaymentEntry: "/api/TblCashRequisitionForm/VerifyPaymentEntry",
    CashRequisitionFormInvoiceGET: 'api/TblCashRequisitionForm/GetTblCashRequisitionFormPrint',
    CashRequisitionFormCalloffPATCH: '/api/TblCashRequisitionForm/UpdateTblCashRequisitionFormCalloff',
    CashRequisitionApprovalPatch: '/api/TblCashRequisitionForm/UpdateTblCashRequisitionApproval'
};

const directBilling = {
    GETDirectBilling: '/api/TblDirectBillEntry/GetTblDirectBillEntrys',
    POSTDirectBilling: '/api/TblDirectBillEntry/CreateTblDirectBillEntry',
    GETBYIDDirectBilling: '/api/TblDirectBillEntry/GetTblDirectBillEntry',
    PATCHDirectBilling: '/api/TblDirectBillEntry/UpdateTblDirectBillEntry',
    DELETEDirectBilling: '/api/TblDirectBillEntry/DeleteTblDirectBillEntry',
    ConvertToBillEntry: '/api/TblDirectBillEntry/ConverttoTblBillEntry',
    DirectBillingProgramIdGET: '/api/TblDirectBillEntry/GetTblProgramList',
}

const directBillingDetails = {
    GETDirectBillingDetails: '/api/TblDirectBillEntryDetail/GetTblDirectBillEntryDetails',
    GETBYIDDirectBillingDetails: '/api/TblDirectBillEntryDetail/GetTblDirectBillEntryDetail',
    POSTDirectBillingDetails: '/api/TblDirectBillEntryDetail/CreateTblDirectBillEntryDetail',
    PATCHDirectBillingDetails: '/api/TblDirectBillEntryDetail/UpdateTblDirectBillEntryDetail',
    DELETEDirectBillingDetails: '/api/TblDirectBillEntryDetail/DeleteTblDirectBillEntryDetail'
};

const accountProperty = {
    GetTblAccountPropertys: '/api/TblAccountProperty/GetTblAccountPropertys',
    GetSingleTblAccountProperty: '/api/TblAccountProperty/GetTblAccountProperty',
    CreateTblAccountProperty: '/api/TblAccountProperty/CreateTblAccountProperty'
}

const accountPropertyModalList = {
    AccounrPropertyModalList: '/api/TblAccountProperty/GetTblAccountPropertysWithFilter'
};

const garmentsPo = {
    garmentsPoMasterGET: '/api/TblGarmentPO/GetTblGarmentPOs',
    garmentsPoMasterCREATE: '/api/TblGarmentPO/CreateTblGarmentPO',
    garmentsPoMasterUPDATE: '/api/TblGarmentPO/UpdateTblGarmentPO',
    garmentsPoMasterDELETE: '/api/TblGarmentPO/DeleteTblGarmentPO',
    garmentsPOMasterByID: '/api/TblGarmentPO/GetTblGarmentPO',
    garmentsPOInvoiceGET: '/api/TblGarmentPO/TblGarmentPOPrint',
    garmentsPODetailsSizeGrid: '/api/TblGarmentPODetail/LoadGridWithSize',
    garDCQtyWithSizeForPrintGET: '/api/TblGarmentPO/GetQtyWithSizeForPrint',
    deleteDCDetailsCallOffGarments: 'api/TblGarmentPODetail/UpdateTblGarmentPOCalloffAll',
    garmentPoCallOffwithReason: '/api/TblGarmentPO/UpdateTblGarmentPOCalloff'
}


const garmentsPodetails = {
    garmentsPoDetailsGET: '/api/TblGarmentPODetail/GetTblGarmentPODetails',
    garmentsPoDetailsCREATE: '/api/TblGarmentPODetail/CreateTblGarmentPODetail',
    garmentsPoDetailsUPDATE: '/api/TblGarmentPODetail/UpdateTblGarmentPODetail',
    garmentsPoDetailsDELETE: '/api/TblGarmentPODetail/DeleteTblGarmentPODetail',
    garmentsPoDetailsBYId: '/api/TblGarmentPODetail/GetGarmentPartwithColour',
    garmentsPoDetailsSizeGrid: '/api/TblGarmentPODetail/LoadGridWithSize',
    garmentsPoDetailsGET_BY_ID_INNER: 'api/TblGarmentPODetail/GetTblGarmentPODetailofDC',
    saveGarmentsPODetailsPOST: '/api/TblGarmentPODetail/CreateTblGarmentPOWithPart',
    garmentsPoDetailsWithColor: '/api/TblGarmentPODetail/GetGarmentPartwithColour',
    //garmentsPoDetailsGET_BY_Accessories:'/api/TblGarmentPODetail/GetTblGarmentAccessoriesstitchingDC'
    //garmentsPoDetailACCGET: '/api/TblAccessoriesDCDetail/GetReqAccessoriesPO',
    garmentsPoDetailACCGET: '/api/TblGarmentPODetail/GetTblGarmentAccesoriesInfo',
    garmentsPoDetailACCPOST: '/api/TblGarmentPODetail/CreateTblGarmentAccessories',
    getTblGarmentsAccessoriesstitchingDC: '/api/TblGarmentPODetail/GetTblGarmentAccessoriesstitchingDC',
    garmentDCDetailACCDelete: '/api/TblGarmentPODetail/DeleteTblGarmentAccessoriesDCDetail'

}

const customerPoHeader = {
    customerPoHeaderGET: '/api/TblCustomerPO/GetTblCustomerPOs',
    customerPoExportData: '/api/TblCustomerPO/GetTblCustomerPOsWithDtls',
    customerPoHeaderCreate: '/api/TblCustomerPO/CreateTblCustomerPO',
    customerPoHeaderPATCH: '/api/TblCustomerPO/UpdateTblCustomerPO',
    customerPODeliveryAtGET: '/api/TblPartyDetail/GetTblPartyDetailofParty',
    customerPoHeaderEditID: '/api/TblCustomerPO/GetTblCustomerPO',
    customerPOHeaderDelete: '/api/TblCustomerPO/DeleteTblCustomerPO',
    customerPOInvoiceGET: '/api/TblCustomerPO/TblCustomerPOPrint'
}

const customerPODetails = {
    customerPODetailGridData: '/api/TblCustomerPODetail/GetTblCustomerPODetails',
    customerPOLastTableIdGET: '/api/TblCustomerPO/GetLastTblCustomerPOId',
    customerPODetailCreatePOST: '/api/TblCustomerPODetail/CreateTblCustomerPODetail',
    customerPODetailUpdatePATCH: '/api/TblCustomerPODetail/UpdateTblCustomerPODetail',
    customerPODetailEditGET: '/api/TblCustomerPODetail/GetTblCustomerPODetail',
    customerPODetailArticleNoGET: '/api/TblArticleMaster/GetActiveTblArticleMasters',
    customerPODetailDELETE: '/api/TblCustomerPODetail/DeleteTblCustomerPODetail'
}


const garmentsPoInwardHeader = {
    garmentsPoInwardPendingGET: '/api/TblGarmentPOInward/GetTblGarmentPODetails',
    garmentsPoInwardMasterGET: '/api/TblGarmentPOInward/GetTblGarmentPOInwards',
    garmentsPoInwardMasterPOST: '/api/TblGarmentPOInward/CreateTblGarmentPOInward',
    garmentsPoInwardMasterPATCH: '/api/TblGarmentPOInward/UpdateTblGarmentPOInward',
    garmentPoInwardDelete: '/api/TblGarmentPOInward/DeleteTblGarmentPOInward',
    garmentPoCallOff: '/api/TblGarmentPO/UpdateTblGarmentPOCalloff',
    //garmentPoCallOffwithReason: '/api/TblGarmentPO/UpdateTblGarmentPOCalloff'
    // garmentsPoMasterCREATE: '/api/TblGarmentPO/CreateTblGarmentPO',
    // garmentsPoMasterUPDATE: '/api/TblGarmentPO/UpdateTblGarmentPO',
    // garmentsPoMasterDELETE: '/api/TblGarmentPO/DeleteTblGarmentPO',
    // garmentsPOMasterByID: '/api/TblGarmentPO/GetTblGarmentPO',

}

const garmentsPoInwardDetails = {
    // garmentsPoInwardPendingGET: '/api/TblGarmentPOInward/GetTblGarmentPODetails',
    // garmentsPoInwardMasterGET: '/api/TblGarmentPOInward/GetTblGarmentPOInwards',
    garmentsPoInwardDetailPOST: '/api/TblGarmentPOInwardDetail/CreateTblGarmentPO',
    garmentsPoInwardDetailPATCH: '/api/TblGarmentPOInward/UpdateTblGarmentPOInward',
    garmentsPoInwardDetails: '/api/TblGarmentPOInwardDetail/GetTblGarmentPOInwardDetailofInward',
    garmentsInwardIdGET: '/api/TblGarmentPOInward/GetTblGarmentPOSize',

    //garmentsPoInwardMasterPATCH: '/api/TblGarmentPOInward/UpdateTblGarmentPOInward'


}

const programDiscount = {
    programDiscountDataGET: '/api/TblYarnPODetail/GetTblYarnPODetailDiscount',
    programDiscountTransferPOST: '/api/TblProgramDiscount/CreateTblProgramDiscount'
};

const stitchingDCDKMaster = {
    stitchingDCDKMasterGET: '/api/TblStitchingDCBulk/GetTblStitchingDCBulks',
    stitchingDCDKMasterPOST: '/api/TblStitchingDCBulk/CreateTblStitchingDCBulk',
    stitchingDCDKMasterGETID: '/api/TblStitchingDCBulk/GetTblStitchingDCBulk',
    stitchingDCDKMasterPATCH: '/api/TblStitchingDCBulk/UpdateTblStitchingDCBulk',
    stitchingDCDKMasterDELETE: '/api/TblStitchingDCBulk/DeleteTblStitchingDCBulk',
    stitchingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    stitchingDCDKInvoiceGET: '/api/TblStitchingDCBulk/TblStitchingDCBulkPrint'
};

const stichingDCMaster = {
    stichingDCMasterGETID: '/api/TblStitchingDC/GetTblStitchingDC'

};

const ironingDCMaster = {
    ironingDCMasterGETID: '/api/TblIroningAndPackingDC/GetTblIroningAndPackingDC'
}

const cuttingDCDKMaster = {
    cuttingDCDKMasterGET: '/api/TblCuttingDCBulk/GetTblCuttingDCBulks',
    cuttingDCDKInvoiceGET: '/api/TblCuttingDCBulk/TblCuttingDCBulkPrint',
    cuttingDCDKMasterPOST: '/api/TblCuttingDCBulk/CreateTblCuttingDCBulk',
    cuttingDCDKMasterGETID: '/api/TblCuttingDCBulk/GetTblCuttingDCBulk',
    cuttingDCDKMasterPATCH: '/api/TblCuttingDCBulk/UpdateTblCuttingDCBulk',
    cuttingDCDKMasterDELETE: '/api/TblCuttingDCBulk/DeleteTblCuttingDCBulk',
    cuttingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    cuttingDCDKFormatMasterGET: '/api/TblFormatMaster/GetAllTblFormatMaster',
    deleteCuttingdkApiCall: '/api/TblCuttingDCBulk/UpdateTblCuttingDCCalloff'
};

const washingDCDKMaster = {
    washingDCDKMasterGET: '/api/TblDyeingDCBulk/GetTblDyeingDCBulks',
    washingDCDKInvoiceGET: '/api/TblDyeingDCBulk/TblDyeingDCBulkPrint',
    washingDCDKMasterPOST: '/api/TblDyeingDCBulk/CreateTblDyeingDCBulk',
    washingDCDKMasterGETID: '/api/TblDyeingDCBulk/GetTblDyeingDCBulk',
    washingDCDKMasterPATCH: '/api/TblDyeingDCBulk/UpdateTblDyeingDCBulk',
    washingDCDKMasterDELETE: '/api/TblDyeingDCBulk/DeleteTblDyeingDCBulk',
    washingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber'
};

const printingDCDKMaster = {
    printingDCDKMasterGET: '/api/TblPrintingDCBulk/GetTblPrintingDCBulks',
    printingDCDKMasterPOST: '/api/TblPrintingDCBulk/CreateTblPrintingDCBulk',
    printingDCDKMasterGETID: '/api/TblPrintingDCBulk/GetTblPrintingDCBulk',
    printingDCDKMasterPATCH: '/api/TblPrintingDCBulk/UpdateTblPrintingDCBulk',
    printingDCDKMasterDELETE: '/api/TblPrintingDCBulk/DeleteTblPrintingDCBulk',
    printingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    printingDCDKInvoiceGET: '/api/TblPrintingDCBulk/TblPrintingDCBulkPrint',
    printingDcGridGet: '/api/TblCuttingDCBulk/TblCuttingDCBulkSKUPrint',
    deleteCuttdkApiCall: '/api/TblCuttingDCBulk/UpdateTblCuttingDCCalloff'
};

const printingDC2DKMaster = {
    printingDC2DKMasterGET: '/api/TblPrintingPartDCBulk/GetTblPrintingPartDCBulks',
    printingDC2DKMasterPOST: '/api/TblPrintingPartDCBulk/CreateTblPrintingPartDCBulk',
    printingDC2DKMasterGETID: '/api/TblPrintingPartDCBulk/GetTblPrintingPartDCBulk',
    printingDC2DKMasterPATCH: '/api/TblPrintingPartDCBulk/UpdateTblPrintingPartDCBulk',
    printingDC2DKMasterDELETE: '/api/TblPrintingPartDCBulk/DeleteTblPrintingPartDCBulk',
    printingDC2DKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    printingDC2DKInvoiceGET: '/api/TblPrintingPartDCBulk/TblPrintingPartDCBulkPrint'
};

const ironingPackingDCDKMaster = {
    ironingPackingDCDKMasterGET: '/api/TblIroningAndPackingDCBulk/GetTblIroningAndPackingDCBulks',
    ironingPackingDCDKMasterPOST: '/api/TblIroningAndPackingDCBulk/CreateTblIroningAndPackingDCBulk',
    ironingPackingDCDKMasterGETID: '/api/TblIroningAndPackingDCBulk/GetTblIroningAndPackingDCBulk',
    ironingPackingDCDKMasterPATCH: '/api/TblIroningAndPackingDCBulk/UpdateTblIroningAndPackingDCBulk',
    ironingPackingDCDKMasterDELETE: '/api/TblIroningAndPackingDCBulk/DeleteTblIroningAndPackingDCBulk',
    ironingPackingDCDKStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    ironingPackingDCDKInvoiceGET: '/api/TblIroningAndPackingDCBulk/TblIroningAndPackingDCBulkPrint',
    deleteironingPackingdkApiCall: '/api/TblIroningAndPackingDCBulk/UpdateTblIroningAndPackingDCCalloff',
    ironingPackingDCDKGridGet: '/api/TblIroningAndPackingDCBulk/TblIroningAndPackingDCBulkSKUPrint'
};

const printingDCDKDetails = {
    printingDCDKDetailsGET: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulks',
    printingDCDKDetailsGET_BY_ID: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulkofDC',
    printingDCDKDetailsPOST: '/api/TblPrintingDCDetailBulk/CreateTblPrintingDCDetailBulk',
    printingDCDKDetailsGETID: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulk',
    printingDCDKDetailsPATCH: '/api/TblPrintingDCDetailBulk/UpdateTblPrintingDCDetailBulk',
    printingDCDKDetailsDELETE: '/api/TblPrintingDCDetailBulk/DeleteTblPrintingDCDetailBulk',
    printingDcDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber',
    printingDcDetailsProgramGET: '/api/TblPrintingDCDetailBulk/GetProgram',
    GRNNoByPrintingDCNoGET: '/api/TblPrintingDCDetailBulk/GetInwardDetailBulks',
    printingDcDetailsPreviousGetListGET: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist'
};

const printingDC2DKDetails = {
    printingDC2DKDetailsGET: '/api/TblPrintingPartDCDetailBulk/GetTblPrintingPartDCDetailBulks',
    printingDC2DKDetailsGET_BY_ID: '/api/TblPrintingPartDCDetailBulk/GetTblPrintingPartDCDetailBulkofDC',
    printingDC2DKDetailsPOST: '/api/TblPrintingPartDCDetailBulk/loadInwardDetailForDCQty',
    printingDC2DKDetailsGETID: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulk',
    printingDC2DKDetailsPATCH: '/api/TblPrintingDCDetailBulk/UpdateTblPrintingDCDetailBulk',
    printingDC2DKDetailsDELETE: '/api/TblPrintingPartDCDetailBulk/DeleteTblPrintingPartDCDetailBulk',
    printingDc2DetailsDCNoGET: '/api/TblPrintingPartDCDetailBulk/GetPOOrDCNumber',
    printingDc2DetailsProgramGET: '/api/TblPrintingPartDCDetailBulk/GetProgram',
    GRNNoByPrintingDC2NoGET: '/api/TblPrintingPartDCDetailBulk/GetInwardDetailBulks',
    printingDC2EditDataDKGET: '/api/TblPrintingPartDCDetailBulk/loadInwardDetailForDCQty',
    printingDC2EditQtyDKPOST: '/api/TblPrintingPartDCDetailBulk/CreateTblCuttingDCDetailQtyBulk'
};

const ironingPackingDCDKDetails = {
    ironingPackingDCDKDetailsGET: '/api/TblIroningAndPackingDCDetailBulk/GetTblIroningAndPackingDCDetailBulks',
    ironingPackingDCDKDetailsGET_BY_ID: '/api/TblIroningAndPackingDCDetailBulk/GetTblIroningAndPackingDCDetailBulkofDC',
    ironingPackingDCDKDetailsPOST: '/api/TblIroningAndPackingDCDetailBulk/loadInwardDetailForDCQty',
    ironingPackingDCDKDetailsGETID: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulk',
    ironingPackingDCDKDetailsPATCH: '/api/TblIroningAndPackingDCDetailBulk/UpdateTblIroningAndPackingDCDetailBulk',
    ironingPackingDCDKDetailsDELETE: '/api/TblIroningAndPackingDCDetailBulk/DeleteTblIroningAndPackingDCDetailBulk',
    ironingPackingDcDetailsDCNoGET: '/api/TblIroningAndPackingDCDetailBulk/GetPOOrDCNumber',
    ironingPackingDcDetailsProgramGET: '/api/TblIroningAndPackingDCDetailBulk/GetProgram',
    GRNNoByIroningPackingDCNoGET: '/api/TblIroningAndPackingDCDetailBulk/GetInwardDetailBulks',
    ironingPackingEditDataDKGET: '/api/TblPrintingPartDCDetailBulk/loadInwardDetailForDCQty',
    ironingPackingEditQtyDKPOST: '/api/TblIroningAndPackingDCDetailBulk/CreateTblIroningAndPackingDCDetailQtyBulk',
    ironingPackingDCDetailEditGET: '/api/TblIroningAndPackingDCDetailBulk/GetIronAndPackEdit'
};

const closeBtnCloseCallKnitting = {
    postCloseIconKNI: '/api/TblKnittingDCDetail/UpdateClose'
};

const closeBtnCloseCallCutting = {
    postCloseIconCUT: '/api/TblCuttingDCDetail/UpdateClose'
};

const closeBtnCloseCallDyeing = {
    postCloseIconDYE: '/api/TblDyeingDCDetail/UpdateClose'
};

const closeBtnCloseCallCompacting = {
    postCloseIconCOMPA: '/api/TblCompactingDCDetail/UpdateClose'
};


const closeBtnCloseCallAllOverPrinting = {
    postCloseIconALLOVER: '/api/TblPrintingDCDetail/UpdateClose'
};
const closeBtnCloseCallGeneral = {
    postCloseIconGeneral: 'api/TblGeneralPODetail/UpdateClose'
};

const updateAllBtnCallPrintingDC = {
    updateAllCloseIconPrintingDC: '/api/TblPrintingPartDCDetail/UpdateAllClose'
};
const closeBtnCloseCallPrintingDC = {
    postCloseIconPrintingDC: '/api/TblPrintingPartDCDetail/UpdateClose'
};

const updateAllBtnCallKnitting = {
    updateAllCloseIconKnitting: '/api/TblKnittingDCDetail/UpdateAllClose'
};

const updateAllBtnCallCutting = {
    updateAllCloseIconCutting: '/api/TblCuttingDCDetail/UpdateAllClose'
};

const updateAllBtnCallGarment = {
    updateAllCloseIconGarment: '/api/TblGarmentPODetail/UpdateAllClose'
};

const updateAllBtnCallStitching = {
    updateAllCloseIconStitching: '/api/TblStitchingDCDetail/UpdateAllClose'
};

const updateAllBtnCallIroning = {
    updateAllCloseIconIroning: '/api/TblIroningAndPackingDCDetail/UpdateAllClose'
};


const updateAllBtnCallAccessories = {
    updateAllCloseIconAccessories: '/api/TblAccessoriesPODetail/UpdateAllClose'
};
const closeBtnCloseCallAccessories = {
    postCloseIconACC: '/api/TblAccessoriesPODetail/UpdateClose'
};

const DetailReport = {
    getDetailedreport: 'api/TblReports/GetTblDetailed_Program'
};

const updateAllBtnCallDyeing = {
    updateAllCloseIconDyeing: '/api/TblDyeingDCDetail/UpdateAllClose'
};

const updateAllBtnCallCompacting = {
    updateAllCloseIconCompacting: '/api/TblCompactingDCDetail/UpdateAllClose'
};

const updateAllBtnCallAllOverPrint = {
    updateAllCloseIconAllOverPrint: '/api/TblPrintingDCDetail/UpdateAllClose'
};

const updateAllBtnCallGeneral = {
    updateAllCloseIconAllGeneral: '/api/TblGeneralPODetail/UpdateAllClose'

}

const ironpackupdateAllBulkBtnCall = {
    updateAllIronPackBulkCloseIcon: '/api/TblIroningAndPackingDCDetailBulk/UpdateAllClose'
};

const ironpackcloseBtnBulkIconCall = {
    postIronPackBulkCloseIcon: '/api/TblIroningAndPackingDCDetailBulk/UpdateClose'
};

const dyeingDCDetails = {
    dyeingDCDetailsGET: '/api/TblDyeingDCDetail/GetTblDyeingDCDetails',
    dyeingDCDetailsGET_BY_ID: '/api/TblDyeingDCDetail/GetTblDyeingDCDetailofDC',
    dyeingDCDetailsPOST: '/api/TblDyeingDCDetail/CreateTblDyeingDCDetail',
    dyeingDCDetailsGETID: '/api/TblDyeingDCDetail/GetTblDyeingDCDetail',
    dyeingDCDetailsPATCH: '/api/TblDyeingDCDetail/UpdateTblDyeingDCDetail',
    dyeingDCDetailsDELETE: '/api/TblDyeingDCDetail/DeleteTblDyeingDCDetail',
    dyeingReprocessPrevListGET: '/api/TblDyeingInwardDetail/LoadDYDForReprocess',
    dyeingDcDetailsGetListFabStockGET: '/api/TblYarnInwardDetail/GetListForFabricStock'

};

const dyeingDCDKDetails = {
    dyeingDCDKDetailsGET: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulks',
    dyeingDCDKDetailsProgramGET: '/api/TblDyeingDCDetailBulk/GetProgram',
    dyeingDCDKDetailsGET_BY_ID: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulkofDC',
    dyeingDCDKDetailsPOST: '/api/TblDyeingDCDetailBulk/CreateTblDyeingDCDetailBulk',
    dyeingDCDKDetailsGETID: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulk',
    dyeingDCDKDetailsPATCH: '/api/TblDyeingDCDetailBulk/UpdateTblDyeingDCDetailBulk',
    dyeingDCDKDetailsDELETE: '/api/TblDyeingDCDetailBulk/DeleteTblDyeingDCDetailBulk',
    dyeingDcDetailsPreviousGetListGET: '/api/TblKnittingDCBulk/GetYarnInwardDetailBulksPending',
    dyeingDcDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber',
    GRNNoByDyeingDCNoGET: '/api/TblDyeingDCDetailBulk/GetInwardDetailBulks'
};

const stitchingDCDKDetails = {
    stitchingDCDKDetailsGET: '/api/TblStitchingDCDetailBulk/GetTblStitchingDCDetailBulks',
    stitchingDCDKDetailsGET_BY_ID: '/api/TblStitchingDCDetailBulk/GetTblStitchingDCDetailBulkofDC',
    stitchingDCDKDetailsPOST: '/api/TblStitchingDCDetailBulk/loadInwardDetailForDCQty',
    stitchingDCDKDetailsGETID: '/api/TblPrintingDCDetailBulk/GetTblPrintingDCDetailBulk',
    stitchingDCDKDetailsPATCH: '/api/TblPrintingDCDetailBulk/UpdateTblPrintingDCDetailBulk',
    stitchingDCDKDetailsDELETE: '/api/TblPrintingPartDCDetailBulk/DeleteTblPrintingPartDCDetailBulk',
    stitchingDetailsDCNoGET: '/api/TblStitchingDCDetailBulk/GetPOOrDCNumber',
    stitchingDetailsProgramGET: '/api/TblStitchingDCDetailBulk/GetProgram',
    GRNNoByStitchingNoGET: '/api/TblStitchingDCDetailBulk/GetInwardDetailBulks',
    stitchingEditDataDKGET: '/api/TblPrintingPartDCDetailBulk/loadInwardDetailForDCQty',
    stitchingEditQtyDKPOST: '/api/TblStitchingDCDetailBulk/CreateTblStitchingDCDetailQtyBulk'
};

const cuttingDCDKDetails = {
    cuttingDCDKDetailsGET: '/api/TblCuttingDCDetailBulk/GetTblCuttingDCDetailBulks',
    cuttingDCDKDetailsGenerateSKUStyleGET: '/api/TblCuttingDCDetailBulk/LoadSKUGridWithSize',
    cuttingDCDKDetailsGET_BY_ID: '/api/TblCUDSKUDCDetailBulk/GetTblCUDSKUDCDetailBulkofDC',
    cuttingDCDKDetailsFormDataGET_BY_ID: '/api/TblCuttingDCDetailBulk/GetTblCuttingDCDetailBulkofDC',
    cuttingDCDKDetailsPOST: '/api/TblCuttingDCDetailBulk/CreateTblCuttingDCDetailBulk',
    cuttingDCDKDetailsGridPOST: '/api/TblCuttingDCDetailBulk/CreateTblCuttingDCDetailQtyBulk',
    cuttingDCDKDetailsSKUStylePOST: '/api/TblCUDSKUDCDetailBulk/CreateTblCuttingDCDetailQtyBulk',
    cuttingDCDKDetailsGETID: '/api/TblCuttingDCDetailBulk/GetTblCuttingDCDetailBulk',
    cuttingDCDKDetailsPATCH: '/api/TblCuttingDCDetailBulk/UpdateTblCuttingDCDetailBulk',
    cuttingDCDKDetailsDELETE: '/api/TblCuttingDCDetailBulk/DeleteTblCuttingDCDetailBulk',
    cuttingDcDetailsPreviousGetListGET: '/api/TblKnittingDCBulk/GetYarnInwardDetailBulksPending',
    cuttingDcDetailsProgramGetListGET: '/api/TblCuttingDCDetailBulk/GetProgram',
    cuttingDcDetailsStyleGetListGET: '/api/TblCuttingDCDetailBulk/GetStyleNumber',
    cuttingDcDetailsDCNoGET: '/api/TblCuttingDCDetailBulk/GetPOOrDCNumber',
    GRNNoByCuttingDCNoGET: '/api/TblCuttingDCDetailBulk/GetInwardDetailBulks',
    stichingDCDKDetails: '/api/TblStitchingDCDetailBulk/CreateTblSTDQtyBulk',
    printingDCDKDeatils: '/api/TblPrintingPartDCDetailBulk/CreateTblPrintingPartQtyBulk',
    cuttingFabricEdit: 'api/TblCuttingDCDetailBulk/GetTblCuttingDCDetailBulkByFldId',
    cuttingFabricDelete: 'api/TblCuttingDCDetailBulk/DeleteTblCuttingDCDetailBulk',
    deleteCuttingDetails: 'api/TblCUDSKUDCDetailBulk/DeleteTblCUDSKUDCDetailBulk'
};

const washingDCDKDetails = {
    washingDCDKDetailsGET: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulks',
    washingDCDKDetailsGET_BY_ID: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulkofDC',
    washingDCDKDetailsPOST: '/api/TblDyeingDCDetailBulk/CreateTblDyeingDCDetailBulk',
    washingDCDKDetailsGETID: '/api/TblDyeingDCDetailBulk/GetTblDyeingDCDetailBulk',
    washingDCDKDetailsPATCH: '/api/TblDyeingDCDetailBulk/UpdateTblDyeingDCDetailBulk',
    washingDCDKDetailsDELETE: '/api/TblDyeingDCDetailBulk/DeleteTblDyeingDCDetailBulk',
    washingDcDetailsPreviousGetListGET: '/api/TblKnittingDCBulk/GetYarnInwardDetailBulksPending',
    washingDcDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber',
    GRNNoByWashingDCNoGET: '/api/TblDyeingDCDetailBulk/GetInwardDetailBulks'
};
const compactingDCMaster = {
    // prev one
    // compactingDCMasterGET: '/api/TblCompactingDC/GetTblCompactingDCs',

    compactingDCMasterGET: '/api/TblCompactingDC/GetTblCompactingDCsWithProcessOption',
    compactingDCMasterPOST: '/api/TblCompactingDC/CreateTblCompactingDC',
    compactingDCMasterGETID: '/api/TblCompactingDC/GetTblCompactingDC',
    compactingDCMasterPATCH: '/api/TblCompactingDC/UpdateTblCompactingDC',
    compactingDCMasterDELETE: '/api/TblCompactingDC/DeleteTblCompactingDC',
    compactingDCStyleGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    GetStylePrepDiaByProgram: '/api/TblCompactingDCDetail/GetStylePrepDiaByProgram',
    // compactingDCInvoiceGET: '/api/TblCompactingDCBulk/TblCompactingDCBulkPrint'
    compactingDCInvoiceGET: '/api/TblCompactingDC/TblCompactingDCPrint',
    // CompactingDCDetailsRatePrKgFrmStyleGET: '/api/TblCompactingDCDetail/GetStylePrepCost',
    CompactingDCDetailsRatePrKgFrmStyleGET: '/api/TblCompactingDCDetail/GetStylePrepCostByProgram',
    CompactingDCDetailsDiaFrmStyleGET: '/api/TblCompactingDCDetail/GetStylePrepDia',
    getProgramProcessCompacting: '/api/TblCompactingDC/GetTblProgramListWithProcessOption'

};
const compactingDivisionMaster = {
    compactingDivisionMasterGET: '/api/TblCompactingRN/GetTblCompactingRNs',
    compactingDivisionMasterPOST: '/api/TblCompactingRN/CreateTblCompactingRN',
    compactingDivisionInvoiceGET: '/api/TblCompactingRN/TblCompactingRNPrint',
    //compactingDivisionCallOff: '/api/TblCompactingRN/UpdateTblCompactingRNCalloff',
    compactingDivisionCallOff: '/api/TblCompactingRN/UpdateTblCompactingRNCalloff',
    compactingDivisionMasterUPDATE: '/api/TblCompactingRN/UpdateTblCompactingRN',
    compactingDivisionMasterGETID: '/api/TblCompactingRN/GetTblCompactingRN',
    compactingDivisionMasterDyeDcNOIDGET: '/api/TblDyeingDC/LoadDyeingDCIds',
    compactingDivisionMasterCancelPATCH: '/api/TblCompactingRN/CancelTblCompactingRN',
};


const compactingDivisionDetails = {
    compactingDivisionDetailsGET_BY_ID: '/api/TblCompactingRNDetail/GetTblCompactingRNDetails',
    compactingDivisionDetailsPOST: '/api/TblCompactingRNDetail/CreateTblCompactingRNDetail',
    //compactingDivisionDetailsPreviousListGET: '/api/TblDyeingDCDetail/GetTblDyeingDCDetailofDC',
    compactingDivisionDetailsPreviousListNewGET: '/api/TblDyeingDC/GetTblDyeingDCDetailofDCForRN',
    compactingDivisionDetailsEditGET_BY_ID: '/api/TblCompactingRNDetail/GetTblCompactingRNDetail',
    compactingDivisionDetailsUPDATE: '/api/TblCompactingRNDetail/UpdateTblCompactingRNDetail',
    compactingDivisionDetailsDELETE: '/api/TblCompactingRNDetail/DeleteTblCompactingRNDetail',
};

const compactingInwardDivision = {
    compactingDivInwardMasterPOST: '/api/TblCompactingDN/CreateTblCompactingDN',
    compactingDivisionInwardMasterGET: '/api/TblCompactingDN/GetTblCompactingDNs',
    compactingDivInwardPendingMasterGET: '/api/TblCompactingDN/GetTblCompactingRNDetailsPending',
    compactingDivInwardInvoiceGET: '/api/TblCompactingDN/TblCompactingDNPrint'
}
const compactingInwardDivisionDetails = {
    compactingDivInwardDetailsPOST: '/api/TblCompactingDNDetail/CreateTblCompactingDNDetail',
    //compactingDivisionInwardPreviousGET: '/api/TblCompactingDN/GetTblCompactingRNDetailsPending',
    compactingDivisionInwardDetailsGET_BY_ID: '/api/TblCompactingDNDetail/GetTblCompactingDNDetails'
}
const compactingDivisionAuthorization = {
    compactingDivisionAuthorizationGET: '/api/TblCompactingRN/GetTblCompactingRNAuth',
    compactingDivisionAuthorizationVerify: '/api/TblCompactingRN/UpdateCRNApprovalStatus',
    compactingDivAuthDetailGET: 'api/TblCompactingRNDetail/GetTblCompactingRNDetailsForCompany'
};

const compactingDCDKMaster = {
    compactingDCMasterDKGET: '/api/TblCompactingDCBulk/GetTblCompactingDCBulks',
    compactingDCStyleDKGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    compactingDCMasterDKPOST: '/api/TblCompactingDCBulk/CreateTblCompactingDCBulk',
    compactingDCMasterDKGETID: '/api/TblCompactingDCBulk/GetTblCompactingDCBulk',
    compactingDCMasterDKPATCH: '/api/TblCompactingDCBulk/UpdateTblCompactingDCBulk',
    compactingDCMasterDKDELETE: '/api/TblCompactingDCBulk/DeleteTblCompactingDCBulk',
    compactingDCDKInvoiceGET: '/api/TblCompactingDCBulk/TblCompactingDCBulkPrint'
};
const compactingDCDetails = {
    compactingDCDetailsGET: '/api/TblCompactingDCDetail/GetTblCompactingDCDetails',

    compactingDCDetailsGET_BY_ID: '/api/TblCompactingDCDetail/GetTblCompactingDCDetailofDC',
    compactingDCDetailsPOST: '/api/TblCompactingDCDetail/CreateTblCompactingDCDetail',
    compactingDCDetailsGETID: '/api/TblCompactingDCDetail/GetTblCompactingDCDetail',
    compactingDCDetailsPATCH: '/api/TblCompactingDCDetail/UpdateTblCompactingDCDetail',
    compactingDCDetailsDELETE: '/api/TblCompactingDCDetail/DeleteTblCompactingDCDetail',
    GRNNoByCompactingGET: '/api/TblDyeingDCDetailBulk/GetInwardDetailBulks',
    compactingDcCommonDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber',
    compactingDCCommonDetailsProgramGET: '/api/TblCompactingDCDetailBulk/GetProgram',
    compactingDCPreviousGetList: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    compactingDCReProcessPreviousGetList: '/api/TblCompactingInwardDetail/LoadCODForReprocess'
};

const compactingDCDKDetails = {
    compactingDCDetailsDKGET: '/api/TblCompactingDCDetailBulk/GetTblCompactingDCDetailBulks',
    compactingDCDetailsDKGET_BY_ID: '/api/TblCompactingDCDetailBulk/GetTblCompactingDCDetailBulkofDC',
    compactingDCDetailsProgramGET: '/api/TblCompactingDCDetailBulk/GetProgram',
    compactingDCDetailsDKPOST: '/api/TblCompactingDCDetailBulk/CreateTblCompactingDCDetailBulk',
    compactingDCDetailsDKGETID: '/api/TblCompactingDCDetailBulk/GetTblCompactingDCDetailBulk',
    compactingDCDetailsDKPATCH: '/api/TblCompactingDCDetailBulk/UpdateTblCompactingDCDetailBulk',
    compactingDCDetailsDKDELETE: '/api/TblCompactingDCDetailBulk/DeleteTblCompactingDCDetailBulk',
    GRNNoByCompactingDKGET: '/api/TblCompactingDCDetailBulk/GetInwardDetailBulks',
    compactingDcDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber'
};
const printingDCMaster = {
    printingDCMasterGET: '/api/TblPrintingDC/GetTblPrintingDCs',
    printingDCMasterPOST: '/api/TblPrintingDC/CreateTblPrintingDC',
    printingDCMasterGETID: '/api/TblPrintingDC/GetTblPrintingDC',
    printingDCMasterPATCH: '/api/TblPrintingDC/UpdateTblPrintingDC',
    printingDCMasterDELETE: '/api/TblPrintingDC/DeleteTblPrintingDC',
    printingDCStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    printingDCInvoiceGET: '/api/TblPrintingDC/TblPrintingDCPrint'
};

const printingDCDetails = {
    printingDCDetailsGET: '/api/TblPrintingDCDetail/GetTblPrintingDCDetails',
    printingDCDetailsGET_BY_ID: '/api/TblPrintingDCDetail/GetTblPrintingDCDetailofDC',
    printingDCDetailsPOST: '/api/TblPrintingDCDetail/CreateTblPrintingDCDetail',
    printingDCDetailsGETID: '/api/TblPrintingDCDetail/GetTblPrintingDCDetail',
    printingDCDetailsPATCH: '/api/TblPrintingDCDetail/UpdateTblPrintingDCDetail',
    printingDCDetailsDELETE: '/api/TblPrintingDCDetail/DeleteTblPrintingDCDetail',
    printingDCDetailsProgramGetList: '/api/TblPrintingDCDetail/GetProgram',
    printingDCCommonDetailsDCNoGET: '/api/TblDyeingDCDetailBulk/GetPOOrDCNumber',
    printingDCCommonDetailsProgramGET: '/api/TblPrintingDCDetailBulk/GetProgram',
    printingDCPreviousGetList: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    GRNNoByPrintingDCCommonNoGET: '/api/TblPrintingDCDetailBulk/GetInwardDetailBulks',
    printingDCReprocessPreviousGetList: '/api/TblPrintingInwardDetail/LoadPRDForReprocess',
};

const printingPartDCMaster = {
    // printingPartDCMasterGET: '/api/TblPrintingPartDC/GetTblPrintingPartDCs',
    printingPartDCMasterGET: '/api/TblPrintingPartDC/GetTblPrintingPartDCsWithProcessOption',

    printingPartDCMasterPOST: '/api/TblPrintingPartDC/CreateTblPrintingPartDC',

    printingPartDCMasterGETID: '/api/TblPrintingPartDC/GetTblPrintingPartDC',

    printingPartDCMasterPATCH: '/api/TblPrintingPartDC/UpdateTblPrintingPartDC',

    //printingPartDCMasterDELETE: '/api/TblPrintingPartDC/DeleteTblPrintingPartDC',
    printingPartDCMasterDELETE: '/api/TblPrintingPartDC/UpdateTblPrintingPartDCCalloff',

    printingDCStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',

    printingPartDCInvoiceGET: '/api/TblPrintingPartDC/GetTblPrintingPartDCPrint',

    //  printingPartDCInvoiceGET: '/api/TblPrintingDC/GetTblPrintingPartDCPrint',
    deletePrintingDCDetailsCallOff: '/api/TblPrintingPartDCDetail/UpdateTblPrintingPartDCCalloffAll',

    getProgramProcessPrinting: '/api/TblPrintingPartDC/GetTblProgramListWithProcessOption'

};

const printingPartDCDetails = {
    printingPartDCDetailsGET: '/api/TblPrintingPartDCDetail/GetTblPrintingPartDCDetails',

    printingPartDCDetailsGET_BY_ID: '/api/TblPrintingPartDCDetail/GetTblPrintingPartDCDetailofDC',

    printingPartDCDetailsPOST: '/api/TblPrintingPartDCDetail/CreateTblPrintingPartDCDetails', //printingPartDCDetails2POST: '/api/TblPrintingPartDCDetail/CreateTblCuttingDCDetailQty',

    printingPartDCDetailsSecondGridGET: '/api/TblPrintingPartDCDetail/GetDEDQty', // printingPartDCDetailsFirstGridGET: '/api/TblDespatchDCDetail/GetDespatchQty',

    printingPartDCDetailsGETID: '/api/TblPrintingDCDetail/GetTblPrintingDCDetail',

    printingPartDCDetailsPATCH: '/api/TblPrintingPartDCDetail/UpdateTblPrintingPartDCDetail',

    printingPartDCDetailsDELETE: '/api/TblPrintingPartDCDetail/DeleteTblPrintingPartDCDetail',

    printingDCCommonDetailsDCNoGET: '/api/TblPrintingPartDCDetail/GetPOOrDCNumber',

    printingDCCommonDetailsProgramGET: '/api/TblPrintingPartDCDetail/GetProgram',
    printingBundleGetList: '/api/TblStitchingDCDetail/GetPreviousProgramBundle',
    printingBundlePOST: '/api/TblPrintingPartDCDetail/CreatePrintingPartDCInwardBundle',

    GRNNoByPrintingDCCommonNoGET: '/api/TblPrintingDCDetailBulk/GetInwardDetailBulks',
    printingIsPartDcDetailsPreviousGetListGET: '/api/TblPrintingPartDCDetail/GetIsPartPrintingRecord',
    printingPartDcDetailsPreviousGetListGET: '/api/TblPrintingPartDCDetail/GetPreviousProgramgetlist',
    printingDCDetailsApproveStatusChangeGET: '/api/TblPrintingPartDC/UpdateTblPrintingPartDCApproval',
    printingPartDcDetailsPreviousStitchedGetListGET: '/api/TblPrintingPartDCDetail/GetStitchedPCS',
    printingBundlePost: '/api/TblPrintingPartDCDetail/CreatePrintingPartDCInwardBundle',
    printingBundleGet: '/api/TblPrintingPartDCDetail/GetTblPrintingPartDCInwardBundleofDC',
    printingGetOilAdasAllowedQty: '/api/TblCuttingReport/GetOilAdasAllowedQty',
    PrintingSentOTPForExcessQty: '/api/TblMail/SendOTP_OADQtyExcess',
    PrintingSentOTPForExcessQtyNew: '/api/TblMail/SendOTP_OADQtyReason'
};



const ironingAndPackingDCMaster = {
    ironingAndPackingDCMasterGET: '/api/TblIroningAndPackingDC/GetTblIroningAndPackingDCs',
    ironingAndPackingDCMasterPOST: '/api/TblIroningAndPackingDC/CreateTblIroningAndPackingDC',
    ironingAndPackingDCMasterGETID: '/api/TblIroningAndPackingDC/GetTblIroningAndPackingDC',
    ironingAndPackingDCMasterPATCH: '/api/TblIroningAndPackingDC/UpdateTblIroningAndPackingDC',
    ironingAndPackingDCMasterDELETE: '/api/TblIroningAndPackingDC/DeleteTblIroningAndPackingDC ',
    ironingPackingDCInvoiceGET: '/api/TblIroningAndPackingDC/TblIroningAndPackingDCPrint'
};

const ironingAndPackingDCDetails = {
    ironingAndPackingDCDetailsGET: '/api/TblIroningAndPackingDCDetail/GetTblIroningAndPackingDCDetails',
    ironingAndPackingDCDetailsGET_BY_ID: '/api/TblIroningAndPackingDCDetail/GetTblIroningAndPackingDCDetailofDC',
    ironingAndPackingDCDetailsPOST: 'api/TblIroningAndPackingDCDetail/CreateTblIroningAndPackingDCDetailWithPart',
    ironingAndPackingDCDetailsGETID: '/api/TblIroningAndPackingDCDetail/GetTblIroningAndPackingDCDetail',
    ironingAndPackingDCDetailsPATCH: '/api/TblIroningAndPackingDCDetail/UpdateTblIroningAndPackingDCDetail',
    ironingAndPackingDCDetailsDELETE: '/api/TblIroningAndPackingDCDetail/DeleteTblKnittingDC',
    ironingAndPackingDCDetailsPreviousGetList: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    ironingAndPackingDCDetailsSecondGridGET: '/api/TblIroningAndPackingDCDetail/GetTblIronAndPack',
    // ironingPackingDCDetailACCGET: '/api/TblAccessoriesDCDetail/GetReqAccessoriesPO',
    ironingPackingDCDetailACCGET: '/api/TblIroningAndPackingDCDetail/GetTblIroningPackingAccesoriesInfo',
    GetTblIroningAndPackingAccessoriesstitchingDC: '/api/TblIroningAndPackingDCDetail/GetTblIroningAndPackingAccessoriesstitchingDC',
    ironingPackingDCDetailACCPOST: '/api/TblIroningAndPackingDCDetail/CreateTblIroningPackingAccessories',
    ironingPackingDCDetailACCDelete: '/api/TblIroningAndPackingDCDetail/DeleteTblIroningAndPackingAccessoriesDCDetail'
};

const generalPoMaster = {
    generalPoMasterGET: 'api/TblGeneralPO/GetTblGeneralPOsWithSampleOption',
    generalPoMasterPOST: '/api/TblGeneralPO/CreateTblGeneralPO',
    generalPoMasterGETID: '/api/TblGeneralPO/GetTblGeneralPO',
    generalPoMasterPATCH: '/api/TblGeneralPO/UpdateTblGeneralPO',
    generalPoMasterDELETE: '/api/TblGeneralPO/DeleteTblGeneralPO',
    generalPoMasterInvoiceGET: '/api/TblGeneralPO/TblGeneralPOPrint',
    deleteGeneralPoMasterPoApiCall: '/api/TblGeneralPO/UpdateTblGeneralPOCalloff',
    updateAllCloseIconGeneralPoMaster: '/api/TblGeneralPODetail/UpdateAllClose',
    programListsamplePO: '/api/TblGeneralPO/GetTblProgramListWithProcessOption'
};

const generalPoDetails = {
    generalPoDetailsGET: '/api/TblGeneralPODetail/GetTblGeneralPODetails',
    generalPoDetailsGET_BY_ID: '/api/TblPartyDetail/GetTblPartyDetailofParty',
    generalDcDetails: '/api/TblGeneralPODetail/GetTblGeneralPODetailofPO',
    generalPoDetailsPOST: '/api/TblGeneralPODetail/CreateTblGeneralPODetail',
    generalPoDetailsGETID: '/api/TblGeneralPODetail/GetTblGeneralPODetail',
    generalPoDetailsPATCH: '/api/TblGeneralPODetail/UpdateTblGeneralPODetail',
    generalPoDetailsDELETE: '/api/TblGeneralPODetail/DeleteTblGeneralPODetail',
    generalPODetailsApproveStatusChangeGET: '/api/TblGeneralPODetail/UpdateTblGeneralPOApproval',
    generalDcDetailsNew: '/api/TblGeneralDCDetail/GetTblGeneralDCDetailofDC'

};


const dyeingInwardMaster = {
    dyeingInwardMasterGET: '/api/TblDyeingInward/GetTblDyeingInwards',
    dyeingInwardMasterPOST: '/api/TblDyeingInward/CreateTblDyeingInward',
    dyeingInwardMasterGETID: '/api/TblDyeingInward/GetTblDyeingInward',
    dyeingInwardMasterPATCH: '/api/TblDyeingInward/UpdateTblDyeingInward',
    dyeingInwardMasterDELETE: '/api/TblDyeingInward/DeleteTblDyeingInward',
    dyeingInwardMasterPreviousGET: '/api/TblDyeingInward/GetTblDyeingDCDetails'
};

const dyeingInwardMasterDK = {
    dyeingInwardMasterDKGET: '/api/TblDyeingInwardBulk/GetTblDyeingInwardBulks',
    dyeingInwardMasterDKPOST: '/api/TblDyeingInwardBulk/CreateTblDyeingInwardBulk',
    dyeingInwardMasterDKGETID: '/api/TblDyeingInwardBulk/GetTblDyeingInwardBulk',
    dyeingInwardMasterDKPATCH: '/api/TblDyeingInwardBulk/UpdateTblDyeingInwardBulk',
    dyeingInwardMasterDKDELETE: '/api/TblDyeingInwardBulk/DeleteTblDyeingInwardBulk',
    dyeingInwardMasterDKPreviousGET: '/api/TblDyeingInwardBulk/GetTblDyeingDCDetailBulks',
    reportDKSingleDyeingProgramWiseGET: '/api/TblReports/GetInwardReports_POWise',
    dyeingDCInwardDKCompleteMasterGET: '/api/TblDyeingInwardBulk/GetTblDyeingDCDetailBulkCompleted'
};

const ironingPackingInwardMasterDK = {
    ironingPackingInwardMasterDKGET: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingInwardBulks',
    ironingPackingInwardMasterEditDataDKGET: '/api/TblIroningAndPackingInwardBulk/GetTblIronAndPack',
    ironingPackingInwardMasterDKPOST: '/api/TblIroningAndPackingInwardBulk/CreateTblIroningAndPackingInwardBulk',
    ironingPackingInwardMasterEditQtyDKPOST: '/api/TblIroningAndPackingInwardDetailBulk/CreateTblIronAndPackBulk',
    // ironingPackingInwardMasterDKPOST: '/api/TblIroningAndPackingInwardBulk/CreateTblIroningAndPackingInwardBulk',
    ironingPackingInwardMasterDKGETID: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingInwardBulk',
    ironingPackingInwardMasterDKPATCH: '/api/TblIroningAndPackingInwardBulk/UpdateTblIroningAndPackingInwardBulk',
    ironingPackingInwardMasterDKDELETE: '/api/TblIroningAndPackingInwardBulk/DeleteTblIroningAndPackingInwardBulk',
    ironingPackingInwardMasterDKPreviousGET: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingDCDetailBulks',
    reportDKSingleironingPackingProgramWiseGET: '/api/TblReports/GetInwardReports_POWise',
    ironingPackingInwardDKCompleteMasterGET: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingDCBulkCompleted'
};

const cuttingInwardMasterDK = {
    cuttingInwardMasterDKGET: '/api/TblCuttingInwardBulk/GetTblCuttingInwardBulks',
    cuttingInwardMasterEditDataDKGET: '/api/TblCuttingInwardBulk/GetTblCutting',
    cuttingInwardMasterDKPOST: '/api/TblCuttingInwardBulk/CreateTblCuttingInwardBulk',
    cuttingInwardMasterEditQtyDKPOST: '/api/TblCuttingInwardDetailBulk/CreateTblCuttingBulk',
    // cuttingInwardMasterDKPOST: '/api/TblIroningAndPackingInwardBulk/CreateTblIroningAndPackingInwardBulk',
    cuttingInwardMasterDKGETID: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingInwardBulk',
    cuttingInwardMasterDKPATCH: '/api/TblIroningAndPackingInwardBulk/UpdateTblIroningAndPackingInwardBulk',
    cuttingInwardMasterDKDELETE: '/api/TblIroningAndPackingInwardBulk/DeleteTblIroningAndPackingInwardBulk',
    cuttingInwardMasterDKPreviousGET: '/api/TblCuttingInwardBulk/GetTblCuttingDCDetailBulks',
    reportDKSingleCuttProgramWiseGET: '/api/TblReports/GetInwardReports_POWise',
    cuttingDCInwardDKCompleteMasterGET: '/api/TblCuttingInwardBulk/GetTblCuttingDCBulkCompleted'
};

const printing2InwardMasterDK = {
    printing2InwardMasterDKGET: '/api/TblPrintingPartInwardBulk/GetTblPrintingPartInwardBulks',
    printing2InwardMasterEditDataDKGET: '/api/TblPrintingPartInwardBulk/GetTblPrintingPart',
    printing2InwardMasterDKPOST: '/api/TblPrintingPartInwardBulk/CreateTblPrintingPartInwardBulk',
    printing2InwardMasterEditQtyDKPOST: '/api/TblPrintingPartInwardDetailBulk/CreateTblPrintingPartBulk',
    // printing2InwardMasterDKPOST: '/api/TblIroningAndPackingInwardBulk/CreateTblIroningAndPackingInwardBulk',
    printing2InwardMasterDKGETID: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingInwardBulk',
    printing2InwardMasterDKPATCH: '/api/TblIroningAndPackingInwardBulk/UpdateTblIroningAndPackingInwardBulk',
    printing2InwardMasterDKDELETE: '/api/TblIroningAndPackingInwardBulk/DeleteTblIroningAndPackingInwardBulk',
    printing2InwardMasterDKPreviousGET: '/api/TblPrintingPartInwardBulk/GetTblPrintingPartDCDetailBulks'
};

const stitchingInwardMasterDK = {
    stitchingInwardMasterDKGET: '/api/TblStitchingInwardBulk/GetTblStitchingInwardBulks',
    stitchingInwardMasterEditDataDKGET: '/api/TblStitchingInwardBulk/GetTblStitching',
    stitchingInwardMasterDKPOST: '/api/TblStitchingInwardBulk/CreateTblStitchingInwardBulk',
    stitchingInwardMasterEditQtyDKPOST: '/api/TblStitchingInwardDetailBulk/CreateTblStitchingBulk',
    // stitchingInwardMasterDKPOST: '/api/TblIroningAndPackingInwardBulk/CreateTblIroningAndPackingInwardBulk',
    stitchingInwardMasterDKGETID: '/api/TblIroningAndPackingInwardBulk/GetTblIroningAndPackingInwardBulk',
    stitchingInwardMasterDKPATCH: '/api/TblIroningAndPackingInwardBulk/UpdateTblIroningAndPackingInwardBulk',
    stitchingInwardMasterDKDELETE: '/api/TblStitchingInwardBulk/DeleteTblStitchingInwardBulk',
    stitchingInwardMasterDKPreviousGET: '/api/TblStitchingInwardBulk/GetTblStitchingDCDetailBulks',
    stitchDCInwardDKCompleteMasterGET: '/api/TblStitchingInwardBulk/GetTblStitchingDCDetailBulkCompleted',
    reportDKSingleStitchProgramWiseGET: '/api/TblReports/GetInwardReports_POWise'
};

const washingInwardMasterDK = {
    washingInwardMasterDKGET: '/api/TblDyeingInwardBulk/GetTblDyeingInwardBulks',
    washingInwardMasterDKPOST: '/api/TblDyeingInwardBulk/CreateTblDyeingInwardBulk',
    washingInwardMasterDKGETID: '/api/TblDyeingInwardBulk/GetTblDyeingInwardBulk',
    washingInwardMasterDKPATCH: '/api/TblDyeingInwardBulk/UpdateTblDyeingInwardBulk',
    washingInwardMasterDKDELETE: '/api/TblDyeingInwardBulk/DeleteTblDyeingInwardBulk',
    washingInwardMasterDKPreviousGET: '/api/TblDyeingInwardBulk/GetTblDyeingDCDetailBulks'
};

const dyeingInwardDetails = {
    dyeingInwardDetailsGET: '/api/TblDyeingInwardDetail/GetTblDyeingInwardDetails',
    dyeingInwardDetailsGET_BY_ID: '/api/TblDyeingInwardDetail/GetTblDyeingInwardDetailofInward',
    dyeingInwardDetailsPOST: '/api/TblDyeingInwardDetail/CreateTblDyeingInwardDetail',
    dyeingInwardDetailsGETID: '/api/TblDyeingInwardDetail/GetTblDyeingInwardDetail',
    dyeingInwardDetailsPATCH: '/api/TblDyeingInwardDetail/UpdateTblDyeingInwardDetail',
    dyeingInwardDetailsDELETE: '/api/TblDyeingInwardDetail/DeleteTblDyeingInwardDetail'
};

const dyeingInwardDKDetails = {
    dyeingInwardDKDetailsGET: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulks',
    dyeingInwardDKDetailsGET_BY_ID: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulkofInward',
    dyeingInwardDKDetailsPOST: '/api/TblDyeingInwardDetailBulk/CreateTblDyeingInwardDetailBulk',
    dyeingInwardDKDetailsGETID: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulk',
    dyeingInwardDKDetailsPATCH: '/api/TblDyeingInwardDetailBulk/UpdateTblDyeingInwardDetailBulk',
    dyeingInwardDKDetailsDELETE: '/api/TblDyeingInwardDetailBulk/DeleteTblDyeingInwardDetailBulk'
};

const ironingPackingInwardDKDetails = {
    ironingPackingInwardDKDetailsGET: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulks',
    ironingPackingInwardDKDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulkofInward',
    // ironingPackingInwardDKDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulkofInward',
    ironingPackingInwardDKDetailsPOST: '/api/TblIroningAndPackingInwardDetailBulk/CreateTblIroningAndPackingInwardDetailBulk',
    ironingPackingInwardDKDetailsGETID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulk',
    ironingPackingInwardDKDetailsPATCH: '/api/TblIroningAndPackingInwardDetailBulk/UpdateTblIroningAndPackingInwardDetailBulk',
    ironingPackingInwardDKDetailsDELETE: '/api/TblIroningAndPackingInwardDetailBulk/DeleteTblIroningAndPackingInwardDetailBulk'
};

const cuttingInwardDKDetails = {
    cuttingInwardDKDetailsGET: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulks',
    cuttingInwardDKDetailsGET_BY_ID: '/api/TblCuttingInwardDetailBulk/GetTblCuttingInwardDetailBulkofInward',
    // cuttingInwardDKDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulkofInward',
    cuttingInwardDKDetailsPOST: '/api/TblIroningAndPackingInwardDetailBulk/CreateTblIroningAndPackingInwardDetailBulk',
    cuttingInwardDKDetailsGETID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulk',
    cuttingInwardDKDetailsPATCH: '/api/TblIroningAndPackingInwardDetailBulk/UpdateTblIroningAndPackingInwardDetailBulk',
    cuttingInwardDKDetailsDELETE: '/api/TblIroningAndPackingInwardDetailBulk/DeleteTblIroningAndPackingInwardDetailBulk'
};

const printing2InwardDKDetails = {
    printing2InwardDKDetailsGET: '/api/TblPrintingPartInwardDetailBulk/GetTblPrintingPartInwardDetailBulks',
    printing2InwardDKDetailsGET_BY_ID: '/api/TblPrintingPartInwardDetailBulk/GetTblPrintingPartInwardDetailBulkofInward',
    // printing2InwardDKDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulkofInward',
    printing2InwardDKDetailsPOST: '/api/TblIroningAndPackingInwardDetailBulk/CreateTblIroningAndPackingInwardDetailBulk',
    printing2InwardDKDetailsGETID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulk',
    printing2InwardDKDetailsPATCH: '/api/TblIroningAndPackingInwardDetailBulk/UpdateTblIroningAndPackingInwardDetailBulk',
    printing2InwardDKDetailsDELETE: '/api/TblIroningAndPackingInwardDetailBulk/DeleteTblIroningAndPackingInwardDetailBulk'
};

const stitchingInwardDKDetails = {
    stitchingInwardDKDetailsGET: '/api/TblStitchingInwardDetailBulk/GetTblStitchingInwardDetailBulks',
    stitchingInwardDKDetailsGET_BY_ID: '/api/TblStitchingInwardDetailBulk/GetTblStitchingInwardDetailBulkofInward',
    // stitchingInwardDKDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulkofInward',
    stitchingInwardDKDetailsPOST: '/api/TblIroningAndPackingInwardDetailBulk/CreateTblIroningAndPackingInwardDetailBulk',
    stitchingInwardDKDetailsGETID: '/api/TblIroningAndPackingInwardDetailBulk/GetTblIroningAndPackingInwardDetailBulk',
    stitchingInwardDKDetailsPATCH: '/api/TblIroningAndPackingInwardDetailBulk/UpdateTblIroningAndPackingInwardDetailBulk',
    stitchingInwardDKDetailsDELETE: '/api/TblIroningAndPackingInwardDetailBulk/DeleteTblIroningAndPackingInwardDetailBulk'
};

const washingInwardDKDetails = {
    washingInwardDKDetailsGET: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulks',
    washingInwardDKDetailsGET_BY_ID: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulkofInward',
    washingInwardDKDetailsPOST: '/api/TblDyeingInwardDetailBulk/CreateTblDyeingInwardDetailBulk',
    washingInwardDKDetailsGETID: '/api/TblDyeingInwardDetailBulk/GetTblDyeingInwardDetailBulk',
    washingInwardDKDetailsPATCH: '/api/TblDyeingInwardDetailBulk/UpdateTblDyeingInwardDetailBulk',
    washingInwardDKDetailsDELETE: '/api/TblDyeingInwardDetailBulk/DeleteTblDyeingInwardDetailBulk'
};

const printingDcInwardMaster = {
    printingDcInwardMasterGET: '/api/TblPrintingInward/GetTblPrintingInwards',
    printingDcInwardMasterPOST: '/api/TblPrintingInward/CreateTblPrintingInward',
    printingDcInwardMasterGETID: '/api/TblPrintingInward/GetTblPrintingInward',
    printingDcInwardMasterPATCH: '/api/TblPrintingInward/UpdateTblPrintingInward',
    printingDcInwardMasterDELETE: '/api/TblPrintingInward/DeleteTblPrintingInward',
    printingDCInwardMasterPendingGET: '/api/TblPrintingInward/GetTblPrintingDCDetails'
};

const printingPartDcInwardMaster = {
    // old
    // printingPartDcInwardMasterGET: '/api/TblPrintingPartInward/GetTblPrintingPartInwards',

    printingPartDcInwardMasterGET: '/api/TblPrintingPartInward/GetTblPrintingPartInwardsWithProcessOption',

    printingPartDcInwardMasterPOST: '/api/TblPrintingPartInward/CreateTblPrintingPartInward',
    printingPartDcInwardMasterGETID: '/api/TblPrintingPartInward/GetTblPrintingPartInward',
    printingPartDcInwardMasterPATCH: '/api/TblPrintingPartInward/UpdateTblPrintingPartInward',
    printingPartDcInwardMasterDELETE: '/api/TblPrintingPartInward/DeleteTblPrintingPartInward',

    // old one
    // printingPartDCInwardMasterPendingGET: '/api/TblPrintingPartInward/GetTblPrintingPartDCDetails'

    printingPartDCInwardMasterPendingGET: '/api/TblPrintingPartInward/GetTblPrintingPartDCDetailsWithProcessOption'

};

const printingDcInwardDKMaster = {
    printingDcInwardDKMasterGET: '/api/TblPrintingInwardBulk/GetTblPrintingInwardBulks',
    printingDcInwardDKMasterPOST: '/api/TblPrintingInwardBulk/CreateTblPrintingInwardBulk',
    printingDcInwardDKMasterGETID: '/api/TblPrintingInwardBulk/GetTblPrintingInwardBulk',
    printingDcInwardDKMasterPATCH: '/api/TblPrintingInwardBulk/UpdateTblPrintingInwardBulk',
    printingDcInwardDKMasterDELETE: '/api/TblPrintingInwardBulk/DeleteTblPrintingInwardBulk',
    printingDcInwardDKMasterPreviousGET: '/api/TblPrintingInwardBulk/GetTblPrintingDCDetailBulks',
    reportDKSinglePrintingDCProgramWiseGET: '/api/TblReports/GetInwardReports_POWise',
    printingDCInwardDKCompleteMasterGET: '/api/TblPrintingInwardBulk/GetTblPrintingDCDetailBulkCompleted'
};

const printingPartDcInwardDetails = {
    printingDcPartInwardDetailsGET: '/api/TblPrintingPartInwardDetail/GetTblPrintingPartInwardDetails',
    printingDcPartInwardDetailsGET_BY_ID: '/api/TblPrintingPartInwardDetail/GetTblPrintingPartInwardDetailofInward',
    printingpartInwardDetailsPOST: '/api/TblPrintingPartInwardDetail/CreateTblPrintingPartInwards',
    printingDcPartInwardDetailsGETID: '/api/TblPrintingPartInwardDetail/GetTblPrintingPartInwardDetail',
    printingDcPartInwardDetailsPATCH: '/api/TblPrintingPartInwardDetail/UpdateTblPrintingPartInwardDetail',
    printingDcPartInwardDetailsDELETE: '/api/TblPrintingPartInwardDetail/DeleteTblPrintingPartInwardDetail',
    printingDCPartInwardDetailsPreviousGETID: '/api/TblPrintingPartInwardDetail/GetTblPrintingPart',
    //printingPartInwardDetailsQtyGET: '/api/TblPrintingPartInwardDetail/GetTblPrintingPart'
};

const printingDcInwardDetails = {
    printingDcInwardDetailsGET: '/api/TblPrintingInwardDetail/GetTblPrintingInwardDetails',
    printingDcInwardDetailsGET_BY_ID: '/api/TblPrintingInwardDetail/GetTblPrintingInwardDetailofInward',
    printingDcInwardDetailsPOST: '/api/TblPrintingInwardDetail/CreateTblPrintingInwardDetail',
    printingDcInwardDetailsGETID: '/api/TblPrintingInwardDetail/GetTblPrintingInwardDetail',
    printingDcInwardDetailsPATCH: '/api/TblPrintingInwardDetail/UpdateTblPrintingInwardDetail',
    printingDcInwardDetailsDELETE: '/api/TblPrintingInwardDetail/DeleteTblPrintingInwardDetail',
    printingDCInwardDetailsPreviousGETID: '/api/TblYarnInwardDetail/GetPreviousTblYarnPODetails'
};

const printingDcInwardDKDetails = {
    printingDcInwardDKDetailsGET: '/api/TblPrintingInwardDetailBulk/GetTblPrintingInwardDetailBulks',
    printingDcInwardDKDetailsGET_BY_ID: '/api/TblPrintingInwardDetailBulk/GetTblPrintingInwardDetailBulkofInward',
    printingDcInwardDKDetailsPOST: '/api/TblPrintingInwardDetailBulk/CreateTblPrintingInwardDetailBulk',
    printingDcInwardDKDetailsGETID: '/api/TblPrintingInwardDetailBulk/GetTblPrintingInwardDetailBulk',
    printingDcInwardDKDetailsPATCH: '/api/TblPrintingInwardDetailBulk/UpdateTblPrintingInwardDetailBulk',
    printingDcInwardDKDetailsDELETE: '/api/TblPrintingInwardDetailBulk/DeleteTblPrintingInwardDetailBulk'
};

const yarnPoInwardMaster = {
    yarnPoInwardMasterGET: '/api/TblYarnInward/GetTblYarnInwards',
    yarnPoInwardMasterPendingGET: '/api/TblYarnInward/GetTblYarnPODetail',
    yarnPoInwardMasterPOST: '/api/TblYarnInward/CreateTblYarnInward',
    yarnPoInwardMasterGETID: '/api/TblYarnInward/GetTblYarnInward',
    yarnPoInwardMasterPATCH: '/api/TblYarnInward/UpdateTblYarnInward',
    yarnPoInwardMasterDELETE: '/api/TblYarnInward/DeleteTblYarnInward',
    yarnPoInwardPendingMasterGET: '/api/TblYarnInward/DeleteTblYarnInward',
    yarnPoInwardDetailsPreviousGETID: '/api/TblYarnInwardDetail/GetPreviousTblYarnPODetails'
};


const inwardDetailSOandSN = {
    inwardDetailSOandSNGET: '/api/TblYarnInwardDetail/GetPendingSaleOrderByProgram'
};

const yarnPoInwardDKMaster = {
    yarnPoInwardDKMasterGET: '/api/TblYarnInwardBulk/GetTblYarnInwardBulks',
    yarnPoInwardDKMasterPOST: '/api/TblYarnInwardBulk/CreateTblYarnInwardBulk',
    yarnPoInwardDKMasterGETID: '/api/TblYarnInwardBulk/GetTblYarnInwardBulk',
    yarnPoInwardDKMasterPATCH: '/api/TblYarnInwardBulk/UpdateTblYarnInwardBulk',
    yarnPoInwardDKMasterDELETE: '/api/TblYarnInwardBulk/DeleteTblYarnInwardBulk',
    yarnPoInwardDKPendingMasterGET: '/api/TblYarnInwardBulk/GetTblYarnPODetail',
    yarnPoInwardDKCompleteMasterGET: '/api/TblYarnInwardBulk/GetTblYarnPOCompleted',
    reportDKSingleYarnProgramWiseGET: '/api/TblReports/GetInwardReports_POWise'
};

const yarnPoInwardDetails = {
    yarnPoInwardDetailsGET: '/api/TblYarnInwardDetail/GetTblYarnInwardDetails',
    yarnPoInwardDetailsGET_BY_ID: '/api/TblYarnInwardDetail/GetTblYarnInwardDetailofInward',
    yarnPoInwardDetailsPOST: '/api/TblYarnInwardDetail/CreateTblYarnInwardDetail',
    yarnPoInwardDetailsGETID: '/api/TblYarnInwardDetail/GetTblYarnInwardDetail',
    yarnPoInwardDetailsPATCH: '/api/TblYarnInwardDetail/UpdateTblYarnInwardDetail',
    yarnPoInwardDetailsDELETE: '/api/TblYarnInwardDetail/DeleteTblYarnInwardDetail'
};

const yarnPoInwardDKDetails = {
    yarnPoInwardDKDetailsGET: '/api/TblYarnInwardDetailBulk/GetTblYarnInwardDetailBulks',
    yarnPoInwardDKDetailsGET_BY_ID: '/api/TblYarnInwardDetailBulk/GetTblYarnInwardDetailBulkofInward',
    yarnPoInwardDKDetailsPOST: '/api/TblYarnInwardDetailBulk/CreateTblYarnInwardDetailBulk',
    yarnPoInwardDKDetailsGETID: '/api/TblYarnInwardDetailBulk/GetTblYarnInwardDetailBulk',
    yarnPoInwardDKDetailsPreviousGETID: '/api/TblYarnInwardDetailBulk/GetPreviousTblYarnPODetailBulks',
    yarnPoInwardDKDetailsPATCH: '/api/TblYarnInwardDetailBulk/UpdateTblYarnInwardDetailBulk',
    yarnPoInwardDKDetailsDELETE: '/api/TblYarnInwardDetailBulk/DeleteTblYarnInwardDetailBulk'
};

const fabricPoInwardMaster = {
    fabricPoInwardMasterGET: '/api/TblFabricInward/GetTblFabricInwards',
    fabricPoInwardMasterPOST: '/api/TblFabricInward/CreateTblFabricInward',
    fabricPoInwardMasterGETID: '/api/TblFabricInward/GetTblFabricInward',
    fabricPoInwardMasterPATCH: '/api/TblFabricInward/UpdateTblFabricInward',
    fabricPoInwardMasterDELETE: '/api/TblFabricInward/DeleteTblFabricInward',
    fabricPoInwardPendingMasterGET: '/api/TblFabricInward/GetTblFabricPODetails'
};

const fabricPoInwardMasterDK = {
    fabricPoInwardMasterDKGET: '/api/TblFabricInwardBulk/GetTblFabricInwardBulks',
    fabricPoInwardMasterDKPOST: '/api/TblFabricInwardBulk/CreateTblFabricInwardBulk',
    fabricPoInwardMasterDKGETID: '/api/TblFabricInwardBulk/GetTblFabricInwardBulk',
    fabricPoInwardMasterDKPATCH: '/api/TblFabricInwardBulk/UpdateTblFabricInwardBulk',
    fabricPoInwardMasterDKDELETE: '/api/TblFabricInwardBulk/DeleteTblFabricInwardBulk',
    fabricPoInwardDKPendingMasterGET: '/api/TblFabricInwardBulk/GetTblFabricPODetailBulks',
    fabricPoInwardDKCompleteMasterGET: '/api/TblFabricInwardBulk/GetTblFabricPODetailBulkCompleted',
    reportDKSingleFabricProgramWiseGET: '/api/TblReports/GetInwardReports_POWise'
};

const generalPoInwardMasterDK = {
    generalPoInwardMasterDKGET: '/api/TblGeneralPOInwardBulk/GetTblGeneralPOInwardBulks',
    generalPoInwardMasterDKPOST: '/api/TblGeneralPOInwardBulk/CreateTblGeneralPOInwardBulk',
    generalPoInwardMasterDKGETID: '/api/TblGeneralPOInwardBulk/GetTblGeneralPOInwardBulk',
    generalPoInwardMasterDKPATCH: '/api/TblGeneralPOInwardBulk/UpdateTblGeneralPOInwardBulk',
    generalPoInwardMasterDKDELETE: '/api/TblGeneralPOInwardBulk/DeleteTblGeneralPOInwardBulk',
    generalPoInwardDKPendingMasterGET: '/api/TblGeneralPOInwardBulk/GetTblGeneralPODetailBulks'
};

const accessoriesPoInwardMasterDK = {
    accessoriesPoInwardMasterDKGET: '/api/TblAccessoriesPOInwardBulk/GetTblAccessoriesPOInwardBulks',
    accessoriesPoInwardMasterDKPOST: '/api/TblAccessoriesPOInwardBulk/CreateTblAccessoriesPOInwardBulk',
    accessoriesPoInwardMasterDKGETID: '/api/TblAccessoriesPOInwardBulk/GetTblAccessoriesPOInwardBulk',
    accessoriesPoInwardMasterDKPATCH: '/api/TblAccessoriesPOInwardBulk/UpdateTblAccessoriesPOInwardBulk',
    accessoriesPoInwardMasterDKDELETE: '/api/TblAccessoriesPOInwardBulk/DeleteTblAccessoriesPOInwardBulk',
    accessoriesPoInwardDKPendingMasterGET: '/api/TblAccessoriesPOInwardBulk/GetTblAccessoriesPODetailBulks',
    accessoriesPoInwardStyleDKGET: '/api/TblStyleMasterBasic/GetStyleNumber'
};

const fabricPoInwardDetails = {
    fabricPoInwardDetailsGET: '/api/TblFabricInwardDetail/GetTblFabricInwardDetails',
    fabricPoInwardDetailsGET_BY_ID: '/api/TblFabricInwardDetail/GetTblFabricInwardDetailofInward',
    fabricPoInwardDetailsPOST: '/api/TblFabricInwardDetail/CreateTblFabricInwardDetail',
    fabricPoInwardDetailsPOSTMulti: '/api/TblFabricInwardDetail/CreateTblFabricInwardMultipleDetail',
    fabricPoInwardDetailsGETID: '/api/TblFabricInwardDetail/GetTblFabricInwardDetail',
    fabricPoInwardDetailsPATCH: '/api/TblFabricInwardDetail/UpdateTblFabricInwardDetail',
    fabricPoInwardDetailsDELETE: '/api/TblFabricInwardDetail/DeleteTblFabricInwardDetail'
};

const fabricPoInwardDetailsDK = {
    fabricPoInwardDetailsDKGET: '/api/TblFabricInwardDetailBulk/GetTblFabricInwardDetailBulks',
    fabricPoInwardDetailsDKGET_BY_ID: '/api/TblFabricInwardDetailBulk/GetTblFabricInwardDetailBulkofInward',
    fabricPoInwardDetailsDKPOST: '/api/TblFabricInwardDetailBulk/CreateTblFabricInwardDetailBulk',
    fabricPoInwardDetailsDKGETID: '/api/TblFabricInwardDetailBulk/GetTblFabricInwardDetailBulk',
    fabricPoInwardDKDetailsPreviousGETID: '/api/TblFabricInwardDetailBulk/GetPreviousTblFabricPODetailBulks',
    fabricPoInwardDetailsDKPATCH: '/api/TblFabricInwardDetailBulk/UpdateTblFabricInwardDetailBulk',
    fabricPoInwardDetailsDKDELETE: '/api/TblFabricInwardDetailBulk/DeleteTblFabricInwardDetailBulk'
};

const generalPoInwardDetailsDK = {
    generalPoInwardDetailsDKGET: '/api/TblGeneralPOInwardDetailBulk/GetTblGeneralPOInwardDetailBulks',
    generalPoInwardDetailsDKGET_BY_ID: '/api/TblGeneralPOInwardDetailBulk/GetTblGeneralPOInwardDetailBulkofInward',
    generalPoInwardDetailsDKPOST: '/api/TblGeneralPOInwardDetailBulk/CreateTblGeneralPOInwardDetailBulk',
    generalPoInwardDetailsDKGETID: '/api/TblGeneralPOInwardDetailBulk/GetTblGeneralPOInwardDetailBulk',
    generalPoInwardDetailsDKPATCH: '/api/TblGeneralPOInwardDetailBulk/UpdateTblGeneralPOInwardDetailBulk',
    generalPoInwardDetailsDKDELETE: '/api/TblGeneralPOInwardDetailBulk/DeleteTblGeneralPOInwardDetailBulk',
    generalPoInwardDKDetailsPreviousGETID: '/api/TblGeneralPOInwardDetailBulk/GetPendingGrid'
};

const accessoriesPoInwardDetailsDK = {
    accessoriesPoInwardDetailsDKGET: '/api/TblAccessoriesPOInwardDetailBulk/GetTblAccessoriesPOInwardDetailBulks',
    accessoriesPoInwardDetailsDKGET_BY_ID: '/api/TblAccessoriesPOInwardDetailBulk/GetTblAccessoriesPOInwardDetailBulkofInward',
    accessoriesPoInwardDetailsDKPOST: '/api/TblAccessoriesPOInwardDetailBulk/CreateTblAccessoriesPOInwardDetailBulk',
    accessoriesPoInwardDetailsDKGETID: '/api/TblAccessoriesPOInwardDetailBulk/GetTblAccessoriesPOInwardDetailBulk',
    accessoriesPoInwardDetailsDKPATCH: '/api/TblAccessoriesPOInwardDetailBulk/UpdateTblAccessoriesPOInwardDetailBulk',
    accessoriesPoInwardDetailsDKDELETE: '/api/TblAccessoriesPOInwardDetailBulk/DeleteTblAccessoriesPOInwardDetailBulk',
    accessoriesPoInwardDKDetailsPreviousGETID: '/api/TblAccessoriesPOInwardDetailBulk/GetPendingGrid'
};

const knittingInwardMaster = {
    knittingInwardMasterGET: '/api/TblKnittingInward/GetTblKnittingInwards',
    knittingInwardMasterPOST: '/api/TblKnittingInward/CreateTblKnittingInward',
    knittingInwardMasterGETID: '/api/TblKnittingInward/GetTblKnittingInward',
    knittingInwardMasterPATCH: '/api/TblKnittingInward/UpdateTblKnittingInward',
    knittingInwardMasterDELETE: '/api/TblKnittingInward/DeleteTblKnittingInward',
    knittingInwardPendingMasterEproGET: '/api/TblKnittingInward/GetTblKnittingDCDetails'
};

const stitchingInwardMaster = {
    stitchingInwardMasterGET: '/api/TblStitchingInward/GetTblStitchingInwards',
    stitchingInwardMasterPOST: '/api/TblStitchingInward/CreateTblStitchingInward',
    stitchingInwardMasterGETID: '/api/TblStitchingInward/GetTblStitchingInward',
    stitchingInwardMasterPATCH: '/api/TblStitchingInward/UpdateTblStitchingInward',
    stitchingInwardMasterDELETE: '/api/TblStitchingInward/DeleteTblStitchingInward',
    stitchingInwardPendingMasterEproGET: '/api/TblStitchingInward/GetTblStitchingDCPending'
};

const ironingAndPackingInwardMaster = {
    ironingAndPackingInwardMasterGET: '/api/TblIroningAndPackingInward/GetTblIroningAndPackingInwards',
    ironingAndPackingInwardMasterPOST: '/api/TblIroningAndPackingInward/CreateTblIroningAndPackingInward',
    ironingAndPackingInwardMasterGETID: '/api/TblIroningAndPackingInward/GetTblIroningAndPackingInward',
    ironingAndPackingInwardMasterPATCH: '/api/TblIroningAndPackingInward/UpdateTblIroningAndPackingInward',
    ironingAndPackingInwardMasterDELETE: '/api/TblIroningAndPackingInward/DeleteTblIroningAndPackingInward',
    ironingAndPackingInwardPendingMasterEproGET: '/api/TblIroningAndPackingInward/GetTblIroningAndPackingDCDetails',
    GetPkdQtyAgainstSaleOrderofIPInward: '/api/TblIroningAndPackingInward/GetPkdQtyAgainstSaleOrderofIPInward',
    ironingAndPackingInwardCheckEANExist: '/api/TblIroningAndPackingInward/GetCheckEANExistforInwardArticles',
};

const knittingInwardDKMaster = {
    knittingInwardDKMasterGET: '/api/TblKnittingInwardBulk/GetTblKnittingInwardBulks',
    knittingInwardDKMasterPOST: '/api/TblKnittingInwardBulk/CreateTblKnittingInwardBulk',
    knittingInwardDKMasterGETID: '/api/TblKnittingInwardBulk/GetTblKnittingInwardBulk',
    knittingInwardDKMasterPATCH: '/api/TblKnittingInwardBulk/UpdateTblKnittingInwardBulk',
    knittingInwardDKMasterDELETE: '/api/TblKnittingInwardBulk/DeleteTblKnittingInwardBulk',
    knittingInwardPendingMasterGET: '/api/TblKnittingInwardBulk/GetTblKnittingDCDetails',
    knittingdcInwardDKCompleteMasterGET: '/api/TblKnittingInwardBulk/GetTblKnittingDCDetailBulkCompleted'
};

const generalDCInwardDKMaster = {
    generalDCInwardDKMasterGET: '/api/TblGeneralDCInwardBulk/GetTblGeneralDCInwardBulks',
    generalDCInwardDKMasterPOST: '/api/TblGeneralDCInwardBulk/CreateTblGeneralDCInwardBulk',
    generalDCInwardDKMasterGETID: '/api/TblGeneralDCInwardBulk/GetTblGeneralDCInwardBulk',
    generalDCInwardDKMasterPATCH: '/api/TblGeneralDCInwardBulk/UpdateTblGeneralDCInwardBulk',
    generalDCInwardDKMasterDELETE: '/api/TblGeneralDCInwardBulk/DeleteTblGeneralDCInwardBulk',
    generalDCInwardDKPendingMasterGET: '/api/TblGeneralDCInwardBulk/GetTblGeneralDCDetailBulks'
};

const knittingInwardDetails = {
    knittingInwardDetailsGET: '/api/TblKnittingInwardDetail/GetTblKnittingInwardDetails',
    knittingInwardDetailsGET_BY_ID: '/api/TblKnittingInwardDetail/GetTblKnittingInwardDetailofInward',
    knittingInwardDetailsPOST: '/api/TblKnittingInwardDetail/CreateTblKnittingInwardDetail',
    knittingInwardDetailsGETID: '/api/TblKnittingInwardDetail/GetTblKnittingInwardDetail',
    knittingInwardDetailsPATCH: '/api/TblKnittingInwardDetail/UpdateTblKnittingInwardDetail',
    knittingInwardDetailsDELETE: '/api/TblKnittingInwardDetail/DeleteTblKnittingInwardDetail'
};

const knittingInwardDKDetails = {
    knittingInwardDKDetailsGET: '/api/TblKnittingInwardDetailBulk/GetTblKnittingInwardDetailBulks',
    knittingInwardDKDetailsGET_BY_ID: '/api/TblKnittingInwardDetailBulk/GetTblKnittingInwardDetailBulkofInward',
    knittingInwardDKDetailsPOST: '/api/TblKnittingInwardDetailBulk/CreateTblKnittingInwardDetailBulk',
    knittingInwardDKDetailsGETID: '/api/TblKnittingInwardDetailBulk/GetTblKnittingInwardDetailBulk',
    knittingInwardDKDetailsPATCH: '/api/TblKnittingInwardDetailBulk/UpdateTblKnittingInwardDetailBulk',
    knittingInwardDKDetailsDELETE: '/api/TblKnittingInwardDetailBulk/DeleteTblKnittingInwardDetailBulk'
};

const generalDCInwardDKDetails = {
    generalDCInwardDKDetailsGET: '/api/TblGeneralDCInwardDetailBulk/GetTblGeneralDCInwardDetailBulks',
    generalDCInwardDKDetailsGET_BY_ID: '/api/TblGeneralDCInwardDetailBulk/GetTblGeneralDCInwardDetailBulkofInward',
    generalDCInwardDKDetailsPOST: '/api/TblGeneralDCInwardDetailBulk/CreateTblGeneralDCInwardDetailBulk',
    generalDCInwardDKDetailsGETID: '/api/TblGeneralDCInwardDetailBulk/GetTblGeneralDCInwardDetailBulk',
    generalDCInwardDKDetailsPATCH: '/api/TblGeneralDCInwardDetailBulk/UpdateTblGeneralDCInwardDetailBulk',
    generalDCInwardDKDetailsDELETE: '/api/TblGeneralDCInwardDetailBulk/DeleteTblGeneralDCInwardDetailBulk',
    generalDCInwardDKDetailsPreviousGETID: '/api/TblGeneralDCInwardDetailBulk/GetPendingGrid'
};

const cuttingDCMaster = {
    cuttingDCMasterGET: '/api/TblCuttingDC/GetTblCuttingDCs',
    cuttingDCMasterPOST: '/api/TblCuttingDC/CreateTblCuttingDC',
    cuttingDCMasterGETID: '/api/TblCuttingDC/GetTblCuttingDC',
    cuttingDCMasterPATCH: '/api/TblCuttingDC/UpdateTblCuttingDC',
    cuttingDCMasterDELETE: '/api/TblCuttingDC/DeleteTblCuttingDC',
    cuttingDCStyleMasterGET: '/api/TblStyleMasterBasic/GetStyleNumber',
    cuttingDCFormatMasterGET: '/api/TblFormatMaster/GetAllTblFormatMaster',
    cuttingDCInvoiceGET: '/api/TblCuttingDC/TblCuttingDCPrint',
    cutDCQtyWithSizeForPrintGET: '/api/TblCuttingDC/GetQtyWithSizeForPrint',
    deleteDCDetails: 'api/TblCuttingDCDetail/DeleteTblCuttingDCDetail',
    deleteDCDetailsCallOff: 'api/TblCuttingDCDetail/UpdateTblCuttingDCCalloffAll'
};

const cuttingDcDetails = {
    cuttingDcDetailsGET: '/api/TblCuttingDCDetail/GetTblCuttingDCDetails',
    cuttingDcDetailsGET_BY_ID_INNER: 'api/TblCuttingDCDetail/GetTblCuttingDCDetailofDC',
    // cuttingDcDetailsGET_BY_ID: '/api/TblCuttingDCDetail/GetTblCuttingDCDetailPartWithSizes',
    cuttingDcDetailsGET_BY_ID: '/api/TblCuttingDCDetail/GetCuttingPartwithColour',
    cuttingDcDetailsPOST: '/api/TblCuttingDCDetail/CreateTblCuttingDCDetail',
    saveCuttingDcDetailsPOST: '/api/TblCuttingDCDetail/CreateTblCuttingDCDetailWithPart',
    cuttingDcDetailsGETID: '/api/TblCuttingDCDetail/GetTblCuttingDCDetail',
    cuttingDcDetailsPATCH: '/api/TblCuttingDCDetail/UpdateTblCuttingDCDetail',
    cuttingDcDetailsDELETE: '/api/TblCuttingDCDetail/DeleteTblCuttingDCDetail',
    // for getList
    cuttingDcDetailsPreviousGetList: '/api/TblYarnInwardDetail/GetPreviousProgramgetlist',
    cuttingDcDetailsPreviousGetListStitching: '/api/TblYarnInwardDetail/GetPreviousProgramgetlistSales',
    cuttingDcDetailsSizeGrid: '/api/TblCuttingDCDetail/LoadGridWithSize',
    cuttingDCQty: '/api/TblCuttingDCDetail/GetExistingTblCuttingDCDetailPartWithSizeofGroupDC',
    cuttingqtyInnerApi: '/api/TblCuttingDCDetail/GetExistingTblCuttingDCDetailColorInfo',
    cuttingDCFabricDelete: 'api/TblCuttingDCDetail/DeleteTblCuttingDCDetail'
};

const checkingDcMaster = {
    checkingDcMasterGET: '/api/TblCheckingDC/GetTblCheckingDCs',
    checkingDcMasterPOST: '/api/TblCheckingDC/CreateTblCheckingDC',
    checkingDcMasterGETID: '/api/TblCheckingDC/GetTblCheckingDC',
    checkingDcMasterPATCH: '/api/TblCheckingDC/UpdateTblCheckingDC',
    checkingDcMasterDELETE: '/api/TblCheckingDC/DeleteTblCheckingDC'
};

const checkingDcDetails = {
    checkingDcDetailsGET: '/api/TblCheckingDCDetail/GetTblCheckingDCDetails',
    checkingDcDetailsGET_BY_ID: '/api/TblCheckingDCDetail/GetTblCheckingDCDetailofDC',
    checkingDcDetailsPOST: '/api/TblCheckingDCDetail/CreateTblCheckingDCDetail',
    checkingDcDetailsGETID: '/api/TblCheckingDCDetail/GetTblCheckingDCDetail',
    checkingDcDetailsPATCH: '/api/TblCheckingDCDetail/UpdateTblCheckingDCDetail',
    checkingDcDetailsDELETE: '/api/TblCheckingDCDetail/DeleteTblCheckingDCDetail'
};

const ironingPackingDcInwardMaster = {
    ironingPackingDcInwardMasterMasterGET: '/api/TblIroningAndPackingInward/GetTblIroningAndPackingInwards',
    ironingPackingDcInwardMasterMasterPOST: '/api/TblIroningAndPackingInward/CreateTblIroningAndPackingInward',
    ironingPackingDcInwardMasterMasterGETID: '/api/TblIroningAndPackingInward/GetTblIroningAndPackingInward',
    ironingPackingDcInwardMasterMasterPATCH: '/api/TblIroningAndPackingInward/UpdateTblIroningAndPackingInward',
    ironingPackingDcInwardMasterMasterDELETE: '/api/TblIroningAndPackingInward/DeleteTblIroningAndPackingInward'
};

const ironingPackingDcInwardDetails = {
    ironingPackingDcInwardDetailsGET: '/api/TblIroningAndPackingInwardDetail/GetTblIroningAndPackingInwardDetails',
    ironingPackingDcInwardDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetail/GetTblIroningAndPackingInwardDetailofInward',
    ironingPackingDcInwardDetailsPOST: '/api/TblIroningAndPackingInwardDetail/CreateTblIroningAndPackingInwardDetail',
    ironingPackingDcInwardDetailsGETID: '/api/TblIroningAndPackingInwardDetail/GetTblIroningAndPackingInwardDetail',
    ironingPackingDcInwardDetailsPATCH: '/api/TblIroningAndPackingInwardDetail/UpdateTblIroningAndPackingInwardDetail',
    ironingPackingDcInwardDetailsDELETE: '/api/TblIroningAndPackingInwardDetail/DeleteTblIroningAndPackingInwardDetail'
};

const generalPoInwardMaster = {
    generalPoInwardMasterMasterGET: '/api/TblGeneralPOInward/GetTblGeneralPOInwardsWithProcessOption',
    generalPoInwardMasterMasterPOST: '/api/TblGeneralPOInward/CreateTblGeneralPOInward',
    generalPoInwardMasterMasterGETID: '/api/TblGeneralPOInward/GetTblGeneralPOInward',
    generalPoInwardMasterMasterPATCH: '/api/TblGeneralPOInward/UpdateTblGeneralPOInward',
    generalPoInwardMasterMasterDELETE: '/api/TblGeneralPOInward/DeleteTblGeneralPOInward',
    generalPoInwardMasterPendingGET: '/api/TblGeneralPOInward/GetTblGeneralPOsWithProcessOption'
};

const generalPoInwardDetails = {
    generalPoInwardDetailsGET: '/api/TblGeneralPOInwardDetail/GetTblGeneralPOInwardDetails',
    generalPoInwardDetailsGET_BY_ID: '/api/TblGeneralPOInwardDetail/GetTblGeneralPOInwardDetailofInward',
    generalPoInwardDetailsPOST: '/api/TblGeneralPOInwardDetail/CreateTblGeneralPOInwardDetail',
    generalPoInwardDetailsGETID: '/api/TblGeneralPOInwardDetail/GetTblGeneralPOInwardDetail',
    generalPoInwardDetailsPATCH: '/api/TblGeneralPOInwardDetail/UpdateTblGeneralPOInwardDetail',
    generalPoInwardDetailsDELETE: '/api/TblGeneralPOInwardDetail/DeleteTblGeneralPOInwardDetail',
    generalPoInwardDetailsGet: '/api/TblYarnInwardDetail/GetPreviousTblYarnPODetails',
    generalPoInwardDetail: 'api/TblGeneralPOInwardDetail/GetTblGeneralPOInwardDetailofInward'


};

const accessoriesPoInwardMaster = {
    accessoriesPoInwardMasterMasterGET: '/api/TblAccessoriesPOInward/GetTblAccessoriesPOInwards',
    accessoriesPoInwardMasterMasterPOST: '/api/TblAccessoriesPOInward/CreateTblAccessoriesPOInward',
    accessoriesPoInwardMasterMasterGETID: '/api/TblAccessoriesPOInward/GetTblAccessoriesPOInward',
    accessoriesPoInwardMasterMasterPATCH: '/api/TblAccessoriesPOInward/UpdateTblAccessoriesPOInward',
    accessoriesPoInwardMasterMasterDELETE: '/api/TblAccessoriesPOInward/DeleteTblAccessoriesPOInward',
    accessoriesPoInwardMasterPendingGET: '/api/TblAccessoriesPOInward/GetTblAccessoriesPODetails',
    accessoriesPoInwardDetailsPreviousGETID: '/api/TblYarnInwardDetail/GetPreviousTblYarnPODetails',

};

const accessoriesPoInwardDetails = {
    accessoriesPoInwardDetailsGET: '/api/TblAccessoriesPOInwardDetail/GetTblAccessoriesPOInwardDetails',
    accessoriesPoInwardDetailsGET_BY_ID: '/api/TblAccessoriesPOInwardDetail/GetTblAccessoriesPOInwardDetailofInward',
    accessoriesPoInwardDetailsPOST: '/api/TblAccessoriesPOInwardDetail/CreateTblAccessoriesPOInwardMultipleDetail',
    accessoriesPoInwardDetailsGETID: '/api/TblAccessoriesPOInwardDetail/GetTblAccessoriesPOInwardDetail',
    accessoriesPoInwardDetailsPATCH: '/api/TblAccessoriesPOInwardDetail/UpdateTblAccessoriesPOInwardDetail',
    accessoriesPoInwardDetailsDELETE: '/api/TblAccessoriesPOInwardDetail/DeleteTblAccessoriesPOInwardDetail',
};

const accessoriesProcessDCInwardMaster = {
    accessoriesProcessDCInwardMasterMasterGET: '/api/TblAccessoriesGeneralDCInward/GetTblAccessoriesGeneralDCInwards',
    accessoriesProcessDCInwardMasterMasterPOST: '/api/TblAccessoriesGeneralDCInward/CreateTblAccessoriesGeneralDCInward',
    accessoriesProcessDCInwardMasterMasterGETID: '/api/TblAccessoriesGeneralDCInward/GetTblAccessoriesGeneralDCInward',
    accessoriesProcessDCInwardMasterMasterPATCH: '/api/TblAccessoriesGeneralDCInward/UpdateTblAccessoriesGeneralDCInward',
    accessoriesProcessDCInwardMasterMasterDELETE: '/api/TblAccessoriesGeneralDCInward/DeleteTblAccessoriesGeneralDCInward',
    accessoriesProcessDCInwardMasterPendingGET: '/api/TblAccessoriesGeneralDCInward/GetTblAccessoriesGeneralDCDetails',
    accessoriesProcessDCInwardDetailsPreviousGETID: '/api/TblYarnInwardDetail/GetPreviousTblYarnPODetails',

};

const accessoriesProcessDCInwardDetails = {
    accessoriesProcessDCInwardDetailsGET: '/api/TblAccessoriesGeneralDCInwardDetail/GetTblAccessoriesGeneralDCInwardDetails',
    accessoriesProcessDCInwardDetailsGET_BY_ID: '/api/TblAccessoriesGeneralDCInwardDetail/GetTblAccessoriesGeneralDCInwardDetailofInward',
    accessoriesProcessDCInwardDetailsPOST: '/api/TblAccessoriesGeneralDCInwardDetail/CreateTblAccessoriesGeneralDCInwardDetail',
    accessoriesProcessDCInwardDetailsGETID: '/api/TblAccessoriesGeneralDCInwardDetail/GetTblAccessoriesGeneralDCInwardDetail',
    accessoriesProcessDCInwardDetailsPATCH: '/api/TblAccessoriesGeneralDCInwardDetail/UpdateTblAccessoriesGeneralDCInwardDetail',
    accessoriesProcessDCInwardDetailsDELETE: '/api/TblAccessoriesGeneralDCInwardDetail/DeleteTblAccessoriesGeneralDCInwardDetail',
};

const cuttingDcInwardMaster = {
    cuttingDcInwardMasterMasterGET: '/api/TblCuttingInward/GetTblCuttingInwards',
    cuttingDcInwardMasterMasterPOST: '/api/TblCuttingInward/CreateTblCuttingInward',
    cuttingDcInwardMasterMasterGETID: '/api/TblCuttingInward/GetTblCuttingInward',
    cuttingDcInwardMasterMasterPATCH: '/api/TblCuttingInward/UpdateTblCuttingInward',
    cuttingDcInwardMasterMasterDELETE: '/api/TblCuttingInward/DeleteTblCuttingInward',
    cuttingDcInwardMasterPendingList: '/api/TblCuttingInward/GetTblCuttingDCDetails'
};

const cuttingDcInwardDetails = {
    cuttingDcInwardDetailsGET: '/api/TblCuttingInwardDetail/GetTblCuttingInwardDetails',
    cuttingDcInwardBundleDetailsGET: '/api/TblCuttingInwardDetail/GetTblCuttingDCInwardBundle',
    cuttingInwardBundleNew: '/api/TblCuttingInwardDetail/GetTblCuttingDCInwardBundleByDCNO',
    cuttingDcInwardDetailsGET_BY_ID: '/api/TblCuttingInwardDetail/GetTblCuttingInwardDetailofInward',
    cuttingDcInwardDetailsPOST: '/api/TblCuttingInwardDetail/CreateTblCutting',
    cuttingDcInwardDetailsGETID: '/api/TblCuttingInwardDetail/GetTblCuttingInwardDetail',
    cuttingDcInwardDetailsPATCH: '/api/TblCuttingInwardDetail/UpdateTblCuttingInwardDetail',
    cuttingInwardDetailsQtyGET: '/api/TblCuttingInward/GetTblCutting',
    cuttingDcInwardDetailsDELETE: '/api/TblCuttingInwardDetail/DeleteTblCuttingInwardDetail',
    cuttingInwardIdGET: '/api/TblCuttingInward/GetTblCuttingSize',
    cuttingPartComponent: '/api/TblStylePrepPartMaster/GetTblPartsComponent',
    getUniqueId: '/api/TblCuttingInward/GetTblCuttingSizeUniqueSearch',
    postBundle: '/api/TblCuttingInwardDetail/CreateCuttingDCInwardBundle',
    bundleInputget: '/api/TblCuttingInward/GetTblCuttingInfo',
    getDcnoProToDetail: 'api/TblYarnInwardDetail/GetPreviousTblYarnPODetails',
    cutPanelGet: '/api/TblStitchingInwardDetail/GetTblStitchingInwardDetailPanelByInward',
    GetTblStyleMaster: '/api/TblStyleMaster/GetTblStyleMaster',
    postReturnQty: '/api/TblCuttingDCDetail/UpdateTblCuttingDCDetailReturn'
};

const stitchingDcMaster = {
    stitchingDcMasterGET: '/api/TblStitchingDC/GetTblStitchingDCs',
    stitchingDcMasterPOST: '/api/TblStitchingDC/CreateTblStitchingDC',
    stitchingDcMasterGETID: '/api/TblStitchingDC/GetTblStitchingDC',
    stitchingDcMasterPATCH: '/api/TblStitchingDC/UpdateTblStitchingDC',
    stitchingDcMasterDELETE: '/api/TblStitchingDC/DeleteTblStitchingDC',
    stitchingSupplierUpdatePost: '/api/TblStitchingDC/UpdateTblStitchingDC_Supplier'
};

const stitchingDcDetails = {
    stitchingDcDetailsGET: '/api/TblStitchingDCDetail/GetTblStitchingDCDetails',
    stitchingDcDetailsGET_BY_ID: '/api/TblStitchingDCDetail/GetTblStitchingDCDetailofDC',
    stitchingDcDetailsPOST: '/api/TblStitchingDCDetail/CreateTblStitchingDCDetail',
    stitchingDcDetailsGETID: '/api/TblStitchingDCDetail/GetTblStitchingDCDetail',
    stitchingDcDetailsPATCH: '/api/TblStitchingDCDetail/UpdateTblStitchingDCDetail',
    stitchingDcDetailsDELETE: '/api/TblStitchingDCDetail/DeleteTblStitchingDCDetail',
    StitchingDcDetailsBundleLists: '/api/TblStitchingDCDetail/GetPreviousProgramBundle',
    stitchingBundlePost: '/api/TblStitchingDCDetail/CreateStitchingDCInwardBundle',
    RestitchingBundlePost: '/api/TblStitchingDCDetail/ReCreateStitchingDCInwardBundle',

};


const moveToCutting = {
    GETProgramData: '/api/TblProgramMapping/GetTblProgramMappings_MoveToCuttings',
    GETDashMoveToCuttingData: '/api/TblCuttingDCDetail/GetDashboard_MoveToCutting'
}

const generalDcMaster = {
    generalDcMasterGET: '/api/TblGeneralDC/GetTblGeneralDCsWithProcessOption',
    generalDcMasterPOST: '/api/TblGeneralDC/CreateTblGeneralDC',
    generalDcMasterGETID: '/api/TblGeneralDC/GetTblGeneralDC',
    generalDcMasterPATCH: '/api/TblGeneralDC/UpdateTblGeneralDC',
    generalDcMasterDELETE: '/api/TblGeneralDC/DeleteTblGeneralDC',
    generalDcMasterInvoiceGET: '/api/TblGeneralDC/TblGeneralDCPrint',
    deleteGeneralDcMasterPoApiCall: '/api/TblGeneralDC/UpdateTblGeneralDCCalloff',
    updateAllCloseIconGeneralDcMaster: '/api/TblGeneralDCDetail/UpdateAllClose',
    sampleDCProgramList: '/api/TblGeneralDC/GetTblProgramListWithProcessOption',
    completedWasteDC: '/api/TblGeneralDC/UpdateMiscellaneousCompleted'
};

const generalDcDetails = {
    generalDcDetailsGET: '/api/TblGeneralDCDetail/GetTblGeneralDCDetails',
    generalDcDetailsGET_BY_ID: '/api/TblPartyDetail/GetTblPartyDetailofParty',
    generalDcDetailsPOST: '/api/TblGeneralDCDetail/CreateTblGeneralDCDetail',
    generalDcDetailsGETID: '/api/TblGeneralDCDetail/GetTblGeneralDCDetail',
    generalDcDetailsPATCH: '/api/TblGeneralDCDetail/UpdateTblGeneralDCDetail',
    generalDcDetailsDELETE: '/api/TblGeneralDCDetail/DeleteTblGeneralDCDetail',
    generalPoInwardDetailsGET_BY_ID_NEW: '/api/TblGeneralDCInwardDetail/GetTblGeneralDCInwardDetailofInward',
    getMiscellaneousItems: 'api/TblGeneralDCDetail/GetTblMiscellaneousItems',

};

const accessoriesDCMaster = {
    accessoriesDCMasterGET: '/api/TblAccessoriesDC/GetTblAccessoriesDCs',
    accessoriesDCMasterPOST: '/api/TblAccessoriesDC/CreateTblAccessoriesDC',
    accessoriesDCMasterGETID: '/api/TblAccessoriesDC/GetTblAccessoriesDC',
    accessoriesDCMasterPATCH: '/api/TblAccessoriesDC/UpdateTblAccessoriesDC',
    accessoriesDCMasterDELETE: '/api/TblAccessoriesDC/DeleteTblAccessoriesDC',
    accessoriesDCInvoiceGET: '/api/TblAccessoriesDC/TblAccessoriesDCPrint',
    GetLoadBuyerUsingFilter: "/api/TblAccessoriesDC/GetLoadBuyerUsingFilter",

    // accessoriesDCDetailsPreviousGetListGET: '/api/TblSaleOrder/GetSalesOrderReqAccessoriesPO'

    //accessoriesPOInvoiceGET: '/api/TblAccessoriesPO/TblAccessoriesPOPrint'
};

const accessoriesDCDetails = {
    // accessoriesDCDetailsGET: '/api/TblAccessoriesPODetail/GetTblAccessoriesPODetails',
    accessoriesDCDetailsGET_BY_ID: '/api/TblAccessoriesDCDetail/GetTblAccessoriesDCDetailofDC',
    accessoriesDCDetailsPOST: '/api/TblAccessoriesDCDetail/CreateTblAccessoriesDCDetail',
    // accessoriesDCDetailsGETID: '/api/TblAccessoriesPODetail/GetTblAccessoriesPODetail',
    // accessoriesDCDetailsPATCH: '/api/TblAccessoriesPODetail/UpdateTblAccessoriesPODetail',
    accessoriesDCDetailsDELETE: '/api/TblAccessoriesDCDetail/DeleteTblAccessoriesDCDetail',
    //accessoriesP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterAccessories',
    accessoriesDCDetailsPreviousGetListGET: '/api/TblAccessoriesDCDetail/GetReqAccessoriesPO',
    // accessoriesDCDetailsAccessoriesMaster: '/api/TblAccessoriesMaster/GetAllTblAccessoriesMaster',
    // accessoriesDCDetailsUpdateListGET: '/api/TblAccessoriesPODetail/UpdateStylePrepAccessoriesMasterRequirement'
};

const accessoriesProcessDCMaster = {
    accessoriesProcessDCMasterGET: '/api/TblAccessoriesGeneralDC/GetTblAccessoriesGeneralDCs',
    accessoriesProcessDCMasterPOST: '/api/TblAccessoriesGeneralDC/CreateTblAccessoriesGeneralDC',
    accessoriesProcessDCMasterGETID: '/api/TblAccessoriesGeneralDC/GetTblAccessoriesGeneralDC',
    accessoriesProcessDCMasterPATCH: '/api/TblAccessoriesGeneralDC/UpdateTblAccessoriesGeneralDC',
    accessoriesProcessDCMasterDELETE: '/api/TblAccessoriesGeneralDC/DeleteTblAccessoriesGeneralDC',
    accessoriesProcessDCInvoiceGET: '/api/TblAccessoriesGeneralDC/TblAccessoriesGeneralDCPrint',
    GetLoadBuyerUsingFilter: "/api/TblAccessoriesDC/GetLoadBuyerUsingFilter",

    // accessoriesDCDetailsPreviousGetListGET: '/api/TblSaleOrder/GetSalesOrderReqAccessoriesPO'

    //accessoriesPOInvoiceGET: '/api/TblAccessoriesPO/TblAccessoriesPOPrint'
};

const accessoriesProcessDCDetails = {
    accessoriesProcessDCDetailsGET: '/api/TblAccessoriesGeneralDCInwardDetail/GetTblAccessoriesGeneralDCInwardDetails',
    accessoriesProcessDCDetailsGET_BY_ID: '/api/TblAccessoriesGeneralDCDetail/GetTblAccessoriesGeneralDCDetailofDC',
    accessoriesProcessDCDetailsPOST: '/api/TblAccessoriesGeneralDCDetail/CreateTblAccessoriesGeneralDCDetail',
    accessoriesProcessDCDetailsGETID: '/api/TblAccessoriesGeneralDCDetail/GetTblAccessoriesGeneralDCDetail',
    accessoriesProcessDCDetailsPATCH: '/api/TblAccessoriesGeneralDCDetail/UpdateTblAccessoriesGeneralDCDetail',
    accessoriesProcessDCDetailsDELETE: '/api/TblAccessoriesGeneralDCDetail/DeleteTblAccessoriesGeneralDCDetail',
    //accessoriesP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterAccessories',
    accessoriesProcessDCDetailsPreviousGetListGET: '/api/TblAccessoriesGeneralDCDetail/GetReqAccessoriesGeneralPO',
    GetTblAccessoriesGeneralDCInwardDetailsMatchingAccessories: '/api/TblAccessoriesGeneralDCInwardDetail/GetTblAccessoriesGeneralDCInwardDetailsMatchingAccessories',
    GetTblAccessoriesGeneralDCDetailsMatchingAccessories: '/api/TblAccessoriesGeneralDCDetail/GetTblAccessoriesGeneralDCDetailsMatchingAccessories',
    // accessoriesDCDetailsAccessoriesMaster: '/api/TblAccessoriesMaster/GetAllTblAccessoriesMaster',
    // accessoriesDCDetailsUpdateListGET: '/api/TblAccessoriesPODetail/UpdateStylePrepAccessoriesMasterRequirement'
};

const accessoriesPOMaster = {
    accessoriesPOMasterGET: '/api/TblAccessoriesPO/GetTblAccessoriesPOs',
    accessoriesPOMasterPOST: '/api/TblAccessoriesPO/CreateTblAccessoriesPO',
    accessoriesPOMasterGETID: '/api/TblAccessoriesPO/GetTblAccessoriesPO',
    accessoriesPOMasterPATCH: '/api/TblAccessoriesPO/UpdateTblAccessoriesPO',
    accessoriesPOMasterDELETE: '/api/TblAccessoriesPO/DeleteTblAccessoriesPO',
    accessoriesPOInvoiceGET: '/api/TblAccessoriesPO/TblAccessoriesPOPrint',

    accessoriesP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetSalesOrderReqAccessoriesPO'

    //accessoriesPOInvoiceGET: '/api/TblAccessoriesPO/TblAccessoriesPOPrint'
};

const accessoriesPODetails = {
    accessoriesPODetailsGET: '/api/TblAccessoriesPODetail/GetTblAccessoriesPODetails',
    accessoriesPODetailsGET_BY_ID: '/api/TblAccessoriesPODetail/GetTblAccessoriesPODetailofPO',
    accessoriesPODetailsPOST: '/api/TblAccessoriesPODetail/CreateTblAccessoriesPODetailsBulk',
    accessoriesPODetailsGETID: '/api/TblAccessoriesPODetail/GetTblAccessoriesPODetail',
    accessoriesPODetailsPATCH: '/api/TblAccessoriesPODetail/UpdateTblAccessoriesPODetail',
    accessoriesPODetailsDELETE: '/api/TblAccessoriesPODetail/DeleteTblAccessoriesPODetail',
    //accessoriesP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetStylePreParationbyStylemasterAccessories',
    accessoriesP0DetailsPreviousGetListGET: '/api/TblSaleOrder/GetSalesOrderReqAccessoriesPO',
    accessoriesP0DetailsAccessoriesMaster: '/api/TblAccessoriesMaster/GetAllTblAccessoriesMaster',
    accessoriesP0DetailsUpdateListGET: '/api/TblAccessoriesPODetail/UpdateStylePrepAccessoriesMasterRequirement'
};

const generalDcInwardMaster = {
    generalDcInwardMasterMasterGET: '/api/TblGeneralDCInward/GetTblGeneralDCInwardsWithProcessOption',
    generalDcInwardMasterMasterGETNEW: '/api/TblGeneralDCInward/GetTblGeneralDCDetailsWithProcessOption',
    generalDcInwardMasterMasterPOST: '/api/TblGeneralDCInward/CreateTblGeneralDCInward',
    generalDcInwardMasterMasterGETID: '/api/TblGeneralDCInward/GetTblGeneralDCInward',
    generalDcInwardMasterMasterPATCH: '/api/TblGeneralDCInward/UpdateTblGeneralDCInward',
    generalDcInwardMasterMasterDELETE: '/api/TblGeneralDCInward/DeleteTblGeneralDCInward',
    generalDcInwardMasterPendingGet: '/api/TblGeneralDCInward/GetTblGeneralDCDetails',
    //***** AdminDCInward api ***//
    adminDCInwardMasterPendingGet: 'api/TblGeneralDCInward/GetTblGeneralDCDetailsByMenuName',
    adminDCInwardMasterInwardGet: 'api/TblGeneralDCInward/GetTblGeneralDCInwardByMenuName'
};

const generalDcInwardDetails = {
    generalDcInwardDetailsGET: '/api/TblGeneralDCInwardDetail/GetTblGeneralDCInwardDetails',
    generalDcInwardDetailsGET_BY_ID: '/api/TblPartyDetail/GetTblPartyDetailofParty',
    generalDcInwardDetailsPOST: '/api/TblGeneralDCInwardDetail/CreateTblGeneralDCInwardDetail',
    generalDcInwardDetailsGETID: '/api/TblGeneralDCInwardDetail/GetTblGeneralDCInwardDetail',
    generalDcInwardDetailsPATCH: '/api/TblGeneralDCInwardDetail/UpdateTblGeneralDCInwardDetail',
    generalDcInwardDetailsDELETE: '/api/TblGeneralDCInwardDetail/DeleteTblGeneralDCInwardDetail'
};

const checkingDcInwardMaster = {
    checkingDcInwardMasterMasterGET: '/api/TblCheckingInward/GetTblCheckingInwards',
    checkingDcInwardMasterMasterPOST: '/api/TblCheckingInward/CreateTblCheckingInward',
    checkingDcInwardMasterMasterGETID: '/api/TblCheckingInward/GetTblCheckingInward',
    checkingDcInwardMasterMasterPATCH: '/api/TblCheckingInward/UpdateTblCheckingInward',
    checkingDcInwardMasterMasterDELETE: '/api/TblCheckingInward/DeleteTblCheckingInward'
};

const checkingDcInwardDetails = {
    checkingDcInwardDetailsGET: '/api/TblCheckingInwardDetail/GetTblCheckingInwardDetails',
    checkingDcInwardDetailsGET_BY_ID: '/api/TblCheckingInwardDetail/GetTblCheckingInwardDetailofInward',
    checkingDcInwardDetailsPOST: '/api/TblCheckingInwardDetail/CreateTblCheckingInwardDetail',
    checkingDcInwardDetailsGETID: '/api/TblCheckingInwardDetail/GetTblCheckingInwardDetail',
    checkingDcInwardDetailsPATCH: '/api/TblCheckingInwardDetail/UpdateTblCheckingInwardDetail',
    checkingDcInwardDetailsDELETE: '/api/TblCheckingInwardDetail/DeleteTblCheckingInwardDetail'
};

const compactingInwardMaster = {
    // old one
    // compactingInwardMasterGET: '/api/TblCompactingInward/GetTblCompactingInwards',

    compactingInwardMasterGET: '/api/TblCompactingInward/GetTblCompactingInwardsWithProcessOption',

    compactingInwardMasterPOST: '/api/TblCompactingInward/CreateTblCompactingInward',
    compactingInwardMasterGETID: '/api/TblCompactingInward/GetTblCompactingInward',
    compactingInwardMasterPATCH: '/api/TblCompactingInward/UpdateTblCompactingInward',
    compactingInwardMasterDELETE: '/api/TblCompactingInward/DeleteTblCompactingInward',
    compactingDCInwardDKPendingMasterGET: '/api/TblYarnInwardBulk/GetTblYarnPODetail'
};

const compactingInwardDetails = {
    compactingInwardDetailsGET: '/api/TblCompactingInwardDetail/GetTblCompactingInwardDetails',
    compactingInwardDetailsGET_BY_ID: '/api/TblCompactingInwardDetail/GetTblCompactingInwardDetailofInward',
    compactingInwardDetailsPOST: '/api/TblCompactingInwardDetail/CreateTblCompactingInwardDetail',
    compactingInwardDetailsGETID: '/api/TblCompactingInwardDetail/GetTblCompactingInwardDetail',
    compactingInwardDetailsPATCH: '/api/TblCompactingInwardDetail/UpdateTblCompactingInwardDetail',
    compactingInwardDetailsDELETE: '/api/TblCompactingInwardDetail/DeleteTblCompactingInwardDetail',

    // Old One
    // compactingDCInwardPendingMasterGET: '/api/TblCompactingInward/GetTblCompactingDCDetails'

    compactingDCInwardPendingMasterGET: '/api/TblCompactingInward/GetTblCompactingDCDetailsWithProcessOption'
};

const stitchingInwardDetails = {
    stitchingInwardDetailsGET: '/api/TblStitchingInwardDetail/GetTblStitchingInwardDetails',
    stitchingInwardDetailsQtyGET: '/api/TblStitchingInwardDetail/GetTblStitching',
    stitchingInwardDetailsGET_BY_ID: '/api/TblStitchingInwardDetail/GetTblStitchingInwardDetailofInward',
    stitchingInwardDetailsPOST: '/api/TblStitchingInwardDetail/CreateStitchingInwardDetail',
    stitchingInwardDetailsGETID: '/api/TblStitchingInwardDetail/GetTblStitchingInwardDetail',
    stitchingInwardDetailsPATCH: '/api/TblStitchingInwardDetail/UpdateTblStitchingInwardDetail',
};

const ironingAndPackingInwardDetails = {
    ironingAndPackingInwardDetailsGET: '/api/TblIroningAndPackingInwardDetail/GetTblIroningAndPackingInwardDetails',
    ironingAndPackingInwardDetailsQtyGET: '/api/TblIroningAndPackingInward/GetTblIronAndPack',
    ironingAndPackingInwardDetailsGET_BY_ID: '/api/TblIroningAndPackingInwardDetail/GetTblIroningAndPackingInwardDetailofInward',
    ironingAndPackingInwardDetailsPOST: '/api/TblIroningAndPackingInwardDetail/CreateTblIronAndPack',
    ironingAndPackingInwardDetailsGETID: '/api/TblStitchingInwardDetail/GetTblStitchingInwardDetail',
    ironingAndPackingInwardDetailsPATCH: '/api/TblStitchingInwardDetail/UpdateTblStitchingInwardDetail',
    ironingAndPackingInwardDetailsDELETE: '/api/TblStitchingInwardDetail/DeleteTblStitchingInwardDetail'
};

const billPaymentMaster = {
    billPaymentMasterGET: '/api/TblBillPayment/GetTblBillPayments',
    billPaymentSupplierWiseMasterGET: 'api/TblBillPayment/GetTblBillPaymentBySupplierID',
    billPaymentMasterPOST: '/api/TblBillPayment/CreateTblBillPayment',
    billPaymentMasterGETID: '/api/TblBillPayment/GetTblBillPayment',
    billPaymentMasterPATCH: '/api/TblBillPayment/UpdateTblBillPayment',
    billPaymentPendingMasterGET: '/api/TblBillPayment/GetPendingTblPIMs',
    generateMultipleBillPaymentMasterPOST: 'api/TblBillPayment/CreateBulkTblBillPayment',
    billPaymentMasterDELETE: '/api/TblBillPayment/DeleteTblBillPayment'
};

const billPaymentDetails = {
    billPaymentDetailsGET: '/api/TblBillPaymentDetail/GetTblBillPaymentDetails',
    billPaymentDetailsGET_BY_ID: '/api/TblBillPaymentDetail/GetTblBillPaymentDetailsByBillPaymentID',
    billPaymentDetailsPOST: '/api/TblBillPaymentDetail/CreateTblBillPaymentDetail',
    billPaymentDetailsGETID: '/api/TblBillPaymentDetail/GetTblBillPaymentDetail',
    billPaymentDetailsPATCH: '/api/TblBillPaymentDetail/UpdateTblBillPaymentDetail',
    billPaymentDetailsDELETE: '/api/TblBillPaymentDetail/DeleteTblBillPaymentDetail'
};

const yarnMaster = {
    yarnMasterGET: '/api/TblYarnMaster/GetAllYarnMaster',
    yarnGroupDistinctGET: '/api/TblYarnMaster/GetDistinctAllYarnMasterYarnGroup',
    yarnTypeDistinctGET: '/api/TblYarnMaster/GetDistinctAllYarnMasterYarnType',
    yarnMasterPOST: '/api/TblYarnMaster/CreateYarnMaster',
    yarnMasterGETID: '/api/TblYarnMaster/GetYarnMaster',
    yarnMasterPATCH: '/api/TblYarnMaster/UpdateYarnMaster',
    yarnMasterDELETE: '/api/TblYarnMaster/DeleteYarnMaster',
    yarnMasterYarnMaterialsGET: '/api/TblYarnMaster/GetYarnMaterial'
};

const fabricMaster = {
    fabricMasterGET: '/api/TblFabricMaster/GetAllFabricMaster',
    fabricMasterYarnMaterialGET: '/api/TblYarnMaster/GetYarnMaterial',
    fabricMasterWithYarnGroupGET: '/api/TblFabricMaster/GetDistinctAllFabricMasterFabricType',
    fabricMasterPOST: '/api/TblFabricMaster/CreateFabricMaster',
    // fabricMasterPOST: '/api/TblFabricMaster/CreateSingleorMultiYarnFabricMaster',

    fabricMasterGETID: '/api/TblFabricMaster/GetFabricMaster',
    fabricMasterPATCH: '/api/TblFabricMaster/UpdateFabricMaster',
    fabricMasterDELETE: '/api/TblFabricMaster/DeleteFabricMaster'
};

const processAssignStyleMaster = {
    processAssignStyleMasterGET: '/api/TblProcessAssignStyleMaster/GetAllProcessAssignStyleMaster',
    processAssignStyleMasterPOST: '/api/TblProcessAssignStyleMaster/CreateProcessAssignStyleMaster',
    processAssignStyleMasterGETID: '/api/TblProcessAssignStyleMaster/GetProcessAssignStyleMaster',
    processAssignStyleMasterPATCH: '/api/TblProcessAssignStyleMaster/UpdateProcessAssignStyleMaster',
    processAssignStyleMasterDELETE: '/api/TblProcessAssignStyleMaster/DeleteProcessAssignStyleMaster',
    processAssignStyleMasterPATCHNEW: '/api/TblProcessAssignStyleMaster/UpdateProcessAssignStyleMasterProcess',
    processAssignStylePreparationProcessCostKG: '/api/TblStylePrepProcessCostKG/GenerateStylePreparationProcessCostKGNewProcess',
};

const processAssignStyleMasterBasicDK = {
    processAssignStyleMasterBasicDKGET: '/api/TblProcessAssignForBasicStyle/GetAllProcessAssignForBasicStyle',
    processAssignStyleMasterBasicDKPOST: '/api/TblProcessAssignForBasicStyle/CreateProcessAssignForBasicStyle',
    processAssignStyleMasterBasicDKGETID: '/api/TblProcessAssignForBasicStyle/GetProcessAssignForBasicStyle',
    processAssignStyleMasterBasicDKPATCH: '/api/TblProcessAssignStyleMaster/UpdateProcessAssignStyleMaster',
    processAssignStyleMasterBasicDKDELETE: '/api/TblProcessAssignForBasicStyle/DeleteProcessAssignForBasicStyle'
};

const compactingInwardMasterDK = {
    compactingInwardMasterDKGET: '/api/TblCompactingInwardBulk/GetTblCompactingInwardBulks',
    compactingInwardMasterDKPOST: '/api/TblCompactingInwardBulk/CreateTblCompactingInwardBulk',
    compactingInwardMasterDKGETID: '/api/TblCompactingInwardBulk/GetTblCompactingInwardBulk',
    compactingInwardMasterDKPATCH: '/api/TblCompactingInwardBulk/UpdateTblCompactingInwardBulk',
    compactingInwardMasterDKDELETE: '/api/TblCompactingInwardBulk/DeleteTblCompactingInwardBulk',
    compactingDCInwardDKPendingMasterGET: '/api/TblCompactingInwardBulk/GetTblCompactingDCDetailBulks',
    reportDKSingleCompaProgramWiseGET: '/api/TblReports/GetInwardReports_POWise',
    compactingDCInwardDKCompleteMasterGET: '/api/TblCompactingInwardBulk/GetTblCompactingDCDetailBulkCompleted'
};

const compactingInwardDetailsDK = {
    compactingInwardDetailsDKGET: '/api/TblCompactingInwardDetailBulk/GetTblCompactingInwardDetailBulks',
    compactingInwardDetailsDKGET_BY_ID: '/api/TblCompactingInwardDetailBulk/GetTblCompactingInwardDetailBulkofInward',
    compactingInwardDetailsDKPOST: '/api/TblCompactingInwardDetailBulk/CreateTblCompactingInwardDetailBulk',
    compactingInwardDetailsDKGETID: '/api/TblCompactingInwardDetailBulk/GetTblCompactingInwardDetailBulk',
    compactingInwardDetailsDKPATCH: '/api/TblCompactingInwardDetailBulk/UpdateTblCompactingInwardDetailBulk',
    compactingInwardDetailsDKDELETE: '/api/TblCompactingInwardDetailBulk/DeleteTblCompactingInwardDetailBulk'
};

const despatchDCMasterDK = {
    despatchDcDKMasterGET: '/api/TblDespatchDC/GetTblDespatchDCs',
    // fabricPoDKInvoiceGET: '/api/TblFabricPOBulk/TblFabricPOBulkPrint',
    despatchDcDKMasterPOST: '/api/TblDespatchDC/CreateTblDespatchDC',
    despatchDcDKMasterGETID: '/api/TblDespatchDC/GetTblDespatchDC',
    despatchDcDKMasterPATCH: '/api/TblDespatchDC/UpdateTblDespatchDC',
    despatchDcDKMasterDELETE: '/api/TblDespatchDC/DeleteTblDespatchDC'
};

const ApprovalMail = {
    sendApprovalOTPPOST: '/api/TblMail/SendApprovalOTP'
};

const fabricAndAccessoriesDemandPost = {
    sendfarbricSavePost: '/api/TblSaleOrder/CreateStylePreParationbyStylemasterFabric',
    fabricAdditionalReqPost: '/api/TblSaleOrder/CreateStylePreParationbyStylemasterAddtionalRequirement',
    fabricReplacePost: '/api/TblSaleOrder/CreateStylePreParationbyStylemasterReplace',
    newFabricCheckPost: '/api/TblFabricMaster/CheckGetFabricMasterId',
    newFabricReplacePost: '/api/TblSaleOrder/CreateStylePreParationbyStylemasternewFabric',
    //
    accessoriesAddReqPost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasterAddtionalRequirement',
    accessoriesReplacePost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasterReplace',
    newAccessoriesPost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasteNewAcessories',
};

// const accessoriesDemandPost = {
//     accessoriesAddReqPost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasterAddtionalRequirement',
//     accessoriesReplacePost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasterReplace',
//     newAccessoriesPost: '/api/TblSaleOrder/CreateStylePreParationbyAccessoriesMasteNewAcessories',
// }

const getfabricReplaceCall = {
    getFabricGetCall: '/api/TblStylePrepFabric/GetDemandUniqueId'
};
const getDiaCall = {
    getDia: '/api/TblCompanyMaster/GetPropertyList'
};

const postOverAllfabric = {
    postCommonFabric: 'api/TblStylePrepFabric/CreateStylePreParationOverallReplace'
};

const viewPostCallFarbric = {
    getPostViewFabric: '/api/TblSaleOrder/UpdateRequirementtoRequirementDetail'
};

const stitchingInwardDetailsDELETEAPI = {
    stitchingInwardDetailsDELETE: '/api/TblStitchingInwardDetail/DeleteTblStitchingInwardDetails',
    stitchingCutPanel: 'api/TblStitchingInwardDetail/CreateStitchingInwardPanelDetail'
}

const closeBtnIconCall = {
    postCloseIcon: '/api/TblYarnPODetail/UpdateClose'
};

const closeBtnCloseCallFabric = {
    postCloseIconFab: '/api/TblFabricPODetail/UpdateClose'
};

const updateAllBtnCall = {
    updateAllCloseIcon: '/api/TblYarnPODetail/UpdateAllClose'
};

const updateAllBtnCallFabric = {
    updateAllCloseIconFabric: '/api/TblFabricPODetail/UpdateAllClose'
};

const updateApiWhileDeleting = {
    updateDeleteApiCall: '/api/TblYarnPO/UpdateTblYarnPOCalloff'
};

const updateYarnPO = {
    updateYarnPoAiCall: '/api/TblYarnPODetail/GetStylePreParationbyStylemasterYarnUpdate'
};

const deleteWithReasonYarnPo = {
    deleteYarnPoApiCall: '/api/TblYarnPO/UpdateTblYarnPOCalloff'
};

const deleteWithReasonYarnPoDK = {
    deleteYarnPodkApiCall: '/api/TblYarnPOBulk/UpdateTblYarnPOCalloff'
};

const deleteWithReasonfabricPoDK = {
    deletefabricPoDKApiCall: '/api/TblFabricPOBulk/UpdateTblFabricPOCalloff'
};

const deleteWithReasonknittingdcDK = {
    deleteknittingdcDKApiCall: '/api/TblKnittingDCBulk/UpdateTblKnittingDCCalloff'
};

const deleteWithReasondyeingdcDK = {
    deletedyeingdcDKApiCall: '/api/TblDyeingDCBulk/UpdateTblDyeingDCCalloff'
};

const deleteWithReasoncomactingdcDK = {
    deletecomactingdcDKApiCall: '/api/TblCompactingDCBulk/UpdateTblCompactingDCCalloff'
};

const deleteWithReasonfabricPo = {
    deletefabricPoApiCall: 'api/TblFabricPO/UpdateTblFabricPOCalloff'
};

const deleteWithReasonKnittingPo = {
    deleteKnittingPoApiCall: 'api/TblKnittingDC/UpdateTblKnittingDCCalloff'
};

const deleteWithReasonCompactingPo = {
    deleteCompactingPoApiCall: 'api/TblCompactingDC/UpdateTblCompactingDCCalloff'
};

const deleteWithReasonDyeingPo = {
    deleteDyeingPoApiCall: 'api/TblDyeingDC/UpdateTblDyeingDCCalloff'
};

const deleteWithReasonAllOverPrintPo = {
    deleteAllOverPrintApiCall: 'api/TblPrintingDC/UpdateTblPrintingDCCalloff'
};

const deleteWithStitchingDC = {
    deleteStitchingApiCall: 'api/TblStitchingDCDetail/UpdateTblStitchingDCCalloffAll'

}

const deleteWithStitchingDCDelete = {
    deleteStitchingApiCallDelete: 'api/TblStitchingDC/DeleteTblStitchingDC'

}

const deleteWithCuttingDC = {
    deleteCuttingApiCall: 'api/TblCuttingDCDetail/UpdateTblCuttingDCCalloffAll'

}

const deleteWithIroningPacking = {
    deleteIroningApiCall: 'api/TblIroningAndPackingDCDetail/UpdateTblIroningAndPackingDCCalloffAll'

}

const deleteWithIroningPackingDelete = {
    deleteIroningApiCallDelete: 'api/TblIroningAndPackingDC/DeleteTblIroningAndPackingDC'

}

const deleteWithReasonAccessoriesDC = {
    deleteAccessoriesDCApiCall: '/api/TblAccessoriesDC/UpdateTblAccessoriesDCCalloff'
};

const deleteWithReasonAccessoriesPo = {
    deleteAccessoriesPoApiCall: '/api/TblAccessoriesPO/UpdateTblAccessoriesPOCalloff'
};

const postAmountApi = {
    postAmountApiCall: 'api/TblPIMDetail/CreateTblPIMDetail'
};

const fabupdateAllBulkBtnCall = {
    updateAllFabBulkCloseIcon: '/api/TblFabricPODetailBulk/UpdateAllClose'
};

const fabcloseBtnBulkIconCall = {
    postFabBulkCloseIcon: '/api/TblFabricPODetailBulk/UpdateClose'
};

const otpCloseYarnApi = {
    postOtpCallPostYarn: 'api/TblMail/SendCloseApprovalOTP?DetailFldId'
};

const otpCloseAllyarnApi = {
    postOtpCloseCallPostYarn: 'api/TblMail/SendCloseAllApprovalOTP'
};

const stockWiseApiCall = {
    getStockWiseReports: 'api/TblReports/GetProgramWiseStock'
};

const stockWiseLedgerApiCall = {
    getStockWiseLedgerReports: 'api/TblReports/GetStockLedger'
};

const stockWiseLedgerDetailApiCall = {
    getStockWiseLedgerDetailsReports: 'api/TblReports/GetStockLedgerDetail',
    getStockWiseLedgerDetailsDate: 'api/TblReports/GetStockLedgerDetail'
};

const stockWiseLedgerOpeningStockApiCall = {
    getStockWiseLedgerOpeningStockReports: 'api/TblReports/GetStockLedgerOpeningStock'
};

const updateAllBulkBtnCall = {
    updateAllYarnBulkCloseIcon: '/api/TblYarnPODetailBulk/UpdateAllClose'
};

const closeBtnBulkIconCall = {
    postYarnBulkCloseIcon: '/api/TblYarnPODetailBulk/UpdateClose'
};

const Cancelledreport = {
    getCancelledreport: 'api/TblReports/GetTblCancelled_Program'
};
const knitupdateAllBulkBtnCall = {
    updateAllKnittBulkCloseIcon: '/api/TblKnittingDCDetailBulk/UpdateAllClose'
};
const Completedreport = {
    getCompletedreport: 'api/TblReports/GetTblCompleted_Program'
};

const knitcloseBtnBulkIconCall = {
    postKnittBulkCloseIcon: '/api/TblKnittingDCDetailBulk/UpdateClose'
};
const dyeupdateAllBulkBtnCall = {
    updateAllDyeBulkCloseIcon: '/api/TblDyeingDCDetailBulk/UpdateAllClose'
};

const dyecloseBtnBulkIconCall = {
    postDyeBulkCloseIcon: '/api/TblDyeingDCDetailBulk/UpdateClose'
};
const compupdateAllBulkBtnCall = {
    updateAllComBulkCloseIcon: '/api/TblCompactingDCDetailBulk/UpdateAllClose'
};

const compcloseBtnBulkIconCall = {
    postComBulkCloseIcon: '/api/TblCompactingDCDetailBulk/UpdateClose'
};

const aopupdateAllBulkBtnCall = {
    updateAllAOPBulkCloseIcon: '/api/TblPrintingDCDetailBulk/UpdateAllClose'
};

const aopcloseBtnBulkIconCall = {
    postAOPBulkCloseIcon: '/api/TblPrintingDCDetailBulk/UpdateClose'
};

const cutupdateAllBulkBtnCall = {
    updateAllCuttBulkCloseIcon: '/api/TblCuttingDCDetailBulk/UpdateAllClose'
};

const cutcloseBtnBulkIconCall = {
    postCuttBulkCloseIcon: '/api/TblCuttingDCDetailBulk/UpdateClose'
};
const asanaErrorPoints = {
    asanaErrorPointsGET: '/api/TblAsanaError/GetAllTblAsanaError'
};

const deleteDCDetailsCallOff = {
    deleteDCDetailsCallOffStitching: '/api/TblStitchingDCDetail/UpdateTblStitchingDCCalloffAll'
}

const deleteDCDetailsIroningCallOff = {
    deleteDCDetailsIroningPackingCallOff: '/api/TblIroningAndPackingDCDetail/UpdateTblIroningAndPackingDCCalloffAll'
}

const vendorManagementApi = {
    CreateTblVendorManagementApi: "/api/TblVendorManagement/CreateTblVendorManagement"
}

const rnPendingReport = {
    reportRNPendingGET: '/api/TblCompactingRN/GetRNPendingReport',
    reportRNStyleGET: '/api/TblCompactingRNDetail/GetRNStyleNumber',
    reportCompCuttingGET: '/api/TblReports/GetReports_CompactingToCutting',
    rnStockReportGET: '/api/TblCompactingRN/GetRNInStockReport'
};

const packingEntry = {
    packingEntryHeaderGET: '/api/TblPacking/GetTblPackings',
    packingEntryHeaderEditGET: '/api/TblPacking/GetTblPacking',
    packingEntryTableDataGET: '/api/TblProductStock/GetTblProductStocks',
    packingEntryHeaderPOST: '/api/TblPacking/CreateTblPacking',
    packingEntryDetailPOST: 'api/TblPackingDetail/CreateTblPackingDetailRangeInsert',
    packingEntryDetailGET: '/api/TblPackingDetail/GetTblPackingDetails',
    packingEntryHeaderDELETE: '/api/TblPacking/DeleteTblPacking',
    packingEntryDetailDELETE: '/api/TblPackingDetail/DeleteTblPackingDetail',
    WareHouseApprovalAcceptPATCH: '/api/TblPacking/UpdateTblPackingAcknowledgeorReject',
}

const productStock = {
    productStockGET: '/api/TblProductStock/GetAllTblProductStocks',
    productStockPivotView: '/api/TblProductStock/GetProductStockPivotView'
};

const productDispatch = {
    productDispatchGET: '/api/TblProductDespatch/GetTblProductDespatchs',
    productDispatchPOST: '/api/TblProductDespatch/CreateTblProductDespatch',
    productDispatchDELETE: '/api/TblProductDespatch/DeleteTblProductDespatch',
    productDispatchSalesOrderGET: '/api/TblPackingDetail/GetPackingDetailByWHStyleNo',
    productDispatchDetailPOST: '/api/TblProductDespatchDetail/CreateTblProductDespatchRangeInsert',
    productDispatchDetailListGET: '/api/TblProductDespatchDetail/GetTblProductDespatchDetailByDesPatch',
    productDispatchDetailDELETE: '/api/TblProductDespatchDetail/DeleteTblProductDespatchDetail',
    productDispatchPendingListGET: '/api/TblCustomerPO/GetTblCustomerPOsPending',
    productDispatchDetailTableGET: '/api/TblPackingDetail/GetPackingDetailByCPONo',
    WareHouseSalesOrderList: '/api/TblWHStyleMaster/GetPendingTblWHStyleMaster'
};

export default Object.freeze({
    ...billEntryStyle,
    ...Cancelledreport,
    ...Completedreport,
    ...CompanyPropertyListById,
    ...StateMasterList,
    ...BankMasterList,
    ...AccountMaster,
    ...areaMaster,
    ...companyMaster,
    ...unitMaster,
    ...partyMaster,
    ...partyDetails,
    ...vendorMaster,
    ...propertyMaster,
    ...property,
    ...employee,
    ...priceMapping,
    ...stock,
    ...accessoriesMaster,
    ...accessoriesUsage,
    ...sizeInfo,
    ...sizeRatio,
    ...product,
    ...productDetails,
    ...sizeMeasurementMaster,
    ...sizeMeasurementDetails,
    ...userHeader,
    ...userDetails,
    ...feedbackMaster,
    ...feedbackDetails,
    ...colorMaster,
    ...colorDetails,
    ...userAccessInfo,
    ...userAccessInfoDetails,
    ...teamMaster,
    ...teamDetails,
    ...brandMaster,
    ...hsnMaster,
    ...bankMaster,
    ...roles,
    ...feedbackAnyWhere,
    ...process,
    ...processAddOn,
    ...processFlow,
    ...processSupplier,
    ...programConstraint,
    ...programMapping,
    ...styleMaster,
    ...styleMasterMain,
    ...styleDetails,
    ...seasonMaster,
    ...yearMaster,
    ...defaultStyleMaster,
    ...salesOrder,
    ...salesOrderDetails,
    ...stylePreparationsAllInformation,
    ...fabricInformation,
    ...accessoriesRequirement,
    ...processCostPerKg,
    ...processCostPerPcsDetails,
    ...partDetails,
    ...yarnInformation,
    ...stylePreparation,
    ...partMaster,
    ...pcsWeight,
    ...stylePreDia,
    ...fabricPoMaster,
    ...fabricPoDetails,
    ...yarnPO,
    ...yarnPODetails,
    ...dyeingInwardMaster,
    ...dyeingInwardDetails,
    ...comboColor,
    ...cuttingDCMaster,
    ...cuttingDcDetails,
    ...generalPoMaster,
    ...generalPoDetails,
    ...printingDcInwardMaster,
    ...printingDcInwardDetails,
    ...printingPartDcInwardDetails,
    ...printingPartDcInwardMaster,
    ...checkingDcMaster,
    ...checkingDcDetails,
    ...ironingPackingDcInwardMaster,
    ...ironingPackingDcInwardDetails,
    ...despatchDCMaster,
    ...despatchDCDetails,
    ...generalPoInwardMaster,
    ...generalPoInwardDetails,
    ...accessoriesPoInwardMaster,
    ...accessoriesPoInwardDetails,
    ...accessoriesProcessDCInwardMaster,
    ...accessoriesProcessDCInwardDetails,
    ...cuttingDcInwardMaster,
    ...cuttingDcInwardDetails,
    ...stitchingDcMaster,
    ...stitchingDcDetails,
    ...generalDcMaster,
    ...generalDcDetails,
    ...generalDcInwardMaster,
    ...generalDcInwardDetails,
    ...checkingDcInwardMaster,
    ...checkingDcInwardDetails,
    ...yarnPoInwardMaster,
    ...yarnPoInwardDetails,
    ...fabricPoInwardMaster,
    ...fabricPoInwardDetails,
    ...knittingInwardMaster,
    ...knittingInwardDetails,
    ...compactingInwardMaster,
    ...compactingInwardDetails,
    ...stitchingInwardMaster,
    ...stitchingInwardDetails,
    ...section,
    ...knittingDCMaster,
    ...knittingDCDetails,
    ...dyeingDCMaster,
    ...dyeingDCDetails,
    ...compactingDCMaster,
    ...compactingDCDetails,
    ...compactingDivisionMaster,
    ...compactingDivisionDetails,
    ...compactingInwardDivision,
    ...compactingInwardDivisionDetails,
    ...printingDCMaster,
    ...printingDCDetails,
    ...printingPartDCMaster,
    ...printingPartDCDetails,
    ...ironingAndPackingDCMaster,
    ...ironingAndPackingDCDetails,
    ...accessoriesDCMaster,
    ...accessoriesDCDetails,
    ...accessoriesProcessDCMaster,
    ...accessoriesProcessDCDetails,
    ...accessoriesPOMaster,
    ...accessoriesPODetails,
    ...billPaymentMaster,
    ...billPaymentDetails,
    ...yarnMaster,
    ...fabricMaster,
    ...processAssignStyleMaster,
    ...styleMasterBasic,
    ...skuMasterHeader,
    ...skuMasterDetails,
    ...yarnPODK,
    ...yarnPODKDetails,
    ...yarnPoInwardDKMaster,
    ...yarnPoInwardDKDetails,
    ...knittingInwardDKMaster,
    ...knittingInwardDKDetails,
    ...processAssignStyleMasterBasicDK,
    ...fabricPoMasterDK,
    ...fabricPoInwardMasterDK,
    ...knittingDCMasterDK,
    ...knittingDCDetailsDK,
    ...fabricPoInwardDetailsDK,
    ...fabricPoDetailsDK,
    ...dyeingInwardMasterDK,
    ...dyeingDCDKMaster,
    ...generalPoMasterDK,
    ...generalPoDetailsDK,
    ...generalPoInwardMasterDK,
    ...generalPoInwardDetailsDK,
    ...generalDCMasterDK,
    ...generalDCDetailsDK,
    ...generalDCInwardDKMaster,
    ...generalDCInwardDKDetails,
    ...printingDcInwardDKMaster,
    ...printingDcInwardDKDetails,
    ...accessoriesPoMasterDK,
    ...accessoriesPoDetailsDK,
    ...accessoriesPoInwardMasterDK,
    ...accessoriesPoInwardDetailsDK,
    ...printingDCDKMaster,
    ...dyeingDCDKDetails,
    ...printingDCDKDetails,
    ...dyeingInwardDKDetails,
    ...compactingInwardMasterDK,
    ...compactingInwardDetailsDK,
    ...washingDCDKMaster,
    ...washingDCDKDetails,
    ...washingInwardDKDetails,
    ...washingInwardMasterDK,
    ...cuttingDCDKMaster,
    ...cuttingDCDKDetails,
    ...pimMaster,
    ...compactingDCDKMaster,
    ...compactingDCDKDetails,
    ...accessoriesDCMasterDK,
    ...accessoriesDCDetailsDK,
    ...ironingPackingInwardDKDetails,
    ...ironingPackingInwardMasterDK,
    ...stitchingDCDKMaster,
    ...stitchingDCDKDetails,
    ...pimDetails,
    ...inwardDetailSOandSN,
    ...despatchDCMasterDK,
    ...dashboardDK,
    ...reportDK,
    ...cuttingInwardMasterDK,
    ...cuttingInwardDKDetails,
    ...printingDC2DKDetails,
    ...printingDC2DKMaster,
    ...printing2InwardDKDetails,
    ...printing2InwardMasterDK,
    ...stitchingInwardDKDetails,
    ...stitchingInwardMasterDK,
    ...ironingPackingDCDKDetails,
    ...ironingPackingDCDKMaster,
    ...filter,
    ...barcodeMaster,
    ...stitchingDCMaster,
    ...stitchingDCDetails,
    ...ApprovalMail,
    ...ironingAndPackingInwardDetails,
    ...ironingAndPackingInwardMaster,
    // ...fabricDemandPost,
    ...getfabricReplaceCall,
    ...getDiaCall,
    ...viewPostCallFarbric,
    ...closeBtnIconCall,
    ...updateAllBtnCall,
    ...updateApiWhileDeleting,
    ...updateYarnPO,
    ...deleteWithReasonYarnPo,
    ...deleteWithReasonYarnPoDK,
    ...deleteWithReasonfabricPoDK,
    ...deleteWithReasonknittingdcDK,
    ...deleteWithReasondyeingdcDK,
    ...deleteWithReasoncomactingdcDK,
    ...postAmountApi,
    ...postOverAllfabric,
    ...updateFabricPO,
    ...updateAllBtnCallFabric,
    ...closeBtnCloseCallFabric,
    ...deleteWithReasonfabricPo,
    ...otpCloseYarnApi,
    ...otpCloseAllyarnApi,
    ...fabricPo,
    ...stockWiseApiCall,
    ...stockWiseLedgerApiCall,
    ...stockWiseLedgerDetailApiCall,
    ...stockWiseLedgerOpeningStockApiCall,
    ...updateAllBulkBtnCall,
    ...closeBtnBulkIconCall,
    ...fabupdateAllBulkBtnCall,
    ...fabcloseBtnBulkIconCall,
    ...updateAllBtnCallKnitting,
    ...closeBtnCloseCallKnitting,
    ...updateAllBtnCallDyeing,
    ...closeBtnCloseCallDyeing,
    ...updateAllBtnCallCompacting,
    ...closeBtnCloseCallCompacting,
    ...updateAllBtnCallAllOverPrint,
    ...closeBtnCloseCallAllOverPrinting,
    ...knitcloseBtnBulkIconCall,
    ...knitupdateAllBulkBtnCall,
    ...dyeupdateAllBulkBtnCall,
    ...dyecloseBtnBulkIconCall,
    ...DetailReport,
    ...Completedreport,
    ...Cancelledreport,
    ...compcloseBtnBulkIconCall,
    ...compupdateAllBulkBtnCall,
    ...aopcloseBtnBulkIconCall,
    ...aopupdateAllBulkBtnCall,
    ...stichingDCMaster,
    ...cutcloseBtnBulkIconCall,
    ...cutupdateAllBulkBtnCall,
    ...ironpackcloseBtnBulkIconCall,
    ...ironpackupdateAllBulkBtnCall,
    ...billEntriesDK,
    ...editbillEntries,
    ...verifyBillEntriesDK,
    //...editverification,
    ...billentryReportall,
    ...contractorBillEntry,
    ...asanaErrorPoints,
    ...closeBtnCloseCallCutting,
    ...updateAllBtnCallCutting,
    ...deleteWithReasonAccessoriesDC,
    ...deleteWithReasonAccessoriesPo,
    ...deleteWithReasonKnittingPo,
    ...deleteWithReasonCompactingPo,
    ...deleteWithReasonDyeingPo,
    ...deleteWithReasonAllOverPrintPo,
    ...updateAllBtnCallStitching,
    ...updateAllBtnCallAccessories,
    ...closeBtnCloseCallAccessories,
    ...ironingDCMaster,
    ...updateAllBtnCallIroning,
    ...updateAllBtnCallPrintingDC,
    ...closeBtnCloseCallPrintingDC,
    ...getLoadingContentforSalesOrder,
    ...deleteDCDetailsCallOff,
    ...getLoadingDemandforSalesOrder,
    ...deleteWithStitchingDC,
    ...stitchingInwardDetailsDELETEAPI,
    ...deleteWithCuttingDC,
    ...deleteWithIroningPacking,
    ...deleteDCDetailsIroningCallOff,
    ...updateAllBtnCallGeneral,
    ...closeBtnCloseCallGeneral,
    ...deleteWithStitchingDCDelete,
    ...deleteWithIroningPackingDelete,
    ...costing,
    ...cashRequisition,
    ...directBilling,
    ...directBillingDetails,
    ...accountProperty,
    ...accountPropertyModalList,
    ...garmentsPo,
    ...garmentsPodetails,
    ...garmentsPoInwardHeader,
    ...garmentsPoInwardDetails,
    ...updateAllBtnCallGarment,
    ...yarnProjection,
    ...cuttingProgram,
    // ...accessoriesDemandPost,
    ...fabricProjection,
    ...compactingDivisionAuthorization,
    ...styleWiseReportAll,
    ...supplierWiseReport,
    ...compactingReport,
    // ...projectionReport,
    ...shippingPlan,
    ...shippingPlanDetails,
    ...fabricAndAccessoriesDemandPost,
    ...closeBillEntryReport,
    ...vendorManagementApi,
    ...verifiedBills,
    ...rnPendingReport,
    ...priceList,
    ...cuttingReport,
    ...productionReport,
    ...styleInProgress,
    ...dyeingDetails,
    ...requestForm,
    ...packingEntry,
    ...productStock,
    ...productDispatch,
    ...settings,
    ...auditTrial,
    ...fabricReports,
    ...moveToCutting,
    ...billReceiving,
    ...billReceivingReport,
    ...billReceivingVerify,
    ...programDiscount,
    ...articleMaster,
    ...warehouseStyle,
    ...warehouseStyleDetail,
    ...programWiseReportImages,
    ...customerPODetails,
    ...customerPoHeader,
    ...styleUpCharge,
    ...salesOrderReqAproval,
    ...costCenterReports,
    ...fabricroughCosting,
    ...stockReportCP
});
